{
  "update": {
    "available": "Une nouvelle version de Thiia est disponible.",
    "description": "Rechargez pour bénéficier des dernières améliorations.",
    "reload": "Recharger",
    "later": "Plus tard",
    "fromTo": "Mise à jour : {{from}} → {{to}}",
    "toOnly": "Nouvelle version : {{to}}",
    "fromOnly": "Version actuelle : {{from}}",
    "draftRestoredTitle": "Brouillon restauré",
    "draftRestoredDescription": "Vos champs ont été remis comme avant le rechargement ({{count}} champ).",
    "draftRestoredDescription_plural": "Vos champs ont été remis comme avant le rechargement ({{count}} champs)."
  },
  "rightPanel": {
    "ariaLabel": "Panneau latéral",
    "errorTitle": "Ce panneau n'a pas pu se charger",
    "errorGeneric": "Une erreur inattendue s'est produite.",
    "stuck": "Le chargement est plus long que prévu. Vérifiez votre connexion et réessayez.",
    "retry": "Réessayer",
    "copyDetails": "Copier les détails",
    "copied": "Copié",
    "close": "Fermer"
  },
  "common": {
    "loading": "Chargement…",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "search": "Rechercher",
    "searchPlaceholder": "Rechercher…",
    "language": "Langue",
    "french": "Français",
    "english": "Anglais",
    "settings": "Paramètres",
    "logout": "Déconnexion",
    "menu": "Menu",
    "more": "Plus",
    "documentation": "Documentation",
    "contactUs": "Nous contacter",
    "legal": "Mentions légales",
    "privacy": "Confidentialité",
    "terms": "Conditions d'utilisation",
    "all": "Tous",
    "showAll": "Tout afficher",
    "clear": "Effacer",
    "optional": "optionnel",
    "reset": "Réinitialiser",
    "export": "Exporter",
    "buy": "Acheter",
    "deselect": "Désélectionner",
    "noResults": "Aucun résultat",
    "confirmDeleteTitle": "Confirmer la suppression",
    "confirmDeleteDescription": "Cette action est irréversible. Voulez-vous vraiment continuer ?",
    "accept": "Accepter",
    "refuse": "Refuser",
    "learnMore": "En savoir plus",
    "apply": "Appliquer",
    "collapse": "Réduire",
    "create": "Créer",
    "error": "Erreur",
    "expand": "Développer",
    "filters": "Filtres",
    "locked": "Verrouillé",
    "pagination": {
      "perPage": "par page",
      "showing": "Affichage"
    },
    "security": "Sécurité",
    "switchToLanguage": "Passer en {{language}}",
    "retry": "Réessayer",
    "dismiss": "Ignorer",
    "actions": "Actions",
    "helpAndDocs": "Aide & documentation"
  },
  "offline": {
    "message": "Vous êtes hors connexion. Certaines fonctionnalités ne sont pas disponibles."
  },
  "cookies": {
    "message": "Nous utilisons des cookies pour <strong>l'authentification</strong>, la <strong>protection anti-robot (hCaptcha)</strong> et améliorer votre expérience. Aucun cookie publicitaire.",
    "acceptAll": "Tout accepter",
    "refuseOptional": "Refuser",
    "customize": "Personnaliser",
    "save": "Enregistrer mes choix",
    "preferences": {
      "title": "Préférences cookies",
      "description": "Choisissez les catégories de cookies que vous autorisez. Les cookies essentiels sont indispensables au fonctionnement du site.",
      "thirdParties": "Services tiers utilisés : Supabase (auth/données, UE), hCaptcha (anti-bot), Stripe (paiements), Resend (emails). Aucun cookie publicitaire."
    },
    "cat": {
      "essential": {
        "title": "Essentiels",
        "desc": "Authentification Supabase, session, équilibrage de charge. Toujours actifs."
      },
      "security": {
        "title": "Sécurité (anti-robot)",
        "desc": "hCaptcha — protège la création de comptes, la connexion et le mot de passe oublié contre les abus automatisés."
      },
      "functional": {
        "title": "Fonctionnels",
        "desc": "Mémorisation de la langue, état de la barre latérale, préférences d'affichage du chat et des emails."
      },
      "analytics": {
        "title": "Mesure d'audience",
        "desc": "Statistiques anonymisées d'usage des fonctionnalités IA (chat, recherche, génération de contenu) pour améliorer le produit."
      }
    }
  },
  "nav": {
    "dashboard": "Dashboard",
    "calendar": "Calendrier",
    "wellbeing": "Bien-être",
    "notifications": "Notifications",
    "search": "Recherche",
    "searchHub": "Prospection",
    "events": "Événements",
    "people": "Personnes",
    "emailAnalysis": "Analyse emails",
    "monitoring": "Suivi",
    "prospects": "Prospects",
    "clients": "Clients",
    "tasks": "Tâches",
    "communicate": "Communiquer",
    "emails": "Emails",
    "content": "Canaux digitaux",
    "chat": "Chat avec Thiia",
    "credits": "Crédits & Packs",
    "autoSearch": "Veille auto",
    "aiAssistant": "Assistant IA",
    "featureLockedTooltip": "La fonctionnalité « {{feature}} » n'est pas activée sur votre compte. Contactez votre administrateur.",
    "orgFilterTitle": "Filtrer par organisation",
    "orgFilterAll": "Toutes les organisations",
    "orgFilterActiveOne": "{{count}} organisation active",
    "orgFilterActiveOther": "{{count}} organisations actives",
    "orgFilterClear": "Tout désélectionner",
    "orgFilterEmpty": "Aucune organisation",
    "orgFilterSearchPlaceholder": "Rechercher une organisation…",
    "orgFilterNoResults": "Aucune organisation trouvée",
    "primaryMobile": "Navigation principale",
    "openChat": "Ouvrir le chat avec Thiia",
    "mobileMenuDescription": "Filtrez par organisation et naviguez dans l'application.",
    "drawerNavigation": "Sections de l'application",
    "account": "Compte",
    "unreadEmails": "non lus",
    "watch": "Veille",
    "receipts": "Justificatifs",
    "management": "Gestion"
  },
  "landing": {
    "navHome": "Accueil",
    "navUseCases": "Cas d'usage",
    "navPricing": "Tarif",
    "navContact": "Contact",
    "navDocs": "Documentation",
    "navLogin": "Se connecter",
    "navFeatures": "Fonctionnalités",
    "navSecurity": "Sécurité",
    "navTryFree": "Essayer gratuitement",
    "navTryShort": "Essayer",
    "navCreateAccount": "Créer mon compte",
    "navMenu": "Menu",
    "navOpenMenu": "Ouvrir le menu",
    "ctaTrial": "Essai gratuit",
    "heroBadge": "Propulsé par Mistral AI — IA française souveraine",
    "heroTitle1": "Votre copilote pour",
    "heroTitleAccent": "développer",
    "heroTitle2": "votre activité",
    "heroSubtitle": "Prospection, gestion de contacts, création de contenu et suivi client — tout réuni dans un seul outil intelligent conçu pour les entrepreneurs et indépendants.",
    "ctaStart": "Commencer gratuitement",
    "ctaDiscover": "Découvrir les fonctionnalités",
    "noCard": "Aucune carte bancaire requise · Essai gratuit inclus",
    "footerTagline": "Votre assistant IA pour la prospection B2B intelligente.",
    "footerProduct": "Produit",
    "footerFeatures": "Fonctionnalités",
    "footerPricing": "Tarifs",
    "footerHow": "Comment ça marche",
    "footerLegal": "Légal",
    "footerContact": "Contact",
    "footerCopyright": "Tous droits réservés.",
    "footerCreatedBy": "Créé par",
    "footerMadeIn": "— Fait avec ❤️ en France 🇫🇷",
    "statProsLabel": "Professionnels actifs",
    "statLeadsLabel": "Prospects gérés",
    "statSatLabel": "Satisfaction client",
    "statTimeLabel": "Gagnées par semaine",
    "sovBadge": "🇫🇷 IA Souveraine",
    "sovTitle1": "Une IA",
    "sovTitleAccent1": "100% française",
    "sovTitle2": ", vos données restent",
    "sovTitleAccent2": "en France",
    "sovSubtitle": "Thiia s'appuie sur **Mistral AI**, le leader français de l'intelligence artificielle. Aucune donnée ne quitte le territoire français.",
    "sovItem1Title": "Mistral AI",
    "sovItem1Desc": "Modèle IA développé en France par des chercheurs français, alternative souveraine aux géants américains.",
    "sovItem2Title": "Données privées",
    "sovItem2Desc": "Vos données ne sont jamais utilisées pour entraîner les modèles. Confidentialité totale garantie.",
    "sovItem3Title": "Hébergement français",
    "sovItem3Desc": "Infrastructure hébergée en France, conforme au RGPD et aux exigences de souveraineté numérique.",
    "integrationsBadge": "Intégrations",
    "integrationsTitle1": "Connecté à vos",
    "integrationsTitleAccent": "outils du quotidien",
    "integrationsSubtitle": "Synchronisez vos emails, agendas, visios, réseaux sociaux et CRM en un clic.",
    "featuresBadge": "Fonctionnalités",
    "featuresTitle1": "Tout ce dont vous avez besoin,",
    "featuresTitleAccent": "au même endroit",
    "featuresSubtitle": "Six modules puissants qui travaillent ensemble pour accélérer votre croissance.",
    "featuresUseCases": "Voir les cas d'usage par métier",
    "pillars": {
      "badge": "Ce que l'agent fait à votre place",
      "title": "Trois métiers, un seul endroit où demander",
      "exampleLabel": "Exemple réel",
      "allFeatures": "Toutes les fonctionnalités",
      "p1Kicker": "01 — Prospection",
      "p1Title": "Trouve les gens qui ont besoin de vous",
      "p1Body": "Le client décrit qui il cherche en français ; l'agent parcourt réseaux et signaux publics, qualifie, et ne remonte que les profils dont l'intention est datée.",
      "p1Credit": "1 recherche utilisée",
      "p1Ask": "Trouve-moi des personnes qui recherchent des missions de coaching",
      "p1Answer": "12 profils ont exprimé ce besoin ces 30 derniers jours. Le plus chaud : Claire M., DRH chez Novalis — deux publications sur la reconversion de ses équipes.",
      "p2Kicker": "02 — Relation client",
      "p2Title": "Écrit, relance, et n'oublie rien",
      "p2Body": "Chaque contact a son fil (ce qui a été dit, ce qui reste à faire, quand relancer) ; l'agent rédige, programme, et prévient quand une réponse arrive.",
      "p2Credit": "4 relances préparées",
      "p2Ask": "Relance mes devis sans réponse depuis deux semaines",
      "p2Answer": "Quatre devis concernés. J'ai préparé une relance par contact, calée sur votre dernier échange avec chacun. Je vous les montre avant envoi ?",
      "p3Kicker": "03 — Communication digitale",
      "p3Title": "Alimente vos réseaux sans y penser",
      "p3Body": "L'agent écrit à partir des missions, échanges et sujets existants ; une publication rédigée se décline sur les réseaux sans recompter de crédit.",
      "p3Credit": "1 publication utilisée",
      "p3Ask": "Écris mon post LinkedIn de la semaine",
      "p3Answer": "Basé sur la mission que vous avez livrée mardi. Angle retenu : ce que vous avez appris sur la résistance au changement. Trois versions, de sobre à assumée."
    },
    "feat1Title": "Assistant IA conversationnel",
    "feat1Desc": "Un copilote intelligent qui rédige emails, rapports et stratégies de prospection. Chat collaboratif en temps réel avec vos équipes.",
    "feat2Title": "CRM & Pipeline prospects",
    "feat2Desc": "Pipeline Kanban visuel, fiches détaillées, notes vocales, relations entre contacts et suivi complet du parcours client.",
    "feat3Title": "Recherche intelligente de contacts",
    "feat3Desc": "Trouvez et qualifiez des prospects via Perplexity AI. Analyse sémantique de l'activité en ligne et scoring automatique.",
    "feat4Title": "Veille automatique",
    "feat4Desc": "Programmez des recherches récurrentes (quotidiennes, hebdomadaires). Thiia vous alerte quand de nouveaux prospects correspondent à vos critères.",
    "feat5Title": "Calendrier & Événements",
    "feat5Desc": "Synchronisation Google Calendar et Outlook. Gestion d'événements avec inscriptions, QR codes et rappels automatiques.",
    "feat6Title": "Client email intégré",
    "feat6Desc": "Gmail et Outlook intégrés. Lecture, réponse et envoi depuis Thiia avec détection automatique de prospects dans vos échanges.",
    "feat7Title": "Création de contenu",
    "feat7Desc": "Posts LinkedIn, newsletters, articles de blog avec éditeur riche. Calendrier éditorial et publication directe sur LinkedIn.",
    "feat8Title": "Emails & Séquences automatisées",
    "feat8Desc": "Modèles personnalisables, séquences de relance programmées, envoi groupé et pièces jointes PDF générées automatiquement.",
    "feat9Title": "Listes de tâches",
    "feat9Desc": "Checklists liées à vos prospects ou projets avec rappels automatiques et suivi de progression.",
    "feat10Title": "Bien-être & Anti-burnout",
    "feat10Desc": "Check-in quotidien, suivi de votre énergie et conseils personnalisés pour préserver votre équilibre professionnel.",
    "feat11Title": "Intégrations Zoom & Teams",
    "feat11Desc": "Import des enregistrements et transcriptions de vos visioconférences directement dans les fiches prospects.",
    "feat12Title": "Application installable (PWA)",
    "feat12Desc": "Installez Thiia sur votre téléphone ou ordinateur. Accès offline aux données récemment consultées, même sans connexion.",
    "feat13Title": "Annotations collaboratives",
    "feat13Desc": "Surlignez les réponses de Thiia, ajoutez des commentaires et résolvez les fils de discussion. Idéal pour travailler en équipe sur une analyse.",
    "feat14Title": "Bibliothèque documentaire IA",
    "feat14Desc": "Centralisez factures, contrats et comptes-rendus par prospect. Indexation automatique pour une recherche sémantique instantanée depuis le chat.",
    "feat15Title": "Imports cloud (Drive, OneDrive, Dropbox)",
    "feat15Desc": "Connectez Google Drive, OneDrive et Dropbox. Importez vos documents existants en deux clics, sans quitter Thiia.",
    "benefitsBadge": "Avantages",
    "benefitsTitle1": "Pourquoi les indépendants",
    "benefitsTitleAccent": "nous choisissent",
    "ben1Title": "Gagnez 10h par semaine",
    "ben1Desc": "Automatisez les tâches répétitives et concentrez-vous sur ce qui compte : vos clients.",
    "ben2Title": "Convertissez plus de prospects",
    "ben2Desc": "Un pipeline structuré et des relances intelligentes augmentent votre taux de conversion.",
    "ben3Title": "Lancez-vous en 5 minutes",
    "ben3Desc": "Interface intuitive, zéro configuration technique. Opérationnel dès le premier jour.",
    "ben4Title": "IA française & données en France",
    "ben4Desc": "Thiia repose sur Mistral, l'IA souveraine française. Vos données restent en France, privées et sécurisées, conformes au RGPD.",
    "howBadge": "Comment ça marche",
    "howTitle1": "Opérationnel en",
    "howTitleAccent": "3 étapes",
    "step1Title": "Créez votre compte",
    "step1Desc": "Inscrivez-vous gratuitement et configurez votre profil professionnel en quelques clics.",
    "step2Title": "Importez ou trouvez vos prospects",
    "step2Desc": "Ajoutez vos contacts existants ou utilisez notre moteur de recherche pour découvrir de nouveaux leads.",
    "step3Title": "Laissez l'IA travailler pour vous",
    "step3Desc": "L'assistant génère vos emails, analyse vos prospects et vous recommande les meilleures actions à mener.",
    "testimonialsBadge": "Témoignages",
    "testimonialsTitle": "Ils ont transformé leur activité",
    "test1Name": "Sophie M.",
    "test1Role": "Coach en leadership",
    "test1Quote": "J'ai doublé mon nombre de prospects qualifiés en 3 mois. L'assistant IA me fait gagner un temps fou sur la rédaction.",
    "test2Name": "Thomas D.",
    "test2Role": "Consultant indépendant",
    "test2Quote": "Enfin un outil tout-en-un qui comprend les besoins des indépendants. Fini les 10 applications différentes !",
    "test3Name": "Marie L.",
    "test3Role": "Formatrice en développement personnel",
    "test3Quote": "La gestion des événements et le suivi des participants ont transformé mon activité. Je recommande à 100%.",
    "finalCtaTitle": "Prêt à accélérer votre croissance ?",
    "finalCtaSubtitle": "Rejoignez des centaines de professionnels qui utilisent Thiia pour développer leur activité plus rapidement.",
    "finalCtaButton": "Démarrer maintenant",
    "finalCtaTag1": "Essai gratuit",
    "finalCtaTag2": "Sans engagement",
    "finalCtaTag3": "Support réactif"
  },
  "dashboard": {
    "greeting": "Bonjour",
    "subtitle": "Voici un aperçu de votre activité.",
    "stats": {
      "prospects": "Prospects",
      "events": "Événements",
      "published": "Publiés",
      "content": "Contenus"
    },
    "credits": {
      "title": "Crédits disponibles",
      "buy": "Acheter"
    },
    "quotaLabels": {
      "chat": "Chat",
      "report": "CR",
      "audio": "Audio",
      "posts": "Posts",
      "newsletter": "NL",
      "search": "Rech.",
      "analysis": "Analyse",
      "checklist": "Check"
    },
    "recommendations": {
      "title": "Actions recommandées",
      "empty": "Ajoutez des prospects ou événements pour recevoir des recommandations.",
      "priorityHigh": "Urgent",
      "priorityMedium": "Important",
      "priorityLow": "Conseil"
    },
    "pipeline": {
      "title": "Pipeline",
      "nouveau": "Nouveau",
      "contacte": "Contacté",
      "en_discussion": "En discussion",
      "converti": "Converti",
      "perdu": "Perdu"
    },
    "priorityToday": "Priorité du jour",
    "activeProspects": "prospects actifs",
    "thisWeek": "cette semaine",
    "todayAgenda": "Agenda du jour",
    "noEventToday": "Aucun rendez-vous aujourd'hui.",
    "contextLine": "{{events}} rendez-vous, {{emails}} emails non lus",
    "todayActions": "Vos actions du jour",
    "upcomingMeetings": "Prochains rendez-vous",
    "followUp": "Suivi",
    "moreTracking": "Plus de suivi",
    "prospectsTrend": "Évolution prospects",
    "recentProspects": "Prospects récents",
    "noProspect": "Aucun prospect.",
    "noUpcomingEvent": "Aucun événement à venir.",
    "period": {
      "week": "Cette semaine",
      "month": "Ce mois-ci",
      "all": "Tout"
    },
    "tiles": {
      "activeProspects": "Prospects actifs",
      "sentEmails": "Emails envoyés",
      "publishedContent": "Contenus publiés",
      "overdueTasks": "Tâches en retard",
      "newInPeriod": "{{count}} nouveaux",
      "toProcess": "à traiter"
    }
  },
  "prospects": {
    "documents": {
      "uploadTitle": "Téléverser un document",
      "uploadFailed": "Échec du téléversement",
      "uploadedTitle": "Document téléversé",
      "uploadedDesc": "L'indexation démarre en arrière-plan.",
      "tooLargeTitle": "Fichier trop volumineux",
      "tooLargeDesc": "La taille maximale est de 200 Mo.",
      "dropHere": "Glissez un fichier ici ou cliquez pour parcourir",
      "maxSize": "PDF, Word, PowerPoint, Excel, TXT, MD, images — 200 Mo max",
      "type": "Type",
      "year": "Année",
      "upload": "Téléverser",
      "creditsLeft": "{{count}} crédits",
      "searchTitle": "Recherche dans les documents",
      "searchPlaceholder": "Recherche sémantique…",
      "searching": "Recherche en cours…",
      "noResults": "Aucun résultat",
      "searchError": "Erreur de recherche",
      "empty": "Aucun document pour ce prospect.",
      "confirmDelete": "Supprimer définitivement « {{name}} » ?",
      "deletedTitle": "Document supprimé",
      "download": "Télécharger",
      "reindex": "Relancer l'indexation",
      "statusPending": "En attente",
      "statusProcessing": "Indexation…",
      "statusIndexed": "Indexé",
      "statusFailed": "Échec",
      "statusNoText": "Pas de texte",
      "statusQuotaExhausted": "Crédits épuisés",
      "types": {
        "facture": "Factures",
        "devis": "Devis",
        "proposition": "Propositions",
        "cahier_charges": "Cahiers des charges",
        "bon_commande": "Bons de commande",
        "contrat": "Contrats",
        "avenant": "Avenants",
        "nda": "NDA / Confidentialité",
        "cr_reunion": "CR de réunion",
        "brief": "Briefs",
        "presentation": "Présentations",
        "rapport": "Rapports",
        "etude_cas": "Études de cas",
        "autre": "Autres"
      }
    },
    "title": "Prospects",
    "count_one": "{{count}} prospect",
    "count_other": "{{count}} prospects",
    "tabs": {
      "pipeline": "Pipeline",
      "list": "Liste",
      "emails": "Emails"
    },
    "searchPlaceholder": "Rechercher par nom, email, entreprise, tag…",
    "empty": "Aucun prospect pour le moment.",
    "swipeHint": "← Swipez pour changer le statut →",
    "statusUpdated": "Statut mis à jour",
    "statusUpdatedTo": "→ {{label}}",
    "selected_one": "{{count}} prospect sélectionné",
    "selected_other": "{{count}} prospects sélectionnés",
    "deletePrompt_one": "Supprimer {{count}} prospect ?",
    "deletePrompt_other": "Supprimer {{count}} prospects ?",
    "deleteDescription": "Cette action est irréversible. Les prospects sélectionnés et leurs données associées seront définitivement supprimés.",
    "deleted_one": "{{count}} prospect supprimé",
    "deleted_other": "{{count}} prospects supprimés",
    "bulkAssignOrg": {
      "button_one": "Attacher à une org. ({{count}})",
      "button_other": "Attacher à une org. ({{count}})",
      "title_one": "Attacher {{count}} prospect à des organisations",
      "title_other": "Attacher {{count}} prospects à des organisations",
      "description": "Sélectionnez une ou plusieurs organisations à associer aux prospects choisis.",
      "noOrganization": "Aucune organisation. Créez-en une dans les paramètres.",
      "strategy": "Stratégie",
      "addLabel": "Ajouter aux existantes",
      "addHint": "Les organisations cochées s'ajoutent à celles déjà liées.",
      "replaceLabel": "Remplacer les existantes",
      "replaceHint": "Les liens existants sont supprimés et remplacés par votre sélection.",
      "confirm": "Attacher",
      "selectAtLeastOne": "Sélectionnez au moins une organisation",
      "success_one": "{{count}} prospect rattaché à {{orgs}} organisation(s)",
      "success_other": "{{count}} prospects rattachés à {{orgs}} organisation(s)",
      "addedDescription": "{{created}} nouveau(x) lien(s) créé(s).",
      "replacedDescription": "Liens remplacés. {{created}} lien(s) actif(s).",
      "button": "Assigner à une organisation",
      "success": "Prospects assignés",
      "title": "Assigner les prospects"
    },
    "addProspect": "Ajouter un prospect",
    "newProspect": "Nouveau prospect",
    "scanCard": "Scanner une carte",
    "analyzing": "Analyse…",
    "orPasteLinkedIn": "ou collez un lien LinkedIn ci-dessous",
    "fill": "Remplir",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "company": "Entreprise",
    "jobTitle": "Poste",
    "source": "Source",
    "meetingContext": "Contexte de rencontre",
    "meetingContextPlaceholder": "Ex : Salon Tech Paris 2026, présenté par Marie…",
    "meetingContextSelectEvent": "Sélectionner un événement…",
    "meetingContextSearchEvent": "Rechercher un événement…",
    "meetingContextNoEvent": "Aucun événement trouvé.",
    "meetingContextFreeText": "Saisie libre",
    "meetingContextPickEvent": "Choisir un événement",
    "notes": "Notes",
    "adding": "Ajout…",
    "addProspectAction": "Ajouter le prospect",
    "selectImage": "Veuillez sélectionner une image",
    "imageTooLarge": "Image trop volumineuse (max 10 Mo)",
    "cardAnalyzed": "Carte de visite analysée avec succès",
    "cardAnalysisError": "Erreur lors de l'analyse de la carte de visite",
    "validLinkedInRequired": "Veuillez entrer un lien LinkedIn valide",
    "linkedinEnriched": "Profil LinkedIn enrichi avec succès",
    "linkedinEnrichError": "Erreur lors de l'enrichissement LinkedIn",
    "filters": "Filtres",
    "filtersTrigger": "Ouvrir les filtres prospects",
    "clearFilters": "Effacer les filtres",
    "reset": "Réinitialiser",
    "selectedCount": "{{count}} {{label}} sélectionné(s)",
    "filterByStatus": "Filtrer les prospects par statut",
    "status": "Statut",
    "type": "Type",
    "typeIndividual": "Individu",
    "typeOrganization": "Organisation",
    "organizationName": "Nom de l'organisation",
    "organizationNamePlaceholder": "Ex : Acme SAS",
    "attachToOrganization": "Rattacher à une organisation",
    "noOrganization": "Aucune organisation",
    "tags": "Tags",
    "relations": "Relations",
    "allTypes": "Tous types",
    "linkedTo": "Liés à {{name}}",
    "searchProspect": "Chercher un prospect…",
    "whatsappOptOut": "Opt-out WhatsApp",
    "whatsappOptOutOnly": "Uniquement opt-out",
    "exportExcel": "Export Excel",
    "results_one": "{{count}} résultat",
    "results_other": "{{count}} résultats",
    "sortDate": "Date d'ajout",
    "sortName": "Nom A→Z",
    "sortSource": "Par source",
    "sortStatus": "Par statut",
    "sortRelation": "Par relations",
    "qrCode": "QR Code",
    "qrCodeTitle": "QR Code de contact",
    "qrCodeDescription": "Présentez ce QR code lors de vos événements. Vos contacts pourront remplir leurs coordonnées directement.",
    "linkCopied": "Lien copié !",
    "copied": "Copié",
    "copyLink": "Copier le lien",
    "download": "Télécharger",
    "selectAll": "Tout sélectionner",
    "selectProspect": "Sélectionner {{name}}",
    "name": "Nom",
    "addedOn": "Ajouté le",
    "noProspect": "Aucun prospect pour le moment.",
    "analyzed": "Analysé",
    "relationCount": "{{count}} relation(s)",
    "noRelation": "Sans relation",
    "doubleClickRename": "Double-clic pour renommer",
    "validateEscCancel": "↵ valider · Echap annuler",
    "sendAiEmail": "Envoyer un email IA",
    "relationTypes": {
      "collegue": "Collègue",
      "manager": "Manager",
      "collaborateur": "Collaborateur",
      "conjoint": "Conjoint(e)",
      "recommande_par": "Recommandé par",
      "meme_entreprise": "Même entreprise",
      "partenaire": "Partenaire",
      "ami": "Ami(e)",
      "autre": "Autre"
    },
    "statusLabels": {
      "nouveau": "Nouveau",
      "contacte": "Contacté",
      "en_discussion": "En discussion",
      "converti": "Converti",
      "perdu": "Perdu"
    },
    "sourceLabels": {
      "gmail": "Gmail",
      "outlook": "Outlook",
      "web": "Web",
      "evenement": "Événement",
      "qr": "QR Code",
      "email": "Email",
      "reseaux_sociaux": "Réseaux sociaux",
      "import": "Import",
      "manuel": "Manuel",
      "recherche_ia": "Recherche IA",
      "chat_ia": "Chat IA"
    },
    "contactTypes": {
      "prospect": "Prospect",
      "client": "Client",
      "partenaire": "Partenaire"
    },
    "detail": {
      "tabFiche": "Fiche",
      "tabActivity": "Activité",
      "tabDocuments": "Documents",
      "changeStatus": "Changer le statut",
      "tags": "Tags",
      "noTag": "Aucun tag",
      "addTagPlaceholder": "Ajouter un tag…",
      "linkedEvents": "Événements liés",
      "registered": "Inscrit",
      "bio": "Bio",
      "companyDescription": "Description entreprise",
      "foundedIn": "Fondée en {{year}}",
      "onlineActivity": "Analyse d'activité en ligne",
      "interestThemes": "Thèmes d'intérêt",
      "publishedArticles": "Articles publiés",
      "personalSite": "Site personnel",
      "linkedinActivity": "Activité LinkedIn",
      "sources": "Sources",
      "linkedinProfile": "Profil LinkedIn",
      "addedOn": "Ajouté le {{date}}",
      "notes": "Notes",
      "notesPlaceholder": "Ajoutez des notes sur ce prospect…",
      "sentEmails": "Emails envoyés ({{count}})",
      "noSubject": "Sans objet",
      "writeAiEmail": "Rédiger un email avec l'IA",
      "deleteProspect": "Supprimer ce prospect",
      "deleteTitle": "Supprimer ce prospect ?",
      "deleteDescription": "{{name}} sera définitivement supprimé, ainsi que ses emails et inscriptions liés. Cette action est irréversible.",
      "viewExchangesIn": "Voir les échanges dans {{provider}}",
      "call": "Appeler"
    },
    "analyses": {
      "label": "Analyses d'activité",
      "exportPdf": "PDF",
      "compare": "Comparer",
      "selected": "Sélectionnée",
      "analyze": "Analyser",
      "reanalyze": "Réanalyser",
      "running": "Analyse en cours via Perplexity AI…",
      "empty": "Aucune analyse. Cliquez sur « Analyser » pour lancer une analyse d'activité en ligne.",
      "analysisOf": "Analyse du {{date}}",
      "themesCount": "{{count}} thèmes",
      "comparison": "Comparaison",
      "older": "Ancienne",
      "recent": "Récente",
      "interestEvolution": "Évolution des centres d'intérêt",
      "new": "Nouveau",
      "removed": "Disparu",
      "stable": "Stable",
      "oldSummary": "Ancien résumé",
      "newSummary": "Nouveau résumé",
      "interestThemes": "Thèmes d'intérêt",
      "icebreakers": "Points d'accroche",
      "recentPosts": "Publications récentes",
      "linkedinActivity": "Activité LinkedIn",
      "personalSite": "Site personnel",
      "sources": "Sources",
      "deleteTitle": "Supprimer cette analyse ?",
      "deleteDescription": "L'analyse sera définitivement supprimée.",
      "delete": "Supprimer",
      "deleted": "Analyse supprimée",
      "errorPrefix": "Erreur : ",
      "savedToast": "Analyse terminée et sauvegardée !",
      "exportError": "Erreur lors de l'export PDF"
    },
    "reports": {
      "label": "Comptes-rendus",
      "generateAi": "Générer IA",
      "add": "Ajouter",
      "titlePlaceholder": "Titre du compte-rendu…",
      "contentPlaceholder": "Contenu…",
      "stop": "Arrêter",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saved": "Compte-rendu mis à jour",
      "added": "Compte-rendu ajouté",
      "deleted": "Compte-rendu supprimé",
      "empty": "Aucun compte-rendu",
      "noContent": "Aucun contenu",
      "send": "Envoyer",
      "pdf": "PDF",
      "edit": "Modifier",
      "saveEdit": "Sauvegarder",
      "deleteTitle": "Supprimer ce rapport ?",
      "deleteDescription": "Le rapport sera définitivement supprimé.",
      "noEmail": "Ce prospect n'a pas d'adresse email",
      "untitled": "Sans titre",
      "analyzing": "Analyse des données du prospect…",
      "generated": "Compte-rendu généré !",
      "generateError": "Erreur lors de la génération",
      "noContentGenerated": "Aucun contenu généré",
      "sendByEmailTitle": "Envoyer le compte-rendu par email",
      "recipient": "Destinataire",
      "subject": "Objet",
      "content": "Contenu",
      "attachPdf": "Joindre le compte-rendu en PDF",
      "sentTo": "Compte-rendu envoyé à {{email}}",
      "sendError": "Erreur lors de l'envoi",
      "pdfError": "Erreur lors de la génération du PDF",
      "defaultTitle": "Compte-rendu – {{date}}",
      "aiConfig": {
        "estimatedCost": "Coût estimé",
        "generate": "Générer le rapport",
        "howCalculated": "Comment est calculé le coût ?",
        "language": "Langue",
        "model": "Modèle IA",
        "title": "Configuration IA"
      }
    },
    "swipeCard": {
      "analyzed": "Analysé",
      "relations": "{{count}} relation(s)"
    },
    "emailDialog": {
      "title": "Email personnalisé — {{name}}",
      "objectiveLabel": "Objectif de l'email",
      "templates": "Modèles ({{count}})",
      "savedTemplates": "Modèles sauvegardés",
      "noTemplates": "Aucun modèle sauvegardé. Générez un email puis sauvegardez-le !",
      "noSubject": "Sans objet",
      "objectives": {
        "prise_contact": "Prise de contact",
        "proposition": "Proposer un service",
        "relance": "Relance",
        "invitation": "Invitation à un événement",
        "suivi": "Suivi après échange",
        "custom": "Personnalisé…"
      },
      "vars": {
        "prenom": "Prénom",
        "nom": "Nom",
        "nom_complet": "Nom complet",
        "entreprise": "Entreprise",
        "poste": "Poste",
        "email": "Email"
      },
      "customObjectivePlaceholder": "Décrivez l'objectif de votre email…",
      "generating": "Génération en cours…",
      "regenerate": "Régénérer",
      "generate": "Générer l'email avec l'IA",
      "subject": "Objet",
      "subjectPlaceholder": "Objet de l'email…",
      "body": "Corps de l'email",
      "edit": "Éditer",
      "preview": "Aperçu",
      "variable": "Variable",
      "bodyPlaceholder": "Le contenu de l'email apparaîtra ici…",
      "templateNamePlaceholder": "Nom du modèle…",
      "save": "Sauver",
      "saveAsTemplate": "Sauvegarder comme modèle",
      "addSignature": "Ajouter la signature",
      "cancel": "Annuler",
      "modify": "Modifier",
      "create": "Créer",
      "signaturePlaceholder": "Ex:\nJean Dupont\nCoach Business\n06 12 34 56 78\nwww.monsite.fr",
      "saveSignature": "Enregistrer",
      "noSignature": "Aucune signature configurée. Cliquez sur \"Créer\" pour en ajouter une.",
      "noEmailWarning": "⚠️ Ce prospect n'a pas d'adresse email. L'envoi ne sera pas possible.",
      "scheduleSend": "Programmer l'envoi",
      "pickDate": "Choisir une date",
      "schedule": "Programmer",
      "send": "Envoyer",
      "to": "À :",
      "subjectColon": "Objet :",
      "previewNoSubject": "(sans objet)",
      "sentVia": "Envoyé via Thiia",
      "errors": {
        "generation": "Erreur lors de la génération",
        "generationGeneric": "Impossible de générer l'email",
        "noProspectEmail": "Ce prospect n'a pas d'adresse email",
        "subjectAndBodyRequired": "L'objet et le corps de l'email sont requis",
        "sendFailed": "Erreur d'envoi",
        "sendGeneric": "Impossible d'envoyer l'email",
        "fillAllFields": "Veuillez remplir tous les champs et choisir une date",
        "futureDateRequired": "La date programmée doit être dans le futur",
        "scheduleFailed": "Impossible de programmer l'email",
        "saveFailed": "Erreur lors de la sauvegarde",
        "generationEmpty": "La génération est vide."
      },
      "toasts": {
        "emailSent": "Email envoyé à {{name}} !",
        "emailScheduled": "Email programmé pour le {{date}}",
        "templateSaved": "Modèle sauvegardé !",
        "templateLoaded": "Modèle « {{name}} » chargé — variables remplacées",
        "templateDeleted": "Modèle supprimé",
        "signatureSaved": "Signature enregistrée",
        "generationCancelled": "Génération annulée",
        "generationSuccess": "E-mail généré avec succès"
      },
      "defaultRelance": {
        "subject": "Suivi de notre échange, {{prenom}}",
        "body": "Bonjour {{prenom}},\n\nJ'espère que vous allez bien. Je me permets de revenir vers vous suite à notre dernier échange.\n\nJe serais ravi(e) de savoir si vous avez eu le temps de réfléchir à notre discussion et si je peux vous apporter des informations complémentaires.\n\nN'hésitez pas à me faire signe si vous souhaitez en discuter.\n\nBien cordialement"
      },
      "customObjectiveRequired": "Veuillez décrire votre objectif.",
      "draft": {
        "autosaveLabel": "Sauvegarde auto",
        "autosavedAt": "Enregistré à {{time}}",
        "delete": "Supprimer le brouillon",
        "empty": "Aucun brouillon",
        "emptyError": "Le brouillon est vide.",
        "hint": "Vos brouillons sont enregistrés automatiquement.",
        "history": "Historique des brouillons",
        "listLabel": "Brouillons",
        "manageTitle": "Gérer les brouillons",
        "nameLabel": "Nom du brouillon",
        "openList": "Ouvrir la liste",
        "restore": "Restaurer",
        "restorePrompt": "Restaurer ce brouillon ?",
        "restorePromptMany": "Restaurer ces brouillons ?",
        "restoreVersion": "Restaurer cette version",
        "restored": "Brouillon restauré",
        "save": "Enregistrer",
        "saveAction": "Enregistrer le brouillon",
        "saveError": "Impossible d'enregistrer le brouillon.",
        "saved": "Brouillon enregistré",
        "versionRestored": "Version restaurée",
        "versionsLabel": "Versions"
      },
      "newTemplate": "Nouveau modèle",
      "updateTemplate": "Mettre à jour le modèle"
    },
    "notesUi": {
      "header": "Notes",
      "stop": "Stop",
      "uploading": "Envoi…",
      "recordVoice": "Enregistrer une note vocale",
      "importTeams": "Importer une transcription Teams",
      "importZoom": "Importer un enregistrement Zoom",
      "add": "Ajouter",
      "writePlaceholder": "Écrire une note…",
      "attachLabel": "Joindre",
      "uploadingFile": "Envoi fichier {{current}}/{{total}}…",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "empty": "Aucune note pour le moment",
      "modified": "(modifié)",
      "preview": "Aperçu & Export",
      "sendByEmailPdf": "Envoyer par email avec PDF",
      "reopenDraft": "Rouvrir le brouillon de compte-rendu",
      "draft": "Brouillon",
      "createAiReport": "Créer un compte-rendu IA",
      "transcription": "Transcription",
      "transcribe": "Transcrire",
      "voiceSaved": "Note vocale enregistrée",
      "voiceDeleted": "Note vocale supprimée",
      "noteDeleted": "Note supprimée",
      "transcriptionDone": "Transcription terminée",
      "transcriptionError": "Erreur de transcription",
      "uploadError": "Erreur d'upload",
      "noProspectEmail": "Aucune adresse email pour ce prospect",
      "noteSentTo": "Note envoyée à {{email}}",
      "sendError": "Erreur lors de l'envoi",
      "micError": "Impossible d'accéder au microphone",
      "fileTooLarge": "{{name}} trop volumineux (max 200 Mo)",
      "transcriptionOf": "Transcription de {{name}} terminée",
      "transcriptionErrorOf": "Erreur transcription {{name}}",
      "uploadErrorOf": "Erreur upload {{name}}",
      "networkErrorOf": "Erreur réseau pour {{name}}",
      "reportFinalized": "Compte-rendu finalisé et ajouté à la note",
      "office365Expired": "Connexion Office 365 expirée",
      "zoomExpired": "Connexion Zoom expirée",
      "reconnectHint": "Rendez-vous dans Paramètres > Intégrations pour reconnecter votre compte.",
      "importError": "Erreur lors de l'import",
      "copy": "Copier",
      "copied": "Copié !",
      "reportSeparator": "## 📋 Compte-rendu – {{date}}",
      "noteEmailSubject": "Note – {{name}} – {{date}}",
      "teamsTranscriptHeader": "## 🎥 Transcription Teams – {{title}}",
      "zoomTranscriptHeader": "## 🎥 Transcription Zoom – {{title}}",
      "prospectFallback": "Prospect",
      "cancelTranscription": "Annuler la transcription",
      "transcriptionCancelled": "Transcription annulée",
      "voiceNotesTitle": "Notes vocales",
      "recordShort": "Enregistrer",
      "attachToNote": "Ajouter des fichiers à cette note",
      "filesAttached": "{{count}} fichier(s) ajouté(s) à la note",
      "removeAttachment": "Retirer la pièce jointe",
      "attachmentRemoved": "Pièce jointe supprimée",
      "transcriptionFailedHttp": "Échec de la transcription (HTTP {{status}})"
    },
    "timeline": {
      "voiceNote": "Note vocale",
      "emailSent": "Email envoyé",
      "emailReceived": "Email reçu",
      "registration": "Inscription",
      "report": "Compte-rendu",
      "activity": "Activité",
      "noSubject": "Sans objet",
      "event": "Événement",
      "empty": "Aucune activité enregistrée",
      "noEmailAddress": "Ce prospect n'a pas d'adresse email renseignée",
      "noEmailAddressHelp": "Ajoutez une adresse email au prospect pour afficher les échanges.",
      "noEmailAccount": "Aucun compte email connecté",
      "noEmailAccountHelp": "Connectez votre compte Gmail ou Outlook pour afficher les emails échangés avec ce prospect.",
      "connectionSettings": "Paramètres de connexion",
      "play": "Écouter",
      "pause": "Pause",
      "emailOpened": "Email ouvert",
      "emailClicked": "Lien cliqué",
      "dateFormat": "d MMM yyyy · HH:mm",
      "openInEmails": "Ouvrir dans les e-mails",
      "reply": "Répondre"
    },
    "relationsUi": {
      "header": "Relations ({{count}})",
      "addRelation": "Ajouter une relation",
      "searchPlaceholder": "Rechercher un prospect…",
      "labelPlaceholder": "Nom de la relation (ex: Co-fondateur)",
      "notePlaceholder": "Note (optionnel)",
      "cancel": "Annuler",
      "add": "Ajouter",
      "alreadyExists": "Cette relation existe déjà",
      "addError": "Erreur lors de l'ajout",
      "added": "Relation ajoutée",
      "deleted": "Relation supprimée",
      "types": {
        "collegue": "Collègue",
        "manager": "Manager",
        "collaborateur": "Collaborateur",
        "conjoint": "Conjoint(e)",
        "recommande_par": "Recommandé par",
        "meme_entreprise": "Même entreprise",
        "partenaire": "Partenaire",
        "ami": "Ami(e)",
        "autre": "Autre"
      }
    },
    "aiIndexedDesc": "Vos prospects ont été indexés pour la recherche IA.",
    "aiIndexedTitle": "Indexation IA terminée",
    "aiSearchOff": "Recherche IA désactivée",
    "aiSearchOn": "Recherche IA activée",
    "aiSearchPlaceholder": "Rechercher avec l'IA…",
    "autocomplete": {
      "companies": "Entreprises",
      "organizations": "Organisations",
      "prospects": "Prospects"
    },
    "createOrgNamed": "Créer l'organisation « {{name}} »",
    "deletePrompt": "Supprimer ce prospect ?",
    "deleted": "Prospect supprimé",
    "duplicateByName": "Doublon par nom",
    "duplicateFoundDesc": "Un prospect similaire existe déjà.",
    "duplicateFoundMatchedBy": "Trouvé par : {{field}}",
    "duplicateFoundTitle": "Doublon détecté",
    "goToExistingProspect": "Aller au prospect existant",
    "loadingMore": "Chargement…",
    "organizationAlreadyExists": "Cette organisation existe déjà",
    "organizationCreated": "Organisation créée",
    "refresh": "Actualiser",
    "refreshed": "Prospects actualisés",
    "searchOrCreateOrg": "Rechercher ou créer une organisation",
    "selected": "{{count}} sélectionnés",
    "sheet": {
      "viewExchangesIn": "Voir les échanges dans"
    },
    "sortBy": "Trier par",
    "willAttachToOrg": "Sera rattaché à l'organisation « {{name}} »",
    "insights": {
      "title": "Analyse de la base",
      "byStatus": "Par statut",
      "byKind": "Individus vs Organisations",
      "bySource": "Sources d'acquisition",
      "bySize": "Taille d'entreprise",
      "bySector": "Secteurs",
      "topTags": "Tags les plus utilisés",
      "weekly": "Ajouts (12 sem.)",
      "noSector": "Enrichissez vos fiches organisation pour voir les secteurs.",
      "individuals": "Individus",
      "organizations": "Organisations",
      "kpi": {
        "total": "Total",
        "mix": "Individus / Orgs",
        "analyzed": "Analysés IA",
        "newWeek": "Cette semaine"
      },
      "export": {
        "xlsx": "Excel (.xlsx)",
        "csv": "CSV (.csv)"
      },
      "sources": {
        "web": "Web",
        "evenement": "Événement",
        "qr": "QR code",
        "email": "Email",
        "reseaux_sociaux": "Réseaux sociaux",
        "import": "Import",
        "manuel": "Manuel",
        "gmail": "Gmail",
        "outlook": "Outlook",
        "recherche_ia": "Recherche IA",
        "chat_ia": "Chat IA",
        "unknown": "Inconnu"
      },
      "noMatch": "Aucun prospect ne correspond à ces filtres.",
      "filters": {
        "status": "Statut",
        "source": "Source",
        "sector": "Secteur",
        "matching": "{{n}} résultats",
        "noSource": "Aucune source",
        "periods": {
          "all": "Depuis toujours",
          "7d": "7 derniers jours",
          "30d": "30 derniers jours",
          "90d": "90 derniers jours",
          "12m": "12 derniers mois"
        }
      },
      "error": "Impossible de charger les insights",
      "bulkAnalyze": {
        "button": "Analyser {{n}} prospect(s)",
        "buttonAll": "Ré-analyser",
        "tooltip": "Analyse IA (Perplexity) — 1 crédit / prospect",
        "tooltipAll": "Tous vos prospects sont déjà analysés. Vous pouvez les rafraîchir.",
        "title": "Analyser mes prospects",
        "description": "L'IA récupère l'activité récente, les centres d'intérêt et les points d'accroche pour chaque prospect. Chaque analyse consomme 1 crédit du quota « Analyses ».",
        "toAnalyze": "Prospects à analyser",
        "cost": "Coût total",
        "credits": "{{n}} crédit(s)",
        "available": "Quota disponible",
        "after": "Solde après analyse",
        "reanalyze": "Ré-analyser aussi les prospects déjà analysés",
        "missing": "Il vous manque {{n}} crédit(s) d'analyse.",
        "rechargeHint": "Rechargez votre quota pour analyser toute votre base, ou lancez seulement ce que votre solde permet.",
        "recharge": "Recharger mon quota",
        "launch": "Lancer l'analyse",
        "launchPartial": "Analyser {{n}} prospect(s)",
        "running": "Analyse en cours…",
        "stopped": "Batch interrompu (quota épuisé côté serveur).",
        "quotaExhausted": "Quota d'analyses épuisé, batch interrompu.",
        "doneOk": "{{n}} prospect(s) analysés avec succès.",
        "donePartial": "{{ok}} analysés, {{err}} en erreur.",
        "doneAllFail": "Aucun prospect n'a pu être analysé ({{err}} erreurs)."
      },
      "analysisCharts": {
        "title": "Insights d'analyse IA",
        "basedOn": "sur {{n}} analysés",
        "avgInterests": "{{n}} centres d'intérêt moyens",
        "topInterests": "Centres d'intérêt les plus fréquents",
        "noInterests": "Aucun centre d'intérêt identifié.",
        "freshness": "Fraîcheur des analyses",
        "freshnessHint": "Ré-analysez les fiches anciennes pour garder vos accroches à jour.",
        "topActive": "Prospects les plus actifs en ligne",
        "noActive": "Aucune activité en ligne détectée pour l'instant.",
        "pubs": "{{n}} pub."
      }
    },
    "createdAt": "Créé le",
    "searchPlaceholderMobile": "Rechercher un prospect…",
    "workspaceOrg": "Votre organisation",
    "workspaceOrgNone": "Aucune (personnel)"
  },
  "events": {
    "notes": {
      "unknownProspect": "Prospect inconnu",
      "empty": "Aucune note prise pendant cet événement pour le moment.",
      "summary": "{{notes}} note(s) prospect · {{recaps}} récap(s) vocal",
      "voiceRecaps": "Récaps vocaux",
      "voiceRecap": "Récap vocal",
      "noTranscription": "Pas de transcription disponible.",
      "prospectNotes": "Notes prospects"
    },
    "search": {
      "loadingSuggestions": "⏳ Thiia prépare vos suggestions personnalisées…",
      "greeting": "👋 Bonjour ! Je suis Thiia. Je vais vous aider à trouver des événements pertinents pour votre activité.\n\nQuel type d'événement recherchez-vous ?",
      "launchingSearch": "🔍 Je lance la recherche pour \"{{query}}\"...",
      "refinedSearch": "🔍 Recherche affinée…",
      "noResults": "😕 Je n'ai pas trouvé d'événements correspondants. Voulez-vous ajuster vos critères ? Par exemple un autre thème, une autre localisation ou période ?",
      "foundResults": "✅ J'ai trouvé **{{count}} événement(s)** correspondant à vos critères ! Consultez les résultats ci-dessous.\n\nVous pouvez me demander d'ajuster : changer le lieu, le type d'événement, la période, ou ajouter des mots-clés.",
      "searchError": "❌ Désolé, une erreur est survenue lors de la recherche. Voulez-vous réessayer ?",
      "communicationError": "Erreur de communication avec Thiia",
      "unknownError": "Erreur inconnue",
      "analysisError": "Erreur d'analyse",
      "analysisDone": "Analyse terminée !",
      "analysisFailed": "Erreur d'analyse : {{message}}",
      "contactsFound": "{{count}} contact(s) identifié(s) !",
      "contactsImported": "{{count}} contacts importés !",
      "genericError": "Erreur : {{message}}",
      "importError": "Erreur lors de l'import : {{message}}",
      "saveError": "Erreur lors de la sauvegarde",
      "savedOk": "Recherche sauvegardée !",
      "deletedOk": "Recherche supprimée",
      "reloadingSaved": "🔄 Relance de la recherche sauvegardée « {{name}} »…",
      "registeredImported": "✅ Inscrit et importé : \"{{title}}\"",
      "imported": "\"{{title}}\" importé dans vos événements",
      "contactImported": "{{name}} importé comme prospect",
      "contactNotes": "Contact identifié via l'événement \"{{event}}\"\nRôle : {{role}}\n{{relevance}}",
      "contactRelevance": "Pertinence : {{value}}",
      "exportedCsv": "{{count}} événement(s) exporté(s) en CSV",
      "csvHeaders": {
        "title": "Titre",
        "date": "Date",
        "endDate": "Date fin",
        "location": "Lieu",
        "type": "Type",
        "price": "Prix",
        "free": "Gratuit",
        "organizer": "Organisateur",
        "format": "Format",
        "language": "Langue",
        "capacity": "Capacité",
        "expectedAudience": "Audience attendue",
        "pastAttendance": "Fréquentation passée",
        "targetAudience": "Public cible",
        "registrationDeadline": "Inscription avant",
        "url": "URL",
        "source": "Source",
        "description": "Description"
      },
      "yes": "Oui",
      "no": "Non",
      "notSpecified": "Non précisé",
      "online": "En ligne",
      "sourcePrefix": "Source",
      "suggestions": {
        "onlyIn": "Uniquement à {{loc}}",
        "onlyInMsg": "Montre-moi uniquement les événements à {{loc}}",
        "onlyOnline": "Uniquement en ligne",
        "onlyOnlineMsg": "Filtre uniquement les événements en ligne ou webinaires",
        "onlyFree": "Uniquement gratuits ({{count}})",
        "onlyFreeMsg": "Montre-moi uniquement les événements gratuits",
        "byOrg": "Par {{org}}",
        "byOrgMsg": "Montre-moi uniquement les événements organisés par {{org}}",
        "changeCity": "Changer de ville",
        "changeCityMsg": "Cherche les mêmes événements mais dans une autre ville",
        "thisWeek": "Cette semaine",
        "thisWeekMsg": "Montre-moi uniquement les événements de cette semaine"
      },
      "ui": {
        "thiiaEvents": "Thiia – Événements",
        "searchInProgress": "Recherche en cours…",
        "thiiaThinking": "Thiia réfléchit…",
        "describeWhat": "Décrivez ce que vous cherchez…",
        "hideChat": "Masquer le chat",
        "showChat": "Afficher le chat",
        "results_one": "{{count}} résultat",
        "results_other": "{{count}} résultats",
        "save": "Sauvegarder",
        "nameThisSearch": "Nommer cette recherche",
        "searchPlaceholder": "Ex : Conférences IA Paris",
        "saved": "Sauvegardées :",
        "allResults": "Tous les résultats",
        "relevanceOver50": "Pertinence > 50%",
        "sortBy": "Trier par…",
        "sortRelevance": "Pertinence",
        "sortDate": "Date (plus proche)",
        "sortPrice": "Prix (croissant)",
        "noResultsYet": "Aucun résultat pour le moment",
        "describeInChat": "Décrivez les événements que vous recherchez dans le chat",
        "free": "Gratuit",
        "paid": "Payant",
        "web": "Web",
        "audience": "Audience : {{value}}",
        "previousEditions": "Éd. précédentes : {{value}}",
        "publicLabel": "Public : {{value}}",
        "analyzed": "Analysé",
        "analyze": "Analyser",
        "contacts": "Contacts",
        "imported": "Importé",
        "register": "S'inscrire",
        "import": "Importer",
        "aiAnalysis": "Analyse IA",
        "aiAnalysisRelevance": "Analyse IA — Pertinence : {{score}}%",
        "themes": "Thèmes :",
        "highlights": "Points forts :",
        "speakers": "Intervenants :",
        "networking": "Networking :",
        "recommendations": "Recommandations :",
        "pricing": "Tarifs :",
        "contactsIdentified": "Contacts identifiés ({{count}})",
        "importAll": "Tout importer ({{count}})",
        "prospect": "Prospect",
        "page": "Page {{current}} / {{total}}",
        "results": "{{count}} résultats"
      }
    },
    "title": "Événements suivis",
    "count_one": "{{count}} événement",
    "count_other": "{{count}} événements",
    "categories": {
      "all": "Tous",
      "task": "Tâches",
      "meeting": "Réunions",
      "conference": "Conférences"
    },
    "status": "Statut",
    "allStatuses": "Tous les statuts",
    "filterByStatus": "Filtrer les événements par statut",
    "statusesActive_one": "{{count}} statut",
    "statusesActive_other": "{{count}} statuts",
    "clearStatuses": "Effacer les statuts",
    "tabs": {
      "table": "Tableau",
      "list": "Liste",
      "calendar": "Calendrier"
    },
    "empty": "Aucun événement pour le moment.",
    "deleteEvent": "Supprimer l'événement",
    "types": {
      "task": "Tâche",
      "meeting": "Réunion",
      "conference": "Conférence",
      "workshop": "Atelier",
      "webinar": "Webinaire",
      "meetup": "Meetup",
      "coaching": "Coaching",
      "other": "Autre"
    },
    "statuses": {
      "draft": "Brouillon",
      "registered": "Inscrit",
      "confirmed": "Confirmé"
    },
    "registrationStatuses": {
      "registered": "Inscrit",
      "confirmed": "Confirmé",
      "cancelled": "Annulé",
      "attended": "Présent",
      "no_show": "Absent"
    },
    "sheet": {
      "startDateTime": "Date et heure de début",
      "datePlaceholder": "Date",
      "location": "Lieu",
      "locationPlaceholder": "Lieu de l'événement",
      "description": "Description",
      "descriptionPlaceholder": "Description de l'événement…",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "type": "Type",
      "status": "Statut",
      "deleteButton": "Supprimer cet événement",
      "deleteTitle": "Supprimer cet événement ?",
      "deleteDescription": "Cette action est irréversible. L'événement sera définitivement supprimé.",
      "deleteConfirm": "Supprimer",
      "dateFormat": "EEEE d MMMM yyyy · HH:mm",
      "breadcrumbList": "Liste des événements",
      "breadcrumbDetail": "Détail de l'événement"
    },
    "add": {
      "trigger": "Nouvel événement",
      "title": "Créer un événement",
      "fieldTitle": "Titre *",
      "titlePlaceholder": "Nom de l'événement",
      "type": "Type",
      "maxParticipants": "Participants max",
      "maxParticipantsPlaceholder": "Illimité",
      "date": "Date *",
      "datePlaceholder": "Choisir une date",
      "startTime": "Début",
      "endTime": "Fin",
      "video": "Visioconférence",
      "videoNone": "Aucune",
      "location": "Lieu",
      "locationPlaceholder": "Adresse ou lien visio",
      "description": "Description",
      "descriptionPlaceholder": "Détails de l'événement…",
      "creating": "Création…",
      "submit": "Créer l'événement"
    },
    "calendar": {
      "weekDays": [
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam",
        "Dim"
      ],
      "monthFormat": "MMMM yyyy"
    },
    "table": {
      "location": "Lieu"
    },
    "bulk": {
      "selectAll": "Tout sélectionner",
      "selectAllFiltered": "Sélectionner les {{count}} événements filtrés",
      "selectedCount_one": "{{count}} sélectionné",
      "selectedCount_other": "{{count}} sélectionnés",
      "deleteSelected": "Supprimer la sélection",
      "confirmTitle_one": "Supprimer {{count}} événement ?",
      "confirmTitle_other": "Supprimer {{count}} événements ?",
      "confirmDescription": "Cette action est irréversible. Les événements sélectionnés seront définitivement supprimés.",
      "deletedOk_one": "{{count}} événement supprimé",
      "deletedOk_other": "{{count}} événements supprimés",
      "deletedPartial": "{{ok}} supprimé(s), {{fail}} échec(s)",
      "confirmTitle": "Supprimer les événements sélectionnés ?",
      "deletedOk": "Événements supprimés",
      "selectedCount": "{{count}} sélectionnés"
    },
    "registrations": {
      "title": "Inscrits",
      "empty": "Aucun inscrit pour le moment.",
      "count_one": "{{count}} inscrit",
      "count_other": "{{count}} inscrits",
      "bulk": {
        "confirmTitle_one": "Supprimer {{count}} inscription ?",
        "confirmTitle_other": "Supprimer {{count}} inscriptions ?",
        "confirmDescription": "Cette action est irréversible. Les inscriptions sélectionnées seront définitivement supprimées.",
        "deletedOk_one": "{{count}} inscription supprimée",
        "deletedOk_other": "{{count}} inscriptions supprimées",
        "deletedPartial": "{{ok}} supprimée(s), {{fail}} échec(s)",
        "confirmTitle": "Supprimer les inscriptions sélectionnées ?",
        "deletedOk": "Inscriptions supprimées"
      },
      "count": "{{count}} inscriptions"
    },
    "qr": {
      "buttonLabel": "QR Code",
      "titleWithEvent": "QR Code – {{title}}",
      "titleGeneric": "QR Code événement",
      "descriptionWithEvent": "Présentez ce QR code lors de \"{{title}}\". Les participants pourront s'inscrire directement.",
      "descriptionGeneric": "Présentez ce QR code pour permettre aux participants de s'inscrire.",
      "copy": "Copier le lien",
      "copied": "Copié",
      "copySuccess": "Lien copié !",
      "download": "Télécharger",
      "linkLabel": "Lien d'inscription",
      "openLink": "Ouvrir le lien"
    },
    "count": "{{count}} événements",
    "searchPlaceholderMobile": "Rechercher…",
    "groups": {
      "thisWeek": "Cette semaine",
      "nextMonth": "Le mois prochain",
      "later": "Plus tard",
      "past": "Passés"
    },
    "filters": {
      "seeResults": "Voir {{count}} événements"
    }
  },
  "content": {
    "title": "Contenu",
    "summary_drafts_one": "{{count}} brouillon",
    "summary_drafts_other": "{{count}} brouillons",
    "summary_scheduled_one": "{{count}} planifié",
    "summary_scheduled_other": "{{count}} planifiés",
    "summary_published_one": "{{count}} publié",
    "summary_published_other": "{{count}} publiés",
    "communicate": "Communiquer",
    "import": "Importer",
    "importDialog": {
      "title": "Importer une série de posts",
      "description": "Word, Markdown ou PDF. Thiia détecte les posts, le canal et programme les créneaux les plus visibles sans chevaucher vos publications existantes.",
      "dropzone": "Déposez votre document",
      "analyzing": "Analyse du document…",
      "formats": ".md · .txt · .docx · .pdf",
      "start": "Début",
      "perWeek": "Posts / semaine",
      "audience": "Audience visée",
      "audienceB2b": "Professionnels (B2B)",
      "audienceB2c": "Grand public (B2C)",
      "audienceMixed": "Mixte",
      "organization": "Organisation",
      "personal": "Personnel",
      "cadenceDetected": "Rythme détecté : {{raw}}",
      "weekendNotice": "{{count}} post(s) placés le week-end (meilleure portée pour cette audience)",
      "generateVisual": "Générer le visuel décrit",
      "manualSlot": "Créneau ajusté manuellement",
      "noSlot": "Aucun créneau libre trouvé",
      "imageProgress": "Génération des visuels {{done}}/{{total}}…",
      "summary": "{{included}}/{{total}} posts · {{file}}",
      "visualsSuffix": " · {{count}} visuel(s)",
      "cancel": "Annuler",
      "schedule": "Programmer",
      "scheduleCount": "Programmer {{count}} posts",
      "unsupportedTitle": "Format non supporté",
      "unsupportedDesc": "Utilisez un fichier .md, .txt, .docx ou .pdf",
      "noPostsTitle": "Aucun post détecté",
      "noPostsDesc": "Structurez le document avec un titre par post (ex. « ## Post 1 — Titre »).",
      "readErrorTitle": "Lecture impossible",
      "readErrorDesc": "Erreur d'extraction",
      "imageFailed": "Image non générée — {{title}}",
      "importedTitle": "{{count}} contenus importés",
      "importedDesc": "Retrouvez-les dans le calendrier éditorial.",
      "importFailed": "Import échoué",
      "genericError": "Erreur"
    },
    "allTypes": "Tous",
    "allStatuses": "Tout statut",
    "tabs": {
      "list": "Liste",
      "calendar": "Calendrier éditorial"
    },
    "empty": "Aucun contenu pour le moment.",
    "emptyHint": "Utilisez le bouton « Communiquer » pour commencer.",
    "table": {
      "type": "Type",
      "title": "Titre",
      "status": "Statut",
      "date": "Date",
      "actions": "Actions"
    },
    "actions": {
      "publishLinkedIn": "Publier sur LinkedIn",
      "copy": "Copier",
      "copied": "Copié dans le presse-papier !",
      "duplicate": "Dupliquer"
    },
    "deleteTitle": "Supprimer ce contenu ?",
    "deleteDescription": "Le contenu sera définitivement supprimé.",
    "types": {
      "post_linkedin": "Post LinkedIn",
      "post_linkedin_short": "LinkedIn",
      "post_instagram": "Post Instagram",
      "post_instagram_short": "Instagram",
      "post_facebook": "Post Facebook",
      "post_facebook_short": "Facebook",
      "post_twitter": "Post X / Twitter",
      "post_twitter_short": "X",
      "post_whatsapp": "Message WhatsApp",
      "post_whatsapp_short": "WhatsApp",
      "newsletter": "Newsletter",
      "newsletter_short": "Newsletter",
      "blog_article": "Article de blog",
      "blog_article_short": "Blog"
    },
    "statuses": {
      "draft": "Brouillon",
      "scheduled": "Planifié",
      "published": "Publié",
      "archived": "Archivé"
    },
    "calendar": {
      "weekDays": [
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam",
        "Dim"
      ],
      "monthFormat": "MMMM yyyy",
      "weekOf": "Semaine du"
    },
    "imageSection": {
      "addImage": "Ajouter image",
      "generateAi": "Générer avec l'IA",
      "dialogTitle": "Générer une image avec l'IA",
      "describe": "Décrivez l'image souhaitée",
      "promptPlaceholder": "Ex : Photo professionnelle d'une équipe en réunion, style corporate moderne",
      "hint": "Soyez précis : style, couleurs, composition, ambiance…",
      "cancel": "Annuler",
      "generate": "Générer",
      "generating": "Génération…",
      "unsupportedFormat": "Format non supporté",
      "tooLarge": "Image trop volumineuse (max 10 Mo)",
      "imageAdded": "Image ajoutée",
      "imageGenerated": "Image générée et ajoutée ✨",
      "uploadError": "Erreur d'upload",
      "error": "Erreur",
      "notAuthenticated": "Non authentifié",
      "generationError": "Erreur de génération d'image",
      "noImage": "Aucune image générée"
    },
    "editor": {
      "placeholder": "Rédigez votre contenu…",
      "linkPrompt": "URL du lien",
      "imagePrompt": "URL de l'image",
      "bold": "Gras",
      "italic": "Italique",
      "underline": "Souligné",
      "strike": "Barré",
      "highlight": "Surligner",
      "h1": "Titre 1",
      "h2": "Titre 2",
      "h3": "Titre 3",
      "bullet": "Liste à puces",
      "ordered": "Liste numérotée",
      "quote": "Citation",
      "divider": "Séparateur",
      "alignLeft": "Aligner à gauche",
      "alignCenter": "Centrer",
      "alignRight": "Aligner à droite",
      "link": "Lien",
      "image": "Image",
      "undo": "Annuler",
      "redo": "Rétablir"
    },
    "linkedinDialog": {
      "title": "Publier sur LinkedIn",
      "publishAs": "Publier en tant que",
      "personalProfile": "Profil personnel",
      "companyPage": "Page entreprise",
      "choosePage": "Choisir une page",
      "postContent": "Contenu du post",
      "postPlaceholder": "Votre post LinkedIn...",
      "charCount": "{{count}} / 3000 caractères",
      "imageOptional": "Image (optionnel)",
      "preview": "Aperçu",
      "addImage": "Ajouter une image",
      "visibility": "Visibilité",
      "public": "🌍 Public",
      "connections": "👥 Connexions uniquement",
      "now": "Maintenant",
      "schedule": "Planifier",
      "date": "Date",
      "time": "Heure",
      "choose": "Choisir",
      "scheduledFor": "📅 Publication prévue le {{date}} à {{time}}",
      "copyOpen": "Copier & ouvrir LinkedIn",
      "publishOnPage": "Publier sur la page",
      "publishOnProfile": "Publier sur mon profil",
      "schedulePost": "Planifier la publication",
      "selectPage": "Sélectionnez une page entreprise.",
      "publishedToast": "✅ Post publié sur votre {{label}} LinkedIn !",
      "labelPage": "page entreprise {{name}}",
      "labelPersonal": "profil personnel",
      "publishError": "Erreur de publication",
      "scheduleError": "Erreur de planification",
      "futureDate": "La date de planification doit être dans le futur.",
      "scheduledToast": "📅 Publication planifiée !",
      "scheduledToastDesc": "Votre post sera publié le {{date}}",
      "copiedToast": "Texte copié ! Collez-le sur LinkedIn.",
      "unsupportedFormat": "Format non supporté",
      "imagesOnly": "Seules les images sont acceptées.",
      "tooLarge": "Image trop volumineuse",
      "max10mb": "Max 10 Mo.",
      "dateFormatLong": "EEEE d MMMM yyyy",
      "dateFormatShort": "d MMM yyyy",
      "scheduledDateFormat": "d MMMM yyyy 'à' HH:mm",
      "back": "Retour",
      "checklistClose": "Fermer",
      "checklistDesc": "Suivez ces étapes pour publier sur LinkedIn.",
      "checklistDone": "Terminé",
      "checklistFinish": "Terminer",
      "checklistTitle": "Publication LinkedIn",
      "confirmPublish": "Publier",
      "confirmPublishDesc": "Confirmez la publication de ce contenu sur LinkedIn.",
      "confirmPublishTitle": "Confirmer la publication",
      "confirmSchedule": "Planifier",
      "confirmScheduleDesc": "Confirmez la planification de ce contenu.",
      "confirmScheduleTitle": "Confirmer la planification",
      "previewAndPublish": "Aperçu et publication",
      "previewAndSchedule": "Aperçu et planification",
      "recopy": "Recopier",
      "reopen": "Rouvrir",
      "step1Desc": "Copiez le contenu dans le presse-papiers.",
      "step1Title": "Copier le contenu",
      "step2Desc": "Ouvrez LinkedIn pour créer une publication.",
      "step2Title": "Ouvrir LinkedIn",
      "step3Desc": "Collez le contenu dans le composeur.",
      "step3Title": "Coller le contenu",
      "step4Desc": "Ajoutez vos médias si nécessaire.",
      "step4Title": "Ajouter les médias",
      "step5Desc": "Publiez ou planifiez votre post depuis LinkedIn.",
      "step5Title": "Publier sur LinkedIn"
    },
    "generator": {
      "titleManual": "Nouvelle publication",
      "titleAi": "Générer du contenu avec Thiia",
      "analyzing": "Analyse en cours…",
      "writing": "Thiia rédige…",
      "ready": "Votre contenu est prêt",
      "reviewTitle": "Titre",
      "tabPreview": "Aperçu",
      "tabSource": "Source",
      "refinePlaceholder": "Demandez à Thiia d'ajuster… (ex: rends-le plus court, ajoute des emojis)",
      "saveDraft": "Enregistrer en brouillon",
      "schedule": "Planifier",
      "publishLinkedIn": "Publier sur LinkedIn",
      "copyLinkedIn": "Copier & ouvrir LinkedIn",
      "copyWhatsApp": "Copier pour WhatsApp",
      "copyWhatsAppSuccess": "Message WhatsApp copié",
      "copyWhatsAppSuccessDesc": "Collez-le directement dans WhatsApp, la mise en forme sera conservée.",
      "copyError": "Impossible de copier",
      "copiedLabel": "Copié !",
      "channelFailed": "Échec de génération pour ce canal",
      "retryChannel": "Relancer ce canal",
      "resumeChannel": "Reprendre ce canal",
      "cancelGeneration": "Annuler",
      "channelCanceled": "Génération annulée",
      "multiCanceled": "Génération multi-canal annulée",
      "retryAllFailed": "Relancer les {{count}} canaux en échec",
      "multiError": "Erreur de génération",
      "generatingProgress": "Génération en cours… {{done}}/{{total}} canaux",
      "generationComplete": "Génération terminée : {{done}}/{{total}} réussis",
      "channelStreaming": "Génération en cours…",
      "channelPending": "En file d'attente…",
      "chars": "caractères",
      "cleanWhatsApp": "Nettoyer le format WhatsApp",
      "cleaned": "Texte nettoyé",
      "whatsappPreviewHint": "Aperçu du rendu final dans WhatsApp — la copie conserve la syntaxe *gras* / _italique_.",
      "regenerate": "Régénérer",
      "confirmPublishTitle": "Confirmer la publication",
      "confirmPublishDesc": "Vérifiez l'aperçu de votre post avant de continuer.",
      "tooLong": "— trop long",
      "cancel": "Annuler",
      "continuePublish": "Continuer vers la publication",
      "modeAi": "Générer avec Thiia",
      "modeManual": "Rédiger manuellement",
      "forOrganization": "Pour quelle organisation",
      "noOrg": "Aucune (personnel)",
      "orgDefaultSuffix": " · par défaut",
      "contentType": "Type de contenu",
      "soon": "Bientôt",
      "linkedInFormat": "Format LinkedIn",
      "formats": {
        "classic": "Post classique",
        "classicDesc": "Texte avec ou sans image",
        "carousel": "Carrousel",
        "carouselDesc": "Diaporama multi-images (PDF)",
        "poll": "Sondage",
        "pollDesc": "Question + options de vote",
        "article": "Article",
        "articleDesc": "Article long format",
        "video": "Vidéo / Script",
        "videoDesc": "Script pour vidéo LinkedIn"
      },
      "mediaAndSources": "Médias et sources",
      "filesCounter": "{{files}}/{{maxFiles}} fichiers · {{used}}/{{max}} Mo",
      "acceptedHint": "Images {{images}} · Docs PDF, Word, TXT, CSV, Excel · Audio MP3, WAV, M4A · {{maxImg}} Mo (image) / {{maxDoc}} Mo (doc/audio)",
      "library": "Bibliothèque",
      "librarySelected_one": "{{count}} sélectionné",
      "librarySelected_other": "{{count}} sélectionnés",
      "libraryHiddenCount_one": " · {{count}} masqué",
      "libraryHiddenCount_other": " · {{count}} masqués",
      "hideHidden": "Cacher masqués",
      "showHidden": "Voir masqués",
      "collapse": "Replier",
      "chooseMySources": "Choisir mes sources",
      "libraryHint": "Cochez les médias que Thiia doit utiliser comme sources.",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "hidden": "(masqué)",
      "typeImage": "Image",
      "typeAudio": "Audio",
      "typeDoc": "Doc",
      "dropHere": "Déposez vos fichiers ici",
      "filesInProgress_one": "{{count}} fichier en cours",
      "filesInProgress_other": "{{count}} fichiers en cours",
      "cancelAll": "Tout annuler",
      "statusQueued": "En file…",
      "statusUploadImage": "Upload de l'image…",
      "statusUpload": "Upload…",
      "statusExtracting": "Extraction du texte…",
      "statusTranscribing": "Transcription audio…",
      "statusDone": "Terminé",
      "statusError": "Erreur",
      "cancelImport": "Annuler cet import",
      "notImported_one": "{{count}} fichier non importé",
      "notImported_other": "{{count}} fichiers non importés",
      "clearAll": "Tout effacer",
      "retry": "Réessayer",
      "ignore": "Ignorer",
      "mediaAdded": "Médias ajoutés",
      "removeAll": "Tout retirer",
      "removeMedia": "Retirer ce média",
      "typePdf": "PDF",
      "typeCsv": "CSV",
      "typeWord": "Word",
      "typeDocument": "Document",
      "extractedCharsSuffix": " caractères extraits",
      "noPreview": "Aucun aperçu disponible",
      "removeDocument": "Retirer le document",
      "removePhoto": "Retirer la photo",
      "addPhoto": "Ajouter une photo",
      "limitReached": "Limite atteinte — retirez un fichier pour ajouter",
      "attachDocTitle": "Joindre un document (PDF, Word, image, texte) ou un audio (mp3, wav, m4a…)",
      "smartAnalysis": "Analyse intelligente",
      "smartAnalysisDesc": "Thiia analyse vos posts, emails envoyés et événements à venir pour enrichir votre newsletter.",
      "recentPosts": "Posts récents",
      "sentEmails": "Emails envoyés",
      "eventsLabel": "Événements",
      "reanalyze": "Réanalyser",
      "analyzeMyData": "Analyser mes données",
      "analysisReady": "Analyse prête",
      "subjectTheme": "Sujet / Thème *",
      "topicPlaceholderPoll": "Ex: Quel est le plus grand défi des managers en 2026 ?",
      "topicPlaceholderCarousel": "Ex: 7 erreurs à éviter dans votre stratégie de prospection…",
      "topicPlaceholderVideo": "Ex: 3 conseils pour réussir votre prise de parole en public…",
      "topicPlaceholderLinkedIn": "Ex: Les 5 habitudes des leaders performants…",
      "topicPlaceholderNewsletter": "Ex: Newsletter mensuelle mars 2026, actualités et événements à venir…",
      "topicPlaceholderDefault": "Ex: Mon retour d'expérience sur l'accompagnement en entreprise…",
      "desiredTone": "Ton souhaité",
      "toneWarm": "Professionnel & chaleureux",
      "toneDynamic": "Dynamique & motivant",
      "toneInspiring": "Inspirant & poétique",
      "toneDirect": "Direct & percutant",
      "toneEducational": "Éducatif & pédagogique",
      "generateWithThiia": "Générer avec Thiia",
      "titleOptional": "Titre (optionnel)",
      "titleInternalPlaceholder": "Titre interne pour retrouver ce contenu…",
      "yourMessage": "Votre message *",
      "messagePlaceholder": "Écrivez votre publication ici…",
      "markdownSupported": "Markdown supporté (gras, listes, liens). Aucune génération IA n'est appliquée.",
      "saveDraftBtn": "Enregistrer le brouillon",
      "finalize": "Finaliser",
      "analyzingData": "Analyse de vos posts, emails et événements…",
      "writingContent": "Thiia rédige votre contenu…",
      "deleteMediaTitle": "Supprimer ce média ?",
      "deleteMediaDesc": "Le fichier <strong>{{name}}</strong> sera retiré définitivement de votre bibliothèque. Cette action est irréversible. Si vous souhaitez le garder en réserve, utilisez plutôt l'option « Masquer ».",
      "deletePermanently": "Supprimer définitivement",
      "copied": "Texte copié ! Collez-le sur LinkedIn."
    },
    "summary_drafts": "{{count}} brouillons",
    "summary_published": "{{count}} publiés",
    "summary_scheduled": "{{count}} planifiés",
    "generate": "Générer",
    "filters": {
      "seeResults": "Voir {{count}} contenus"
    }
  },
  "profileCompletion": {
    "label": "Profil {{percent}} %",
    "aria": "Profil complété à {{percent}} %, ouvrir les réglages de profil"
  },
  "onboarding": {
    "headerTitle": "Bienvenue chez Thiia",
    "headerSubtitle": "Configuration de votre profil",
    "letsGo": "C'est parti ! 🚀",
    "validateOne": "Valider ({{count}} sélectionné)",
    "validateOther": "Valider ({{count}} sélectionnés)",
    "saving": "Enregistrement…",
    "enterApp": "Accéder à Thiia →",
    "back": "Retour",
    "skip": "Passer cette question",
    "saveErrorTitle": "Impossible d'enregistrer",
    "saveErrorDesc": "Vos réponses n'ont pas pu être enregistrées. Vérifiez votre connexion et réessayez.",
    "stepCounter": "Étape {{current}} / {{total}}",
    "otherPlaceholder": "Précisez…",
    "summary": {
      "title": "Récapitulatif",
      "edit": "Modifier",
      "notProvided": "Non renseigné",
      "preferredLanguage": "Langue préférée",
      "businessType": "Domaine d'activité",
      "targetAudience": "Public cible",
      "communicationTone": "Ton de communication",
      "socialNetworks": "Réseaux sociaux",
      "toolsUsed": "Outils utilisés",
      "referralSource": "Comment vous nous avez connus"
    },
    "skipAll": "Passer",
    "stepIndicator": "{{current}} sur {{total}}",
    "singleTitle": "Que faites-vous, et pour qui ?",
    "singleSubtitle": "Une phrase suffit. C'est ce qui permet à l'agent de chercher les bons contacts dès maintenant.",
    "activityPlaceholder": "Coach en reconversion pour cadres de plus de 40 ans, en Île-de-France…",
    "activityPrefill": "{{activity}} pour ",
    "launchAgent": "Lancer l'agent",
    "editableLater": "Modifiable à tout moment dans vos réglages",
    "defaultActivity": "Indépendant qui cherche de nouveaux clients",
    "chatKickoff": "Mon activité : {{activity}}. Lance tout de suite une première recherche de contacts correspondants, puis demande-moi sur quel ton tu dois écrire : Direct, Chaleureux, Institutionnel, ou Comme j'écris.",
    "activities": {
      "coach": "Coach",
      "consultant": "Consultant",
      "trainer": "Formateur",
      "agency": "Agence",
      "techFreelance": "Freelance tech",
      "other": "Autre"
    },
    "nextTitle": "Ce qui se passe ensuite",
    "next": {
      "oneTitle": "L'agent cherche",
      "oneDesc": "Il parcourt les réseaux et les signaux publics pour repérer les personnes qui correspondent à votre activité.",
      "twoTitle": "Vous validez",
      "twoDesc": "Vous gardez les profils pertinents, vous écartez les autres : l'agent apprend de vos choix.",
      "threeTitle": "Le profil se complète",
      "threeDesc": "Ton, réseaux, outils : tout s'ajuste au fil de vos échanges, sans questionnaire à remplir."
    },
    "creditsTitle": "Crédits offerts à l'inscription",
    "creditsDesc": "De quoi lancer une première campagne avant de choisir un pack.",
    "languages": {
      "fr": "🇫🇷 Français",
      "en": "🇬🇧 English"
    },
    "steps": {
      "welcome": "Bonjour ! 👋 Je suis Thiia, votre assistant IA personnel. Je vais vous poser quelques questions pour mieux vous connaître et adapter mon aide à vos besoins. Prêt(e) ?",
      "preferredLanguage": "Dans quelle langue préférez-vous utiliser Thiia ? 🌐",
      "businessType": "Quel est votre domaine d'activité ? (ex : consulting, formation, coaching, freelance, accompagnement…)",
      "businessTypePlaceholder": "Ex : Consultant en stratégie digitale",
      "targetAudience": "Super ! Et quel est votre public cible ? Décrivez le profil idéal de vos clients. 🎯",
      "targetAudiencePlaceholder": "Ex : Cadres et dirigeants en transition de carrière",
      "communicationTone": "Comment aimez-vous communiquer ? Quel ton préférez-vous pour vos échanges professionnels ?",
      "socialNetworks": "Sur quels réseaux sociaux êtes-vous actif(ve) ? Je pourrai vous aider à créer du contenu adapté. 📱",
      "toolsUsed": "Quels outils utilisez-vous aujourd'hui pour votre prospection ou la gestion client ? (sélection multiple) 🛠️",
      "referralSource": "Dernière question ! Comment avez-vous entendu parler de Thiia ? 💬",
      "done": "Parfait ! J'ai tout ce qu'il me faut pour commencer. 🚀 Je vais adapter mes recherches de prospects, mes suggestions de contenu et mon style de communication à votre profil. Allons-y !"
    },
    "tones": {
      "professionnel": "Professionnel & formel",
      "chaleureux": "Chaleureux & accessible",
      "dynamique": "Dynamique & motivant",
      "inspirant": "Inspirant & poétique"
    },
    "tools": {
      "hubspot": "HubSpot",
      "salesforce": "Salesforce",
      "pipedrive": "Pipedrive",
      "notion": "Notion",
      "airtable": "Airtable",
      "spreadsheets": "Excel / Google Sheets",
      "salesNav": "LinkedIn Sales Navigator",
      "lemlist": "Lemlist / Waalaxy",
      "brevo": "Brevo / Mailchimp",
      "zoho": "Zoho CRM",
      "none": "Aucun outil pour le moment",
      "other": "Autre"
    },
    "referral": {
      "linkedin": "LinkedIn",
      "google": "Recherche Google",
      "wordOfMouth": "Recommandation d'un proche",
      "press": "Article / blog / presse",
      "socialMedia": "Réseaux sociaux (Instagram, X, Facebook…)",
      "event": "Événement / salon",
      "newsletter": "Email / newsletter",
      "ad": "Publicité",
      "invited": "Invité",
      "other": "Autre"
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread_one": "{{count}} non lue",
    "unread_other": "{{count}} non lues",
    "markAllRead": "Tout marquer comme lu",
    "markAllReadShort": "Tout lu",
    "empty": "Aucune notification pour le moment.",
    "new": "Nouveau",
    "view": "Voir",
    "markRead": "Marquer comme lu",
    "bellTooltip": "Notifications",
    "unread": "Non lues"
  },
  "emails": {
    "searchPlaceholder": "Rechercher ou poser une question IA... (⌘K)",
    "searchPlaceholderShort": "Rechercher...",
    "aiSearchTitle": "Recherche intelligente par IA (Shift+Entrée)",
    "showSidebar": "Afficher la sidebar",
    "hideSidebar": "Masquer la sidebar",
    "compactMode": "Mode compact",
    "comfortableMode": "Mode confortable",
    "shortcuts": "Raccourcis clavier (?)",
    "new": "Nouveau",
    "partialResults": "Résultats incomplets : certaines boîtes n'ont pas répondu à temps.",
    "partialRetry": "Réessayer",
    "partialHint": "Réduisez la période ou précisez les mots-clés pour accélérer la recherche.",
    "noMatch": "Aucun email ne correspond aux filtres",
    "clearFilters": "Effacer les filtres",
    "list": {
      "loading": "Chargement…",
      "empty": "Aucun email trouvé",
      "loadMore": "Charger plus",
      "draft": "Brouillon",
      "yesterday": "Hier"
    },
    "filters": {
      "unread": "Non lus",
      "attachments": "Pièces jointes",
      "sender": "Expéditeur",
      "searchContact": "Rechercher un contact…",
      "noContact": "Aucun contact trouvé",
      "clearFilter": "Effacer le filtre",
      "today": "Aujourd'hui",
      "week": "7 derniers jours",
      "month": "30 derniers jours",
      "quarter": "90 derniers jours",
      "allDates": "Toutes les dates",
      "sortDate": "Date",
      "sortFrom": "Expéditeur",
      "sortSubject": "Objet",
      "results_one": "{{count}} résultat",
      "results_other": "{{count}} résultats",
      "clear": "Effacer",
      "filtersAndSort": "Filtres & tri",
      "results": "{{count}} résultats"
    },
    "viewer": {
      "back": "Retour",
      "from": "De",
      "to": "À",
      "cc": "Cc",
      "fromShort": "De :",
      "analyze": "Analyser",
      "replyAll": "Rép. tous",
      "reply": "Répondre",
      "forward": "Transférer",
      "attachments_one": "{{count}} pièce jointe",
      "attachments_other": "{{count}} pièces jointes",
      "dateFormat": "d MMM yyyy à HH:mm",
      "addAllProspects": "Ajouter tous en prospects",
      "addAsProspect": "Ajouter comme prospect",
      "alreadyProspect": "Déjà prospect",
      "attachments": "Pièces jointes",
      "bulkAddCount": "{{count}} contacts ajoutés",
      "bulkAddDone": "Ajout groupé terminé",
      "download": "Télécharger",
      "duplicateAddAnyway": "Ajouter quand même",
      "duplicateDomainBody": "Un prospect existe déjà avec le même domaine.",
      "duplicateExisting": "Prospect existant",
      "duplicateNew": "Nouveau contact",
      "duplicateTitle": "Doublon potentiel détecté",
      "prospectAdded": "Prospect ajouté",
      "sameDomainProspect": "Prospect du même domaine"
    },
    "composer": {
      "saveDraft": "Brouillon",
      "newMessage": "Nouveau message",
      "reply": "Répondre",
      "forward": "Transférer",
      "templates": "Templates",
      "noTemplate": "Aucun template enregistré",
      "saveAsTemplate": "Sauvegarder comme template",
      "templateSaved": "Template enregistré",
      "templateSavedDesc": "« {{name}} » a été sauvegardé.",
      "templateLoaded": "Template chargé",
      "templateLoadedDesc": "« {{name}} » appliqué.",
      "templateDeleted": "Template supprimé",
      "templateDeletedDesc": "« {{name}} » a été supprimé.",
      "saveTemplate": "Sauvegarder le template",
      "templateNamePlaceholder": "Nom du template…",
      "savedContent": "Contenu sauvegardé :",
      "subjectField": "Objet : {{value}}",
      "messageField": "Message : {{value}}",
      "empty": "(vide)",
      "attachmentsCount_one": "{{count}} pièce jointe",
      "attachmentsCount_other": "{{count}} pièces jointes",
      "save": "Sauvegarder",
      "to": "À",
      "ccOptional": "Cc (optionnel)",
      "subject": "Objet",
      "bodyPlaceholder": "Rédigez votre message...",
      "attachFile": "Joindre un fichier",
      "aiAssist": "Assistance IA",
      "aiInstructions": "Instructions pour l'IA (optionnel)...",
      "writeReply": "Rédiger réponse",
      "compose": "Composer",
      "improve": "Améliorer",
      "draft": "Brouillon",
      "updateDraft": "Mettre à jour le brouillon",
      "cancel": "Annuler",
      "send": "Envoyer",
      "error": "Erreur",
      "attachmentsCount": "{{count}} pièce(s) jointe(s)"
    },
    "unsubscribe": {
      "clickHere": "cliquer ici",
      "footerText": "Pour ne plus recevoir d'e-mails, {{link}}."
    },
    "attachTx": {
      "title": "Attacher à une transaction bancaire",
      "button": "Attacher à une transaction",
      "search": "Rechercher par fournisseur, libellé ou montant",
      "empty": "Aucune transaction à justifier. Lancez un passage dans Justificatifs.",
      "noResult": "Aucune transaction ne correspond.",
      "suggested": "Suggérée",
      "confirm": "Valider et attacher",
      "done": "Facture attachée à la transaction",
      "unavailable": "Pièce jointe indisponible",
      "org": "Organisation",
      "allOrgs": "Toutes les organisations",
      "noOrg": "Sans organisation"
    }
  },
  "chat": {
    "heroGreetingSuffix": ", je suis Thiia",
    "heroTagline": "Votre assistante IA de prospection et communication",
    "heroTaglineShort": "Votre assistante IA de prospection",
    "newConversation": "Nouvelle conversation",
    "searchPlaceholder": "Rechercher…",
    "tabs": {
      "conversations": "Conversations",
      "note": "Note"
    },
    "inputPlaceholder": "Posez une question ou demandez une tâche…",
    "errors": {
      "generic": "Erreur",
      "createConversation": "Impossible de créer la conversation",
      "delete": "Impossible de supprimer",
      "rename": "Impossible de renommer",
      "archive": "Impossible d'archiver",
      "reset": "Impossible de réinitialiser",
      "deleteMessage": "Impossible de supprimer le message"
    },
    "toasts": {
      "conversationReset": "Conversation réinitialisée",
      "messageDeleted": "Message supprimé",
      "uploadCancelled": "Téléversement annulé",
      "uploadFailed": "Téléversement échoué"
    },
    "upload": {
      "tooLarge": "Le fichier est trop volumineux. La limite dépend de votre plan Supabase (200 Mo en Free, 5 Go en Pro). Veuillez compresser ou découper le fichier puis réessayer.",
      "badFormat": "Format de fichier non supporté. Formats acceptés : MP3, WAV, MP4, WEBM, M4A, PDF, DOC, images.",
      "network": "Erreur réseau. Vérifiez votre connexion puis retéléversez le fichier.",
      "generic": "Échec du téléversement. Veuillez réessayer avec un fichier plus petit ou dans un autre format.",
      "withReason": "Échec du téléversement : {{error}}. Veuillez réessayer."
    },
    "transcription": {
      "noTranscription": "Aucune transcription reçue",
      "error": "❌ Erreur lors de la transcription : {{error}}. Veuillez réessayer.",
      "unknownError": "Erreur inconnue"
    },
    "quickActions": {
      "orChoose": "ou choisissez une action rapide",
      "audioReport": "Compte rendu audio",
      "communicate": "Communiquer",
      "communicateDesc": "Email, post, message",
      "newsletter": "Newsletter",
      "newsletterDesc": "Rédiger un envoi pro",
      "followUp": "Relances",
      "followUpDesc": "Programmer un suivi",
      "findProspects": "Trouver prospects",
      "findProspectsDesc": "Recherche ciblée web",
      "findEvents": "Trouver événements",
      "findEventsDesc": "Salons, conférences",
      "addProspect": "Ajouter prospect",
      "addProspectDesc": "Nouvelle fiche CRM",
      "myProspects": "Mes prospects",
      "myProspectsDesc": "Voir mon pipeline",
      "tasksList": "Liste de tâches",
      "tasksListDesc": "Organiser mes actions",
      "suggestions": {
        "findCoachingProspects": "Trouve-moi des prospects dans le coaching",
        "summarizeRecent": "Résume mes derniers échanges"
      }
    }
  },
  "calendar": {
    "title": "Calendrier",
    "noEventToday": "Aucun événement ce jour",
    "organization": "Organisation",
    "newEvent": "Nouvel événement",
    "syncWith": "Synchroniser {{providers}}",
    "connectCalendar": "Connecter un calendrier",
    "loading": "Chargement…",
    "syncSuccess": "{{count}} événement(s) importé(s) depuis {{sources}}",
    "syncUpToDate": "Calendriers à jour, aucun nouvel événement",
    "syncError": "Erreur de synchronisation",
    "googleError": "Erreur Google",
    "outlookError": "Erreur Outlook",
    "views": {
      "agenda": "Agenda",
      "month": "Mois",
      "week": "Semaine",
      "day": "Jour"
    },
    "today": "Aujourd'hui",
    "allOrgs": "Toutes les orgs",
    "allAccounts": "Tous",
    "manualAccounts": "Manuels",
    "dateFormat": "EEEE d MMMM yyyy"
  },
  "rules": {
    "title": "Règles & Préférences",
    "summary": "{{count}} règle · {{active}} active · {{learned}} apprise par Thiia",
    "summary_plural": "{{count}} règles · {{active}} actives · {{learned}} apprises par Thiia",
    "intro": "Thiia apprend de vos corrections et feedbacks. Quand vous modifiez un post ou un email, il mémorise vos préférences automatiquement. Vous pouvez aussi ajouter des règles manuellement.",
    "all": "Toutes",
    "empty": "Aucune règle dans cette catégorie.",
    "emptyHint": "Ajoutez une règle manuellement ou laissez Thiia apprendre de vos corrections.",
    "add": "Ajouter une règle",
    "addNew": "Nouvelle règle",
    "category": "Catégorie",
    "ruleTitle": "Titre",
    "ruleTitlePlaceholder": "Ex : Toujours tutoyer les prospects",
    "description": "Description / Détail",
    "descriptionPlaceholder": "Décrivez la règle que Thiia doit suivre…",
    "adding": "Ajout…",
    "addRuleAction": "Ajouter la règle",
    "edit": "Modifier",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "titlePlaceholder": "Titre de la règle",
    "contentPlaceholder": "Contenu de la règle",
    "learnedBadge": "Apprise par Thiia",
    "manualBadge": "Manuelle",
    "deleteTitle": "Supprimer cette règle ?",
    "deleteDescription": "La règle sera définitivement supprimée.",
    "dateFormat": "d MMM yyyy",
    "templatesTitle": "Modèles de règles prêts à l'emploi",
    "templateAdded": "Ajoutée",
    "templateAdd": "Ajouter",
    "templateAdding": "Ajout…",
    "categories": {
      "tone": {
        "label": "Ton de communication",
        "description": "Comment Thiia s'adresse à vos prospects et rédige vos messages"
      },
      "writing": {
        "label": "Style de rédaction",
        "description": "Règles de rédaction pour posts, newsletters et articles"
      },
      "search": {
        "label": "Critères de recherche",
        "description": "Filtres et préférences pour la prospection automatique"
      },
      "reports": {
        "label": "Comptes rendus",
        "description": "Instructions pour la génération de comptes rendus IA (format, structure, ton, longueur…)"
      },
      "general": {
        "label": "Général",
        "description": "Préférences générales pour Thiia"
      },
      "email_learned_pattern": {
        "label": "Analyse emails",
        "description": "Patterns appris des imports et refus de contacts — utilisés pour affiner les futures analyses"
      },
      "email_analysis": {
        "label": "Instructions analyse",
        "description": "Vos instructions personnalisées pour guider la détection de prospects dans vos emails"
      }
    },
    "templates": {
      "session": {
        "title": "Compte-rendu de session coaching",
        "description": "Structure classique pour sessions individuelles"
      },
      "express": {
        "title": "Compte-rendu express (5 lignes max)",
        "description": "Format ultra-court pour un suivi rapide"
      },
      "client": {
        "title": "Compte-rendu à envoyer au client",
        "description": "Version client-friendly, positive et motivante"
      },
      "tracking": {
        "title": "Fiche de suivi détaillée",
        "description": "Suivi complet avec objectifs et indicateurs"
      },
      "group": {
        "title": "Compte-rendu de session groupe",
        "description": "Adapté aux ateliers et sessions collectives"
      }
    },
    "defaultReportTitle": "Format des comptes rendus de session",
    "bulk": {
      "confirmDescription": "Cette action est irréversible.",
      "confirmTitle": "Supprimer les règles sélectionnées ?",
      "deleteSelected": "Supprimer la sélection",
      "deletedOk": "Règles supprimées",
      "deletedPartial": "Certaines règles n'ont pas pu être supprimées",
      "selectAll": "Tout sélectionner",
      "selectedCount": "{{count}} sélectionnées"
    },
    "colActions": "Actions",
    "colCategory": "Catégorie",
    "colDate": "Date",
    "colSource": "Source",
    "colTitle": "Titre",
    "collapse": "Réduire",
    "expand": "Développer",
    "filter": {
      "active": "Actives",
      "allSources": "Toutes les sources",
      "allStatus": "Tous les statuts",
      "clear": "Effacer les filtres",
      "inactive": "Inactives"
    },
    "searchPlaceholder": "Rechercher une règle…"
  },
  "checklists": {
    "title": "Tâches",
    "newList": "Nouvelle liste",
    "namePlaceholder": "Nom de la checklist…",
    "noOrg": "Aucune org",
    "create": "Créer",
    "newListTitle": "Nouvelle liste",
    "sectionPlaceholder": "Nom de la section",
    "header": {
      "allOrganizations": "Toutes les organisations",
      "assignedToMe": "Assignées à moi",
      "assignedToMeTitle": "Tâches qui m'ont été assignées",
      "viewList": "Liste",
      "viewAgenda": "Agenda",
      "viewCalendar": "Calendrier",
      "viewTable": "Tableau",
      "viewTags": "Tags",
      "noSection": "Sans section",
      "groupBy": "Grouper",
      "groupTasks": "Tâches",
      "groupLists": "Listes",
      "groupCrm": "Par fiche"
    }
  },
  "autoSearch": {
    "title": "Veille automatique",
    "subtitle": "Résultats de vos recherches automatiques",
    "creditsOne": "{{count}} crédit recherche",
    "creditsOther": "{{count}} crédits recherche",
    "settings": "Paramètres de la veille",
    "enabled": "Veille automatique",
    "enabledDesc": "Rechercher automatiquement de nouveaux résultats",
    "frequency": "Fréquence",
    "daily": "Quotidienne",
    "weekly": "Hebdomadaire",
    "weeklyDay": "Jour de la semaine",
    "sendHour": "Heure d'envoi du digest",
    "digestDaily": "Thiia lancera vos recherches tous les jours à {{hour}} et vous enverra un email récapitulatif.",
    "digestWeekly": "Thiia lancera vos recherches chaque {{day}} à {{hour}} et vous enverra un email récapitulatif.",
    "launchNow": "Lancer maintenant",
    "settingsUpdated": "Paramètres mis à jour",
    "launchSuccess": "Veille lancée ! Les résultats vont apparaître ci-dessous.",
    "launchError": "Erreur : {{message}}",
    "launchErrorDefault": "Impossible de lancer la veille",
    "empty": "Aucun résultat automatique pour le moment",
    "emptyHint": "Sauvegardez des recherches dans les onglets Événements ou Personnes pour que Thiia les exécute automatiquement.",
    "unreadOne": "{{count}} non lu",
    "unreadOther": "{{count}} non lus",
    "totalResults": "{{count}} résultat(s) total",
    "deleteSelected": "Supprimer ({{count}})",
    "confirmDeleteOne": "Supprimer {{count}} résultat ?",
    "confirmDeleteMany": "Supprimer {{count}} résultats ?",
    "deletedOne": "{{count}} résultat supprimé",
    "deletedMany": "{{count}} résultats supprimés",
    "filterAll": "Tous",
    "filterEvents": "🎯 Événements",
    "filterPersons": "👤 Personnes",
    "colSearch": "Recherche",
    "colType": "Type",
    "colResults": "Résultats",
    "colDate": "Date",
    "selectAll": "Tout sélectionner",
    "select": "Sélectionner",
    "typeEvent": "Événement",
    "typePerson": "Personne",
    "delete": "Supprimer",
    "dateFormat": "d MMM yyyy 'à' HH:mm",
    "shortDateFormat": "d MMM yyyy",
    "colEvent": "Événement",
    "colLocation": "Lieu",
    "colName": "Nom",
    "colJob": "Poste",
    "colCompany": "Entreprise",
    "colCity": "Localisation",
    "importEvent": "Importer dans mes événements",
    "importProspect": "Importer comme prospect",
    "importedEvent": "« {{title}} » importé dans vos événements",
    "importedProspect": "{{name}} ajouté aux prospects",
    "importError": "Erreur : {{message}}",
    "noteBio": "Bio : {{value}}",
    "noteSector": "Secteur : {{value}}",
    "noteLocation": "Localisation : {{value}}",
    "noteRelevance": "Pertinence : {{value}}",
    "sourceLabel": "Source : {{url}}",
    "seeResults": "Voir les résultats de la veille",
    "confirmDeleteDesc": "Cette action est définitive."
  },
  "templates": {
    "title": "Templates",
    "comingSoon": "Les modèles d'emails et de contenu seront implémentés prochainement.",
    "followup": {
      "sectionTitle": "Modèles de relance par défaut",
      "sectionDesc": "Un modèle différent par statut de prospect. Variables :",
      "subject": "Objet",
      "subjectPlaceholder": "Ex: Suivi de notre échange, {{prénom}}",
      "body": "Corps de l'email",
      "bodyPlaceholder": "Ex: Bonjour {{prénom}}, je me permets de revenir vers vous…",
      "save": "Sauvegarder ce modèle",
      "savedToast": "Modèle « {{label}} » sauvegardé ✓",
      "showPreview": "Voir l'aperçu",
      "hidePreview": "Masquer l'aperçu",
      "previewWith": "Aperçu — {{name}}",
      "previewFictive": "Aperçu — données fictives",
      "fictiveData": "Données fictives",
      "statuses": {
        "nouveau": "Nouveau",
        "contacte": "Contacté",
        "en_discussion": "En discussion"
      }
    }
  },
  "personSearch": {
    "title": "Recherche de personnes",
    "subtitle": "Trouvez et qualifiez des contacts via recherche IA"
  },
  "eventsSearch": {
    "title": "Recherche d'événements"
  },
  "publicNav": {
    "home": "Accueil",
    "freeTrial": "Essai gratuit",
    "useCases": "Cas d'usage",
    "legal": "Mentions légales",
    "privacy": "Confidentialité",
    "contact": "Contact"
  },
  "publicFooter": {
    "rights": "© {{year}} Thiia — KREAPP SAS. Tous droits réservés. Fait avec ❤️ en France 🇫🇷"
  },
  "useCases": {
    "badge": "Cas d'usage",
    "heroTitle": "Thiia s'adapte à",
    "heroTitleAccent": "votre métier",
    "heroSubtitle": "Découvrez comment les entrepreneurs, coachs et indépendants utilisent Thiia au quotidien pour développer leur activité.",
    "challengesTitle": "Vos défis quotidiens",
    "sharedBadge": "Pour tous les profils",
    "sharedTitle": "Des fonctionnalités",
    "sharedTitleAccent": "communes à tous",
    "ctaTitle": "Prêt à transformer votre prospection ?",
    "ctaSubtitle": "Essayez Thiia gratuitement et découvrez comment l'IA peut accélérer votre développement commercial.",
    "ctaButton": "Commencer gratuitement",
    "sharedFeatures": [
      "IA souveraine française (Mistral AI)",
      "Application installable (PWA) avec mode offline",
      "Client email Gmail & Outlook intégré",
      "Chat collaboratif avec annotations en temps réel",
      "Bibliothèque documentaire IA par prospect",
      "Imports cloud (Google Drive, OneDrive, Dropbox)",
      "Données hébergées en France, conformes RGPD",
      "Support multi-organisations"
    ],
    "personas": {
      "entrepreneur": {
        "title": "Entrepreneur",
        "subtitle": "Startups, PME, dirigeants",
        "description": "Vous lancez ou développez votre entreprise et devez jongler entre prospection, gestion de contacts et création de contenu — sans équipe marketing dédiée.",
        "challenges": [
          "Identifier et qualifier rapidement des prospects B2B",
          "Gérer un pipeline de vente sans CRM complexe",
          "Créer du contenu professionnel régulièrement",
          "Automatiser les relances et le suivi commercial"
        ],
        "useCases": [
          {
            "title": "Veille sectorielle automatisée",
            "description": "Programmez une veille quotidienne sur votre marché. Thiia vous alerte automatiquement quand une entreprise correspond à votre cible (levée de fonds, recrutement, nouveau projet)."
          },
          {
            "title": "Prospection par email intelligente",
            "description": "Analysez vos emails Gmail/Outlook pour détecter automatiquement des opportunités commerciales cachées dans vos échanges existants."
          },
          {
            "title": "Pipeline commercial visuel",
            "description": "Suivez chaque prospect dans un Kanban intuitif : du premier contact à la signature. Notes, rappels et séquences de relance automatiques."
          },
          {
            "title": "Contenu marketing en un clic",
            "description": "Générez des posts LinkedIn, newsletters et articles de blog adaptés à votre audience grâce à l'IA, avec publication directe."
          },
          {
            "title": "Bibliothèque documentaire centralisée",
            "description": "Stockez devis, contrats et factures par client. Importez depuis Google Drive, OneDrive ou Dropbox. Retrouvez n'importe quelle clause via la recherche sémantique du chat."
          }
        ],
        "testimonialQuote": "En 3 mois, j'ai identifié 200 prospects qualifiés et signé 15 nouveaux clients. Thiia fait le travail d'une équipe commerciale entière.",
        "testimonialName": "Marc T.",
        "testimonialRole": "Fondateur, startup SaaS B2B"
      },
      "coach": {
        "title": "Coach & Formateur",
        "subtitle": "Coaching, formation, conseil",
        "description": "Vous accompagnez des professionnels ou des équipes et avez besoin de remplir vos sessions, gérer vos coachés et communiquer efficacement.",
        "challenges": [
          "Trouver de nouveaux coachés/apprenants",
          "Gérer les inscriptions à vos ateliers et webinaires",
          "Personnaliser le suivi de chaque client",
          "Maintenir une présence en ligne régulière"
        ],
        "useCases": [
          {
            "title": "Gestion d'événements et inscriptions",
            "description": "Créez vos ateliers, webinaires et formations. QR codes d'inscription, rappels automatiques J-1 et H-1, et suivi des participants."
          },
          {
            "title": "Suivi personnalisé des coachés",
            "description": "Fiche prospect complète avec notes, enregistrements de séances (Zoom/Teams), transcriptions et historique des échanges email."
          },
          {
            "title": "Bien-être et prévention du burnout",
            "description": "Check-in quotidien pour surveiller votre énergie. Thiia analyse vos tendances et vous recommande quand ralentir — essentiel pour les solopreneurs."
          },
          {
            "title": "Assistant de rédaction spécialisé",
            "description": "Thiia apprend votre ton, votre niche et votre audience. Elle rédige des emails, des propositions et du contenu parfaitement alignés avec votre style."
          },
          {
            "title": "Annotations collaboratives sur les analyses",
            "description": "Surlignez les passages clés des analyses IA, ajoutez des commentaires et discutez avec vos co-coachs ou supervisés directement dans la conversation."
          }
        ],
        "testimonialQuote": "J'ai doublé mes inscriptions aux ateliers grâce à la gestion d'événements et aux relances automatiques. Le suivi de chaque coaché est devenu simple.",
        "testimonialName": "Sophie M.",
        "testimonialRole": "Coach en leadership"
      },
      "independant": {
        "title": "Indépendant & Freelance",
        "subtitle": "Consultants, freelances, experts",
        "description": "Vous êtes expert dans votre domaine mais la prospection n'est pas votre métier. Vous cherchez un outil simple pour développer votre activité sans y passer vos journées.",
        "challenges": [
          "Prospecter sans y consacrer trop de temps",
          "Organiser ses contacts et ne rien oublier",
          "Rester visible sur les réseaux professionnels",
          "Gérer son activité et préserver son équilibre"
        ],
        "useCases": [
          {
            "title": "Recherche de prospects en langage naturel",
            "description": "Demandez à Thiia : « Trouve-moi des DRH dans l'industrie pharmaceutique en Île-de-France ». L'IA comprend le contexte et vous livre des résultats qualifiés."
          },
          {
            "title": "Analyse automatique de vos emails",
            "description": "Connectez votre boîte mail. Thiia identifie automatiquement les contacts à potentiel commercial dans vos échanges et les ajoute à votre CRM."
          },
          {
            "title": "Tâches et checklists intelligentes",
            "description": "Créez des listes de tâches liées à vos prospects. Rappels automatiques et suivi de progression pour ne jamais laisser un deal en suspens."
          },
          {
            "title": "Rapports et analyses IA",
            "description": "Générez des rapports détaillés sur vos prospects : activité en ligne, dernières publications, signaux d'achat — le tout en un clic."
          },
          {
            "title": "Tous vos documents à portée de chat",
            "description": "Connectez Drive, OneDrive ou Dropbox. Vos contrats et briefs sont indexés automatiquement : Thiia retrouve la bonne clause en quelques secondes."
          }
        ],
        "testimonialQuote": "Enfin un outil tout-en-un qui comprend les besoins des freelances. J'ai automatisé 80% de ma prospection et je me concentre sur mes missions.",
        "testimonialName": "Thomas D.",
        "testimonialRole": "Consultant indépendant IT"
      }
    }
  },
  "contactPage": {
    "badge": "Contact",
    "heroTitle": "Parlons de votre",
    "heroTitleAccent": "projet",
    "heroSubtitle": "Une question, une demande de démo ou un partenariat ? Notre équipe vous répond sous 24h.",
    "infoTitle": "Nos coordonnées",
    "infoSubtitle": "N'hésitez pas à nous contacter pour toute question sur Thiia, nos offres ou un accompagnement personnalisé.",
    "labelEmail": "Email",
    "labelCompany": "Société",
    "labelAddress": "Adresse",
    "addressValue": "France 🇫🇷",
    "fieldName": "Nom complet *",
    "fieldNamePlaceholder": "Votre nom",
    "fieldEmail": "Email *",
    "fieldEmailPlaceholder": "votre@email.com",
    "fieldSubject": "Sujet *",
    "fieldSubjectPlaceholder": "Objet de votre message",
    "fieldMessage": "Message *",
    "fieldMessagePlaceholder": "Décrivez votre demande...",
    "send": "Envoyer le message",
    "sending": "Envoi en cours...",
    "successTitle": "Message envoyé !",
    "successDescription": "Merci pour votre message. Nous vous répondrons dans les plus brefs délais.",
    "successAction": "Envoyer un autre message",
    "fillAllFields": "Veuillez remplir tous les champs.",
    "sentToast": "Message envoyé avec succès !",
    "sendError": "Erreur lors de l'envoi. Réessayez ou contactez-nous directement par email."
  },
  "dashboardInsights": {
    "gmailTitle": "Insights Gmail",
    "outlookTitle": "Insights Outlook",
    "analyzeButton": "Analyser mes emails",
    "privacyNotice": "Analyse confidentielle – vos données ne sont pas utilisées pour l'entraînement IA",
    "emptyGmail": "Cliquez sur « Analyser mes emails » pour obtenir un résumé IA de vos échanges récents et des suggestions d'actions.",
    "emptyOutlook": "Cliquez sur « Analyser mes emails » pour obtenir un résumé IA de vos échanges Outlook récents et des suggestions d'actions.",
    "emailsAnalyzed": "📧 {{count}} emails analysés (7 derniers jours)",
    "highlights": "Points clés",
    "suggestedActions": "Actions suggérées",
    "starting": "Démarrage...",
    "sessionExpired": "Session expirée",
    "serverError": "Erreur serveur",
    "streamUnavailable": "Stream non disponible",
    "errorTitle": "Erreur",
    "cancelTitle": "Analyse annulée",
    "cancelDescription": "L'analyse des emails a été interrompue.",
    "tokenExpiredTitle": "Token expiré",
    "tokenExpiredDescription": "Veuillez reconnecter Outlook dans les Paramètres.",
    "priorityLabel": {
      "high": "Urgent",
      "medium": "Important",
      "low": "Conseil"
    }
  },
  "wellbeing": {
    "title": "Bien-être",
    "subtitle": "Suivez votre équilibre et prévenez le burnout",
    "loadScore": "Score de charge",
    "stats": "Statistiques",
    "checkins": "Check-ins",
    "avgMood": "Humeur moy. /5",
    "moods": {
      "great": "Super",
      "good": "Bien",
      "neutral": "Neutre",
      "stressed": "Stressé",
      "burned_out": "Épuisé"
    },
    "levels": {
      "green": "Charge modérée",
      "orange": "Charge élevée",
      "red": "Surcharge détectée"
    },
    "personalTips": "Conseils personnalisés",
    "moodEvolution": "Évolution de l'humeur — 30 derniers jours",
    "checkinsHistory": "Historique des check-ins",
    "noCheckins": "Aucun check-in pour le moment. Rendez-vous dans le Chat pour enregistrer votre première humeur ! 💜",
    "antiburnoutResources": "Ressources anti-burnout",
    "noneMood": "Aucun",
    "historyDateFormat": "EEEE d MMMM yyyy 'à' HH:mm",
    "checkin": {
      "promptUrgent": "💜 Ça fait un moment ! Comment allez-vous vraiment ?",
      "promptDaily": "💜 Comment allez-vous aujourd'hui ?",
      "notePlaceholder": "Un mot sur votre journée ? (optionnel)"
    },
    "widget": {
      "title": "Bien-être",
      "loadLevel": "Niveau de charge",
      "recentMood": "Humeur récente",
      "factors": "Facteurs détectés",
      "tips": "💡 Conseils"
    },
    "factors": {
      "eventsHigh": "{{count}} événements cette semaine (élevé)",
      "events": "{{count}} événements cette semaine",
      "prospectsVeryHigh": "{{count}} prospects actifs (très élevé)",
      "prospects": "{{count}} prospects actifs",
      "lateMessagesHigh": "{{count}} messages envoyés après 21h cette semaine",
      "lateMessages": "{{count}} messages envoyés après 21h",
      "burnedOut": "Vous avez indiqué vous sentir épuisé(e)",
      "stressed": "Vous avez indiqué vous sentir stressé(e)",
      "moodDeclining": "Votre humeur a baissé ces derniers jours"
    },
    "tipsList": {
      "eventsHigh": "Vous avez beaucoup de RDV cette semaine. Pensez à bloquer du temps pour vous reposer.",
      "events": "Semaine bien remplie ! Gardez des créneaux pour souffler.",
      "prospectsVeryHigh": "Beaucoup de prospects en cours. Priorisez les plus prometteurs pour ne pas vous disperser.",
      "lateMessagesHigh": "Vous travaillez souvent tard. Essayez de déconnecter plus tôt pour un meilleur repos.",
      "burnedOut": "Votre bien-être est prioritaire. Accordez-vous une vraie pause aujourd'hui.",
      "stressed": "Prenez quelques minutes de respiration ou de marche pour réduire le stress.",
      "moodDeclining": "Votre moral semble en baisse. Parlez-en à un proche ou prenez du recul sur vos objectifs.",
      "default": "Tout semble bien ! Continuez à prendre soin de vous. 🌟"
    },
    "notifications": {
      "redTitle": "⚠️ Score de charge critique",
      "orangeTitle": "🟠 Charge en hausse",
      "redBody": "Votre score de charge est à {{score}}%. {{tip}}",
      "orangeBody": "Votre score de charge atteint {{score}}%. Pensez à ralentir avant que la situation ne s'aggrave.",
      "defaultTip": "Prenez soin de vous."
    },
    "resources": {
      "pomodoro": {
        "title": "Technique Pomodoro",
        "description": "Travaillez 25 minutes, puis faites une pause de 5 minutes. Après 4 cycles, prenez 15-30 minutes de pause.",
        "category": "Productivité",
        "actionLabel": "Planifier avec Thiia",
        "chatPrompt": "Aide-moi à organiser ma journée avec la technique Pomodoro. Propose-moi un planning adapté à mes tâches."
      },
      "disconnect": {
        "title": "Déconnexion digitale",
        "description": "Définissez des heures sans écran. Coupez les notifications après 20h pour protéger votre récupération mentale.",
        "category": "Déconnexion"
      },
      "mindfulness": {
        "title": "Pleine conscience",
        "description": "5 minutes de méditation ou de respiration profonde par jour réduisent significativement le stress et l'anxiété.",
        "category": "Mental",
        "actionLabel": "Exercice guidé par Thiia",
        "chatPrompt": "Guide-moi dans un exercice de respiration ou de pleine conscience de 5 minutes pour réduire mon stress."
      },
      "aiAnxiety": {
        "title": "Anxiété liée à l'IA",
        "description": "L'IA est un outil, pas un remplacement. Concentrez-vous sur ce que vous faites mieux : l'empathie, la créativité, les relations humaines.",
        "category": "IA & Bien-être",
        "actionLabel": "En parler avec Thiia",
        "chatPrompt": "J'ai parfois de l'anxiété par rapport à l'IA. Aide-moi à comprendre comment bien l'utiliser sans me sentir menacé."
      },
      "overtime": {
        "title": "Limiter les heures sup'",
        "description": "Fixez-vous une heure de fin de journée et respectez-la. La surcharge chronique mène au burnout en quelques semaines.",
        "category": "Limites"
      },
      "talk": {
        "title": "Parler à quelqu'un",
        "description": "Partagez vos difficultés avec un proche, un pair ou un professionnel. L'isolement amplifie le stress.",
        "category": "Support"
      },
      "prioritize": {
        "title": "Prioriser plutôt qu'accumuler",
        "description": "Identifiez chaque matin vos 3 priorités. Déléguez ou reportez le reste. Mieux vaut avancer sur peu que stagner sur tout.",
        "category": "Organisation",
        "actionLabel": "Prioriser avec Thiia",
        "chatPrompt": "Aide-moi à identifier mes 3 priorités du jour et à organiser le reste de mes tâches."
      },
      "journaling": {
        "title": "Journaling",
        "description": "Notez chaque soir 3 choses positives de votre journée. Cette pratique améliore le bien-être et la résilience.",
        "category": "Habitudes",
        "actionLabel": "Journaling avec Thiia",
        "chatPrompt": "Aide-moi à faire mon exercice de journaling : je veux noter 3 choses positives de ma journée et réfléchir à ce que j'ai appris."
      }
    }
  },
  "scheduledEmails": {
    "title": "Emails programmés",
    "filterAll": "Tous",
    "filterPending": "Programmés",
    "filterSent": "Envoyés",
    "filterFailed": "Échoués",
    "status": {
      "pending": "Programmé",
      "sent": "Envoyé",
      "failed": "Échoué",
      "cancelled": "Annulé"
    },
    "emailCancelled": "Email annulé",
    "emailDeleted": "Email supprimé",
    "emailUpdated": "Email mis à jour",
    "dateFutureError": "La date doit être dans le futur",
    "dateUpdated": "Date de l'email mise à jour",
    "emptyTitle": "Aucun email {{label}}",
    "emptyHelp": "Programmez un email depuis la fiche d'un prospect pour le voir ici.",
    "noSubject": "Sans objet",
    "step": "Étape {{n}}",
    "deletedProspect": "Prospect supprimé",
    "scheduledFor": "Programmé pour le ",
    "sentOn": "Envoyé le ",
    "plannedFor": "Prévu le ",
    "rescheduleTitle": "Reprogrammer l'envoi",
    "datePlaceholder": "Date",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "preview": "Prévisualiser",
    "reschedule": "Reprogrammer",
    "cancelSending": "Annuler l'envoi",
    "delete": "Supprimer",
    "deleteConfirmTitle": "Supprimer cet email ?",
    "deleteConfirmDesc": "Cette action est irréversible. L'email sera définitivement supprimé de l'historique.",
    "editTitle": "Modifier l'email",
    "previewTitle": "Prévisualisation de l'email",
    "recipient": "Destinataire",
    "company": "Entreprise",
    "statusLabel": "Statut",
    "date": "Date",
    "subject": "Objet",
    "subjectPlaceholder": "Objet de l'email",
    "body": "Corps du message",
    "bodyPlaceholder": "Contenu de l'email...",
    "noContent": "Aucun contenu",
    "save": "Enregistrer",
    "edit": "Modifier",
    "actionsFor": "Actions pour {{name}}",
    "colActions": "Actions",
    "colDate": "Date d'envoi",
    "colProspect": "Destinataire",
    "colSource": "Source",
    "colSubject": "Objet",
    "collapse": "Réduire",
    "collapseAll": "Tout réduire",
    "collapseAllHint": "Réduire tous les groupes",
    "details": "Détails",
    "expand": "Développer",
    "expandAll": "Tout développer",
    "expandAllHint": "Développer tous les groupes",
    "groupBulkSend": "Envoi groupé",
    "groupInnerSortChrono": "Chronologique",
    "groupInnerSortHint": "Trier les e-mails à l'intérieur du groupe",
    "groupInnerSortRecent": "Plus récents d'abord",
    "groupRecipients": "Destinataires",
    "groupSortHint": "Trier les groupes",
    "openMenu": "Ouvrir le menu",
    "openMenuFor": "Ouvrir le menu pour {{name}}",
    "openProspectHistory": "Voir l'historique du prospect",
    "sortActiveLabel": "Tri actif",
    "sortByDate": "Par date",
    "sortByDateHelp": "Trier par date d'envoi.",
    "sortGroupsFirst": "Groupes en premier",
    "sortGroupsFirstHelp": "Afficher d'abord les envois groupés.",
    "sortGroupsRecent": "Groupes récents",
    "sortGroupsRecentHelp": "Trier les groupes du plus récent au plus ancien.",
    "sortHelpLabel": "Aide au tri",
    "sortHelpTitle": "Options de tri",
    "sortReset": "Réinitialiser le tri",
    "sortResetHint": "Revenir au tri par défaut.",
    "sourceImmediate": "Immédiat",
    "sourceImmediateHint": "E-mail envoyé sans délai.",
    "sourceScheduled": "Planifié",
    "sourceScheduledHint": "E-mail planifié pour un envoi ultérieur."
  },
  "linkedinHistory": {
    "title": "Historique LinkedIn"
  },
  "contactsPage": {
    "title": "Carnet de contacts",
    "countOne": "{{count}} contact email",
    "countOther": "{{count}} contacts email",
    "addButton": "Ajouter",
    "newContact": "Nouveau contact",
    "emailLabel": "Email *",
    "nameLabel": "Nom",
    "namePlaceholder": "Jean Dupont",
    "adding": "Ajout…",
    "contactExists": "Ce contact existe déjà",
    "contactAdded": "Contact ajouté ✓",
    "instructionsTitle": "Instructions analyse emails",
    "instructionsSaved": "Instructions sauvegardées ✓",
    "serverError": "Erreur serveur",
    "analyzeError": "Erreur d'analyse",
    "notAuthenticated": "Non authentifié",
    "starting": "Démarrage...",
    "errorGeneric": "Erreur",
    "rejectTitle": "Refuser ce contact",
    "rejectQuestion": "Pourquoi refusez-vous {{name}} ?",
    "rejectPlaceholder": "Ex: C'est un fournisseur, pas un prospect. / Contact interne de mon entreprise. / Démarchage commercial non sollicité...",
    "rejectHelp": "Cette raison sera enregistrée pour améliorer les futures analyses.",
    "cancel": "Annuler",
    "reject": "Refuser",
    "rejectedToast": "Contact refusé",
    "rejectedToastDesc": "La raison sera prise en compte pour les prochaines analyses.",
    "rejectedTag": "Refusé",
    "alreadyProspect": "Déjà prospect",
    "detectTitle": "Détecter des prospects depuis vos emails",
    "detectSubtitle": "Analysez vos emails récents pour identifier des contacts qui ne sont pas encore clients",
    "viewRules": "Voir les règles",
    "mobileTitle": "Contacts détectés",
    "mobileSubtitle": "Depuis vos emails · {{count}} profils",
    "whyLabel": "Pourquoi",
    "importOptions": "Options d'import",
    "filterToSort": "À trier",
    "filterAlreadyProspects": "Déjà prospects",
    "filterDismissed": "Écartés",
    "dismiss": "Écarter",
    "privacyNote": "Analyse confidentielle – vos données ne sont pas utilisées pour l'entraînement IA",
    "customInstructions": "Instructions personnalisées pour l'IA",
    "instructionsPlaceholder": "Ex: Considère comme prospect toute personne qui mentionne un budget supérieur à 5000€, ou qui demande un audit. Ignore les contacts @monentreprise.fr car ce sont des collègues...",
    "instructionsHelp": "Ces instructions guident l'IA dans la détection de vos prospects",
    "save": "Sauvegarder",
    "analyzeGmail": "Analyser Gmail",
    "analyzeOutlook": "Analyser Outlook",
    "connectMailbox": "Connecter Gmail ou Outlook",
    "contactsIdentifiedOne": "{{count}} contact identifié !",
    "contactsIdentifiedOther": "{{count}} contacts identifiés !",
    "noNewProspect": "Aucun nouveau prospect détecté",
    "emailsAnalyzed": "{{count}} emails analysés",
    "newCount": "{{count}} nouveau(x)",
    "alreadyCount": "{{count}} déjà existant(s)",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "import": "Importer",
    "importError": "Erreur d'import",
    "prospectImported": "Prospect importé ✓",
    "prospectsImported": "{{count}} prospect(s) importé(s) ✓",
    "type": "Type :",
    "typeProspect": "Prospect",
    "typeClient": "Client",
    "typePartner": "Partenaire",
    "typeOther": "Autre…",
    "typeCustomPlaceholder": "Précisez…",
    "tags": "Tags :",
    "tagsPlaceholder": "gmail-import, à relancer",
    "searchContact": "Rechercher un contact…",
    "filterAll": "Tous",
    "filterNew": "Nouveaux",
    "filterExisting": "Existants",
    "filterRejected": "Refusés",
    "sortEmailsDesc": "Emails ↓",
    "sortEmailsAsc": "Emails ↑",
    "sortNameAsc": "Nom A-Z",
    "sortNameDesc": "Nom Z-A",
    "noProspectDetected": "Aucun prospect potentiel détecté dans vos emails récents.",
    "noResults": "Aucun résultat pour ces critères.",
    "tableName": "Nom",
    "tableEmail": "Email",
    "tableReason": "Raison IA",
    "tableEmails": "Emails",
    "tableActions": "Actions",
    "viewInMailbox": "Voir dans la messagerie",
    "previous": "Précédent",
    "next": "Suivant",
    "paginationOf": "{{from}}-{{to}} sur {{total}}",
    "listSearchPlaceholder": "Rechercher un nom ou un email…",
    "listEmpty": "Aucun contact pour le moment.",
    "listNoResults": "Aucun contact ne correspond à votre recherche.",
    "listResults": "{{count}} résultat(s)",
    "deleteTitle": "Supprimer ce contact ?",
    "deleteDesc": "{{email}} sera retiré de votre carnet de contacts.",
    "delete": "Supprimer",
    "accountsLabel": "Analyser un compte",
    "detectSectionTitle": "Détecter des contacts depuis mes emails",
    "sourceHint": "Ces contacts sont détectés automatiquement dans vos emails.",
    "analyzeCta": "Analyser mes emails",
    "criteriaCta": "Critères"
  },
  "tour": {
    "buttons": {
      "back": "Précédent",
      "close": "Fermer",
      "last": "Terminer",
      "next": "Suivant",
      "skip": "Passer"
    },
    "welcome": {
      "title": "Bienvenue sur Thiia 👋",
      "description": "Découvrez en quelques étapes les fonctionnalités clés de votre agent de prospection IA."
    },
    "chatCta": {
      "title": "Le Chat Thiia",
      "description": "Votre point d'entrée principal : posez vos questions, lancez des recherches ou demandez à Thiia d'agir pour vous."
    },
    "history": {
      "title": "Historique des conversations",
      "description": "Retrouvez toutes vos conversations, organisez-les en dossiers et recherchez à l'intérieur."
    },
    "annotations": {
      "title": "Annotations",
      "description": "Sélectionnez du texte dans n'importe quel message pour ajouter des notes contextuelles à votre IA."
    },
    "prospectSearch": {
      "title": "Recherche de prospects",
      "description": "Demandez à Thiia : « Trouve-moi 10 dirigeants de PME tech à Lyon » — elle s'occupe du reste."
    },
    "prospects": {
      "title": "Base Prospects",
      "description": "Votre CRM intégré : pipeline Kanban, fiches détaillées et notes enrichies par l'IA."
    },
    "searchHub": {
      "title": "Recherche & Veille",
      "description": "Recherche sémantique de personnes, entreprises et événements en temps réel."
    },
    "emails": {
      "title": "Emails",
      "description": "Lisez, répondez et générez des emails IA depuis Gmail ou Outlook directement dans Thiia."
    },
    "settingsGeneral": {
      "title": "Paramètres généraux",
      "description": "Profil, organisation, langue et personnalisation de votre compte."
    },
    "settingsIntegrations": {
      "title": "Intégrations",
      "description": "Connectez Gmail, Outlook, LinkedIn, HubSpot, Zoom et plus encore.",
      "mailbox": "Messagerie & agenda (Gmail ou Outlook)",
      "linkedin": "LinkedIn (publication de posts)",
      "connected": "Connecté",
      "notConnected": "À connecter",
      "connectHint": "Vous pouvez connecter vos services maintenant depuis les cartes à côté, puis continuer la visite.",
      "allConnectedHint": "Tout est connecté 🎉 Vous pouvez continuer la visite."
    },
    "finish": {
      "title": "Prêt à prospecter avec Thiia 🚀",
      "description": "Vous avez fait le tour ! Démarrez votre première conversation pour mettre Thiia au travail.",
      "secondary": "Voir la documentation"
    }
  },
  "settings": {
    "title": "Paramètres",
    "signOut": "Se déconnecter",
    "privacy": {
      "legalDocs": "Documents légaux",
      "legal": "Mentions légales",
      "privacyPolicy": "Politique de confidentialité",
      "terms": "Conditions d'utilisation",
      "portabilityTitle": "Droit à la portabilité des données",
      "portabilityDesc": "Conformément à l'article 20 du RGPD, vous pouvez exporter l'intégralité de vos données personnelles dans un format structuré et lisible (JSON). Cet export comprend votre profil, vos prospects, notes, emails, événements, contenus et conversations.",
      "exportAll": "Exporter toutes mes données",
      "exportDone": "Export terminé",
      "exportDoneDesc": "Vos données ont été téléchargées au format JSON.",
      "aiPrivacyTitle": "Confidentialité de l'IA",
      "aiPrivacyDesc": "Vos données ne sont <strong>jamais utilisées pour entraîner les modèles d'intelligence artificielle</strong>. Thiia utilise Mistral AI, un moteur souverain français. Les données transmises à l'IA sont traitées de manière éphémère et ne sont ni stockées ni réutilisées par le fournisseur du modèle.",
      "deleteTitle": "Droit à l'effacement",
      "deleteDesc": "Conformément à l'article 17 du RGPD, vous pouvez demander la suppression de l'ensemble de vos données personnelles. Cette action est <strong>irréversible</strong> : votre profil, vos prospects, notes, emails, événements, contenus et conversations seront définitivement supprimés.",
      "deleteAccount": "Supprimer mon compte et mes données",
      "deleteConfirmTitle": "Supprimer définitivement votre compte ?",
      "deleteConfirmDesc1": "Cette action est <strong>irréversible</strong>. Toutes vos données seront supprimées : profil, prospects, notes, emails, événements, contenus et conversations.",
      "deleteConfirmDesc2": "Nous vous recommandons d'<strong>exporter vos données</strong> avant de procéder.",
      "typeToConfirm": "Tapez <strong>SUPPRIMER</strong> pour confirmer :",
      "deletePlaceholder": "SUPPRIMER",
      "deletePermanently": "Supprimer définitivement",
      "accountDeleted": "Compte supprimé",
      "accountDeletedDesc": "Toutes vos données ont été effacées. Vous allez être déconnecté.",
      "securityCenter": "Centre de sécurité",
      "subprocessors": "Sous-traitants",
      "portabilityShort": "Exportez toutes vos données personnelles au format JSON.",
      "portabilityMore": "En savoir plus",
      "noticeTitle": "Mention RGPD (premier contact)",
      "noticeShort": "Mention insérée en bas de vos emails de premier contact.",
      "noticeSubject": "Votre offre / sujet",
      "noticeContact": "Email de contact RGPD",
      "noticePreview": "Aperçu de la mention insérée",
      "dataTitle": "Vos données",
      "exportRowDesc": "Prospects, emails, comptes rendus, documents et règles, au format JSON (environ {{size}}). Si la préparation dépasse une minute, le fichier vous est envoyé par email.",
      "prepareExport": "Préparer l'export",
      "exportProgress": "Préparation de l'export… {{percent}} %",
      "trainingTitle": "Entraînement des modèles",
      "trainingBadge": "Désactivé par défaut",
      "trainingDesc": "Vos données ne sont jamais utilisées pour entraîner des modèles.",
      "recordingRetention": "Conservation des enregistrements",
      "recordingRetentionDesc": "Les audios de réunion sont supprimés après transcription.",
      "recording0": "Supprimés après transcription",
      "recording7": "Conservés 7 jours",
      "recording30": "Conservés 30 jours",
      "recording90": "Conservés 90 jours",
      "deleteRowDesc": "La suppression efface votre compte, les données associées et votre accès à l'application. Elle est exécutée côté serveur en une seule transaction : elle aboutit entièrement ou elle est annulée. Elle est irréversible."
    },
    "video": {
      "title": "Visioconférence par défaut",
      "description": "Choisissez le fournisseur de visioconférence utilisé par défaut pour vos rendez-vous. Vous pourrez toujours changer au cas par cas.",
      "defaultProvider": "Fournisseur par défaut",
      "none": "Aucun",
      "updated": "Préférence visio mise à jour",
      "defaultProviderHint": "Utilisé quand Thiia crée une réunion depuis un prospect"
    },
    "organizations": {
      "title": "Mes organisations",
      "countOther": "{{count}} organisations",
      "intro": "Ajoutez vos entreprises et associations. L’organisation par défaut est utilisée dans les exports PDF et les emails.",
      "empty": "Aucune organisation ajoutée",
      "default": "Par défaut",
      "setDefault": "Définir par défaut",
      "addCompany": "Ajouter une entreprise ou association",
      "deleteTitle": "Supprimer cette organisation ?",
      "deleteDesc": "L'organisation \"{{name}}\" sera supprimée. Les comptes email associés ne seront pas supprimés.",
      "countOne_one": "{{count}} organisation",
      "countOne_other": "{{count}} organisations",
      "countOne": "{{count}} organisations"
    },
    "integrations": {
      "accountsOther": "{{count}} comptes",
      "default": "Par défaut",
      "setDefault": "Définir par défaut",
      "organization": "Organisation",
      "noOrganization": "Aucune organisation",
      "addAccount": "Ajouter un compte",
      "syncCalendars": "Synchroniser les agendas",
      "readOnly": "Accès sécurisé — Thiia peut lire et envoyer des emails, mais ne modifie ni ne supprime rien dans votre boîte.",
      "connect": "Connecter {{provider}}",
      "disconnected": "Déconnecté",
      "disconnectedDesc": "Compte {{email}} déconnecté.",
      "defaultUpdated": "Compte par défaut mis à jour",
      "connected": "{{provider}} connecté ✓",
      "connectedDesc": "Compte {{email}} ajouté.",
      "connectError": "Erreur de connexion {{provider}}",
      "notConfigured": "{{provider}} OAuth non configuré.",
      "tokenError": "Impossible d'échanger le token",
      "calendarSynced": "Calendrier synchronisé ✓",
      "calendarSyncedDesc": "{{count}} événement(s) importé(s).",
      "analysisDone": "Analyse terminée ✓",
      "importPartial": "Import partiel ⚠️",
      "importError": "Erreur d'import",
      "analysisError": "Erreur d'analyse",
      "emailsAnalyzed": "{{count}} emails analysés",
      "prospectsCreated": "{{count}} prospect(s) créé(s)",
      "duplicatesSkipped": "{{count}} doublon(s) ignoré(s)",
      "failures": "{{count}} échec(s)",
      "noNewProspects": "aucun nouveau prospect détecté",
      "outlookReadOnly": "Accès sécurisé — Thiia lit vos emails et votre agenda Microsoft, sans rien modifier ni supprimer.",
      "fetchRecordings": "Récupérer enregistrements Teams",
      "recordingsFetched": "Enregistrements récupérés ✓",
      "recordingsFetchedDesc": "{{count}} enregistrement(s) sauvegardé(s).",
      "linkedin": {
        "name": "LinkedIn",
        "description": "Connectez votre compte LinkedIn pour publier des posts directement.",
        "subtitle": "LinkedIn",
        "explanation": "Connectez votre compte LinkedIn pour partager vos publications et importer vos contacts.",
        "connect": "Connecter LinkedIn",
        "connected": "Compte LinkedIn connecté",
        "connectedDesc": "Vos publications peuvent être publiées automatiquement.",
        "apiConnected": "API connectée",
        "apiSection": "Connexion API",
        "connectedAs": "Connecté en tant que {{name}}",
        "connectedNoName": "Connecté",
        "defaultUser": "Utilisateur",
        "connectError": "Impossible de lancer la connexion LinkedIn.",
        "notConfigured": "Non configuré",
        "notConfiguredDesc": "Ajoutez vos liens LinkedIn pour activer le partage.",
        "startError": "Erreur au démarrage de la connexion.",
        "disconnected": "Compte LinkedIn déconnecté",
        "disconnect": "Déconnecter",
        "saved": "URLs LinkedIn enregistrées.",
        "linkRemoved": "Lien supprimé.",
        "personalProfile": "Profil personnel",
        "companyPage": "Page entreprise",
        "saveUrls": "Enregistrer les liens",
        "successMessage": "Connexion LinkedIn réussie.",
        "orgsFetchWarning": "Pages entreprise indisponibles",
        "orgsFetchWarningDesc": "La connexion a réussi, mais la liste de vos pages entreprise n'a pas pu être récupérée. Réessayez plus tard.",
        "history": "Historique",
        "dialogTitle": "Gérer LinkedIn",
        "scopeNote": "Publication et lecture"
      },
      "zoom": {
        "name": "Zoom",
        "description": "Connectez votre compte Zoom pour récupérer les enregistrements et transcriptions de vos réunions.",
        "connected": "Compte Zoom connecté",
        "connectedDesc": "Vos réunions peuvent être créées automatiquement.",
        "disconnectedDesc": "Connectez Zoom pour créer des réunions.",
        "recordingsTitle": "Enregistrements",
        "recordingsDesc": "Accédez à vos enregistrements Zoom ici.",
        "readOnly": "Lecture seule",
        "dialogTitle": "Gérer Zoom",
        "disconnect": "Déconnecter"
      },
      "hubspot": {
        "description": "Synchronisez contacts, opportunités, tâches et activités entre HubSpot et Thiia.",
        "account": "Compte",
        "contacts": "Contacts",
        "deals": "Deals",
        "tasks": "Tâches",
        "autoSyncSection": "Synchronisation auto",
        "dailySync": "Sync quotidienne",
        "importDeals": "Importer les deals",
        "importTasks": "Importer les tâches",
        "pushActivities": "Pousser notes & emails",
        "lastSync": "Dernière sync : {{date}}",
        "lastSyncFormat": "d MMM yyyy 'à' HH:mm",
        "permissionsNote": "Lecture/écriture contacts, lecture deals & tâches, push d'activités vers la timeline.",
        "syncContacts": "Sync contacts",
        "syncContactsDone": "Contacts synchronisés",
        "syncContactsDoneDesc": "{{imported}} importés · {{updated}} mis à jour · {{exported}} exportés",
        "syncExtras": "Sync deals & tâches",
        "syncExtrasDone": "Deals & tâches synchronisés",
        "syncExtrasDoneDesc": "{{deals}} deals · {{tasks}} tâches",
        "connected": "HubSpot connecté ✓",
        "connectError": "Erreur HubSpot",
        "notConfigured": "HubSpot OAuth non configuré.",
        "name": "HubSpot",
        "scopeNote": "Thiia ne supprime rien"
      },
      "searchPlaceholder": "Rechercher une intégration...",
      "noResults": "Aucune intégration ne correspond à votre recherche.",
      "resetFilters": "Réinitialiser les filtres",
      "categories": {
        "all": "Toutes",
        "emailCalendar": "E-mail et agenda",
        "video": "Visioconférence",
        "social": "Réseaux sociaux",
        "storage": "Stockage",
        "documents": "Éditeurs de documents",
        "crm": "CRM",
        "import": "Import de données",
        "voice": "Commandes vocales",
        "finance": "Banque & comptabilité"
      },
      "gmail": {
        "name": "Gmail",
        "description": "Lisez, envoyez des emails et synchronisez votre agenda Google depuis Thiia."
      },
      "office365": {
        "name": "Outlook / Office 365",
        "description": "Lisez vos emails et synchronisez votre agenda et vos réunions Microsoft."
      },
      "imap": {
        "name": "Email IMAP/SMTP",
        "description": "Connectez une boîte email personnalisée via IMAP et SMTP."
      },
      "googleMeet": {
        "name": "Google Meet",
        "description": "Générez des liens Google Meet pour vos rendez-vous."
      },
      "defaultVideo": {
        "name": "Fournisseur visio par défaut",
        "description": "Choisissez votre outil de visioconférence par défaut."
      },
      "instagram": {
        "description": "Publiez et planifiez vos posts Instagram directement depuis Thiia."
      },
      "facebook": {
        "description": "Connectez votre page Facebook pour publier et analyser votre audience."
      },
      "googleDrive": {
        "name": "Google Drive",
        "description": "Importez des documents depuis Google Drive pour enrichir vos prospects.",
        "scopeNote": "Lecture seule",
        "orgUpdated": "Organisation mise à jour",
        "explanation": "Google Drive est disponible via vos comptes Google connectés. Associez chaque compte à une organisation pour cloisonner les documents.",
        "noOrgsHint": "Créez des organisations pour associer chaque compte Google à une entité distincte.",
        "connectViaEmail": "Connectez votre compte Google dans la section Email & Calendrier pour activer Google Drive automatiquement."
      },
      "onedrive": {
        "description": "Connectez OneDrive pour synchroniser vos fichiers professionnels Microsoft."
      },
      "dropbox": {
        "description": "Importez vos documents stockés sur Dropbox dans Thiia."
      },
      "googleDocs": {
        "description": "Ouvrez vos documents exportés directement dans Google Docs pour les éditer en ligne."
      },
      "documents": {
        "hint": "Une fois connecté, vos exports Word/PDF depuis le chat pourront s'ouvrir directement dans l'éditeur en ligne."
      },
      "microsoftWord": {
        "name": "Microsoft Word Online",
        "description": "Vos exports Word depuis le chat peuvent être déposés sur OneDrive et ouverts dans Word Online.",
        "scopeNote": "Lecture/écriture fichiers",
        "connectError": "Erreur de connexion Word Online",
        "exchangeError": "Impossible d'échanger le code OAuth.",
        "connected": "Word Online connecté",
        "notConfigured": "Azure n'est pas configuré.",
        "accountDisconnected": "Compte déconnecté",
        "reconnect": "Reconnecter / ajouter un compte",
        "connectCta": "Connecter Word Online"
      },
      "gamma": {
        "name": "Gamma.app",
        "description": "Générez automatiquement des présentations, documents ou posts visuels depuis vos exports.",
        "scopeNote": "Nécessite un plan Gamma Pro",
        "apiKeyRequired": "Clé API requise",
        "saved": "Gamma.app enregistré",
        "enterKeyToTest": "Saisissez une clé API à tester",
        "keyValid": "Clé API valide ✓",
        "keyInvalid": "Clé API invalide",
        "checkKeyOnSite": "Vérifiez votre clé sur gamma.app",
        "disconnected": "Gamma.app déconnecté",
        "apiKey": "Clé API",
        "keepCurrentKey": "Laisser vide pour conserver la clé actuelle",
        "hide": "Masquer",
        "show": "Afficher",
        "test": "Tester",
        "getKeyLink": "Obtenir une clé sur gamma.app",
        "defaultFormat": "Format par défaut",
        "formatPresentation": "Présentation",
        "formatDocument": "Document",
        "formatSocial": "Post social",
        "defaultTheme": "Thème par défaut",
        "optional": "(optionnel)",
        "myTemplates": "Mes templates",
        "oneNamePerLine": "(un nom par ligne)",
        "templatesPlaceholder": "ex:\nOasis\nAtmosphere\nMon template corporate",
        "templatesHint": "Ces noms apparaîtront dans le sélecteur de thème lors de l'export Gamma.",
        "update": "Mettre à jour",
        "saveCta": "Enregistrer"
      },
      "chatgptImport": {
        "description": "Importez des prospects depuis une conversation ChatGPT."
      },
      "voice": {
        "name": "Commandes vocales",
        "description": "Créez des tokens vocaux et contrôlez Thiia par la voix."
      },
      "connectedShort": "Connecté",
      "notConnected": "Non connecté",
      "dateRange": {
        "14_days": "14 derniers jours",
        "this_month": "Ce mois-ci",
        "3_months": "3 derniers mois",
        "6_months": "6 derniers mois",
        "this_year": "Cette année",
        "last_year": "L'année dernière",
        "2_years": "2 dernières années"
      },
      "whatsapp": {
        "description": "Connectez votre propre numéro WhatsApp Business pour envoyer des messages automatiquement.",
        "name": "WhatsApp Cloud API",
        "dialogTitle": "Gérer WhatsApp Cloud API",
        "scopeNote": "Numéro personnalisé",
        "savedToast": "Configuration WhatsApp enregistrée",
        "genericError": "Erreur",
        "phoneNumberId": "Phone Number ID",
        "accessToken": "Access Token (System User permanent)",
        "configured": "Configuré",
        "businessAccountId": "Business Account ID (WABA) — optionnel",
        "webhookVerifyToken": "Webhook Verify Token — optionnel",
        "activeLabel": "Actif",
        "activeDesc": "Autoriser l'envoi via cette configuration",
        "credentialsNote": "Vos credentials sont chiffrés et visibles uniquement par vous (RLS).",
        "save": "Mettre à jour",
        "saveNew": "Enregistrer",
        "test": "Tester la connexion",
        "testOk": "Connexion Meta validée",
        "testFail": "Échec de la validation",
        "helpText": "Récupérez ces identifiants dans Meta for Developers → votre app → WhatsApp → API Setup.",
        "helpLink": "Meta for Developers",
        "requiredError": "Phone Number ID et Access Token sont requis pour la première configuration.",
        "phoneLabel": "Numéro",
        "verifiedNameLabel": "Nom vérifié",
        "qualityLabel": "Qualité",
        "latencyLabel": "Latence"
      },
      "accountsOne_one": "{{count}} compte",
      "accountsOne_other": "{{count}} comptes",
      "disconnect": "Déconnecter",
      "accountsOne": "{{count}} comptes",
      "status": {
        "summary": "{{connected}} intégrations connectées, {{toReconnect}} à reconnecter",
        "expiredOn": "{{name}} : jeton expiré le {{date}}",
        "expired": "{{name}} : jeton expiré",
        "reconnect": "Reconnecter"
      },
      "soon": {
        "title": "Bientôt disponible",
        "hint": "Aucune action possible pour l'instant"
      },
      "state": {
        "connected": "Connecté",
        "notConnected": "Non connecté",
        "soon": "Bientôt disponible"
      },
      "actions": {
        "connect": "Connecter",
        "manage": "Gérer",
        "reconnect": "Reconnecter"
      },
      "lastSyncShort": "Sync du {{date}}",
      "readOnlyShort": "Lecture seule",
      "noDeleteShort": "Thiia ne supprime rien",
      "moreAccounts": "+{{count}}",
      "manageAccount": "Gérer le compte",
      "googleMeetCard": {
        "description": "Google Meet est disponible automatiquement avec votre compte Google connecté. Aucune connexion séparée n'est requise.",
        "scopeNote": "Inclus avec Google",
        "action": "Connecter Google"
      },
      "clearFilter": "Effacer",
      "qonto": {
        "name": "Qonto",
        "description": "Rattachez automatiquement vos factures fournisseurs aux transactions de votre compte Qonto.",
        "scopeNote": "Lecture seule + ajout de pièces jointes",
        "scope": "Organisation",
        "globalScope": "Tous les comptes",
        "login": "Identifiant Qonto",
        "secret": "Clé secrète",
        "connect": "Connecter",
        "disconnect": "Déconnecter",
        "connected": "Qonto connecté",
        "securityNote": "Vos identifiants sont conservés côté serveur et ne sont jamais lisibles depuis le navigateur.",
        "primaryMailbox": "Boîte mail des factures",
        "noPrimaryMailbox": "Aucune boîte principale",
        "primaryMailboxHint": "La recherche de factures commence par cette boîte.",
        "saveMailbox": "Enregistrer la boîte mail",
        "mailboxSaved": "Boîte mail enregistrée"
      },
      "amazon": {
        "name": "Amazon Business",
        "description": "Récupérez automatiquement les factures de vos commandes Amazon Business.",
        "scopeNote": "Lecture seule des commandes et factures",
        "scope": "Organisation",
        "globalScope": "Tous les comptes",
        "region": "Région Amazon",
        "regions": {
          "eu": "Europe",
          "na": "Amérique du Nord",
          "fe": "Extrême-Orient"
        },
        "clientId": "Identifiant client",
        "clientSecret": "Secret client",
        "refreshToken": "Jeton de rafraîchissement",
        "test": "Tester la connexion",
        "testOk": "Identifiants Amazon valides",
        "connect": "Connecter",
        "connected": "Amazon Business connecté",
        "disconnect": "Déconnecter",
        "alreadyConnected": "Cette organisation est déjà reliée à Amazon Business.",
        "reassignHint": "Une connexion Amazon existe déjà pour : {{from}}. Vous pouvez la rattacher à cette organisation sans ressaisir vos identifiants.",
        "reassign": "Rattacher la connexion à cette organisation",
        "reassigned": "Connexion Amazon rattachée",
        "oauthScope": "Droits demandés à Amazon",
        "oauthScopeHint": "Laissez « profile » si vous ne savez pas. Si Amazon refuse l'accès aux commandes, indiquez ici les droits affichés dans votre profil de sécurité Amazon.",
        "securityNote": "Vos identifiants sont conservés côté serveur et ne sont jamais lisibles depuis le navigateur.",
        "authorize": "Autoriser avec Amazon",
        "authorizing": "Autorisation en cours…",
        "authorizeHint": "Saisissez l'identifiant et le secret, puis autorisez : le jeton est généré automatiquement.",
        "redirectUri": "URL de redirection à déclarer chez Amazon",
        "copy": "Copier",
        "copied": "URL copiée",
        "popupBlocked": "La fenêtre Amazon a été bloquée par le navigateur.",
        "authCancelled": "Autorisation Amazon annulée.",
        "callbackDone": "Autorisation terminée, vous pouvez fermer cette fenêtre."
      }
    },
    "tabs": {
      "general": "Général",
      "appearance": "Apparence",
      "integrations": "Intégrations",
      "autosearch": "Veille auto",
      "rules": "Règles & Préférences",
      "templates": "Templates",
      "linkedin": "LinkedIn",
      "subscription": "Facturation",
      "quotas": "Crédits & Packs",
      "privacy": "Confidentialité et RGPD"
    },
    "appearance": {
      "fontsTitle": "Polices",
      "fontSans": "Texte courant (sans serif)",
      "fontSansDesc": "Paragraphes, menus et boutons.",
      "fontSerif": "Titres (serif)",
      "fontSerifDesc": "Titres et accroches éditoriales.",
      "fontMono": "Code (monospace)",
      "fontMonoDesc": "Blocs de code et données techniques.",
      "scaleTitle": "Échelle typographique",
      "scaleDesc": "Redimensionne proportionnellement toute l’interface.",
      "previewLabel": "Aperçu",
      "previewHeading": "L'élégance d'une typographie soignée",
      "previewBody": "Vos préférences s'appliquent immédiatement à toute l'application. N'oubliez pas d'enregistrer pour les conserver entre vos sessions.",
      "saveCta": "Enregistrer le thème",
      "resetCta": "Réinitialiser",
      "savedTitle": "Thème enregistré",
      "savedDesc": "Vos préférences typographiques ont été sauvegardées.",
      "resetTitle": "Thème réinitialisé",
      "resetDesc": "Les valeurs par défaut ont été restaurées.",
      "errorTitle": "Erreur",
      "errorDesc": "Impossible d'enregistrer vos préférences pour le moment.",
      "discardCta": "Annuler les modifications",
      "discardedDesc": "Vos modifications ont été annulées.",
      "discardedTitle": "Modifications annulées",
      "previewBadge": "Aperçu",
      "previewBtnPrimary": "Bouton principal",
      "previewBtnSecondary": "Bouton secondaire",
      "previewHint": "Aperçu en direct de vos changements.",
      "previewInputLabel": "Champ d'exemple",
      "previewInputPlaceholder": "Saisissez du texte…",
      "unsavedDesc": "Vous avez des modifications non enregistrées.",
      "unsavedTitle": "Modifications non enregistrées"
    },
    "language": {
      "title": "Langue de l'interface",
      "description": "Choisissez la langue d'affichage de l'application.",
      "saved": "Langue mise à jour"
    },
    "general": {
      "tourTitle": "Visite guidée",
      "tourHelp": "Refaire la présentation interactive des fonctionnalités clés.",
      "tourCta": "Lancer la visite",
      "languageTitle": "Langue préférée",
      "languageHelp": "Choisissez la langue d'affichage de Thiia. Ce choix est enregistré sur votre profil et appliqué automatiquement sur tous vos appareils — vous pouvez le modifier ici à tout moment, sans refaire l'onboarding.",
      "languageSavedTitle": "Langue préférée enregistrée",
      "languageSavedDescription": "Votre langue préférée est maintenant : {{lng}}.",
      "languageSaveError": "Impossible d'enregistrer votre langue préférée.",
      "languageUnavailableTitle": "Langue indisponible",
      "languageUnavailableDescription": "La langue « {{requested}} » de votre profil n'est plus disponible. Retour automatique à {{fallback}}.",
      "myProfile": "Mon profil",
      "displayName": "Nom affiché",
      "currentEmail": "Email actuel",
      "newEmailPlaceholder": "Nouvel email…",
      "change": "Changer",
      "emailConfirmHelp": "Un email de confirmation sera envoyé aux deux adresses.",
      "changePassword": "Changer le mot de passe",
      "currentPassword": "Mot de passe actuel",
      "currentPasswordRequired": "Saisissez votre mot de passe actuel",
      "currentPasswordInvalid": "Mot de passe actuel incorrect",
      "currentPasswordNoEmail": "Adresse email introuvable pour ce compte",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "update": "Mettre à jour",
      "passwordMin": "Minimum 6 caractères",
      "businessType": "Votre activité",
      "businessPlaceholder": "Ex: Consultant en stratégie digitale",
      "audience": "Audience cible",
      "audiencePlaceholder": "Ex: Cadres et dirigeants en transition",
      "tone": "Ton de communication",
      "tones": {
        "professionnel": "Professionnel & formel",
        "chaleureux": "Chaleureux & accessible",
        "dynamique": "Dynamique & motivant",
        "inspirant": "Inspirant & poétique"
      },
      "socialNetworks": "Réseaux sociaux connectés",
      "noneConfigured": "Aucun configuré",
      "appearance": "Apparence emails & exports",
      "pdfExports": "PDF & exports",
      "primaryColor": "Couleur primaire",
      "accentColor": "Couleur accent",
      "pdfPrimaryHelp": "Titres, numéros, en-tête",
      "pdfAccentHelp": "Sous-titres, puces, séparateurs",
      "emails": "Emails",
      "emailHeaderColor": "Couleur d'en-tête",
      "emailHeaderHelp": "Bandeau haut de l'email",
      "emailAccentHelp": "Séparateurs, liens",
      "templatePreview": "Aperçu template",
      "emailSignature": "Signature email",
      "signatureHelp": "Ajoutée automatiquement à vos emails.",
      "includeUnsubscribeFooterLabel": "Pied de page de désabonnement",
      "includeUnsubscribeFooterHelp": "Afficher le texte RGPD et le lien de désabonnement en bas des emails de prospection.",
      "preview": "Aperçu",
      "profileUpdated": "Profil mis à jour ✓",
      "logoUpdated": "Logo mis à jour ✓",
      "logoRemoved": "Logo supprimé",
      "avatarUpdated": "Photo de profil mise à jour ✓",
      "avatarRemoved": "Photo de profil supprimée",
      "uploadAvatar": "Téléverser une photo",
      "avatarHelp": "JPG, PNG ou WEBP. 2 Mo maximum.",
      "remove": "Supprimer",
      "passwordUpdated": "Mot de passe mis à jour ✓",
      "emailConfirmSent": "Email de confirmation envoyé",
      "emailConfirmDesc": "Vérifiez votre nouvelle boîte mail pour confirmer le changement.",
      "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères.",
      "passwordMismatch": "Les mots de passe ne correspondent pas.",
      "imageOnly": "Veuillez sélectionner une image (PNG, JPG, SVG…)",
      "error": "Erreur",
      "noSocialNetwork": "Aucun réseau connecté",
      "connectNetwork": "Connecter un réseau",
      "restartOnboarding": "Refaire l’onboarding"
    },
    "search": {
      "placeholder": "Rechercher un réglage…",
      "empty": "Aucun réglage trouvé.",
      "heading": "Réglages",
      "items": {
        "aiPrivacy": "Confidentialité de l'IA",
        "appearance": "Apparence de l'application",
        "audience": "Audience cible",
        "autosearch": "Configuration de la veille",
        "avatar": "Photo de profil",
        "businessType": "Votre activité",
        "deleteAccount": "Supprimer mon compte",
        "displayName": "Nom affiché",
        "email": "Adresse email du compte",
        "emailAnalysis": "Analyse des emails",
        "emailAppearance": "Apparence des emails et PDF",
        "emailSignature": "Signature des emails",
        "export": "Export RGPD de mes données",
        "followups": "Modèles de relance par statut",
        "gdprNotice": "Mention RGPD des premiers contacts",
        "intChatgpt": "Import ChatGPT",
        "intDrive": "Google Drive",
        "intDropbox": "Dropbox",
        "intGamma": "Gamma",
        "intGmail": "Gmail",
        "intHubspot": "HubSpot",
        "intImap": "IMAP / SMTP",
        "intLinkedin": "LinkedIn",
        "intMeet": "Google Meet",
        "intOffice365": "Office 365 / Outlook",
        "intOnedrive": "OneDrive",
        "intVideo": "Outil de visio par défaut",
        "intVoice": "Commandes vocales",
        "intWhatsapp": "WhatsApp",
        "intWord": "Microsoft Word",
        "intZoom": "Zoom",
        "language": "Langue de l'interface",
        "legalDocs": "Documents légaux",
        "meetingDuration": "Durée des rendez-vous",
        "needSignals": "Signaux de besoin",
        "notifAnnouncements": "Digest des annonces",
        "notifBriefing": "Heure du briefing quotidien",
        "notifChecklists": "Email quotidien des tâches",
        "notifMentions": "Emails de mention",
        "onboarding": "Refaire l'onboarding",
        "organizations": "Organisation par défaut",
        "password": "Mot de passe",
        "patterns": "Patterns appris",
        "quotas": "Packs de crédits",
        "retention": "Durée de conservation des données",
        "rules": "Règles de l'agent",
        "socialNetworks": "Réseaux sociaux",
        "subscription": "Abonnement",
        "timezone": "Fuseau horaire",
        "tone": "Ton de communication",
        "tour": "Tour de bienvenue"
      }
    },
    "saveBar": {
      "pending_one": "1 champ modifié",
      "pending_other": "{{count}} champs modifiés",
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "account": {
      "profileTitle": "Profil",
      "profileHint": "Utilisé dans les emails et les documents générés",
      "photo": "Photo",
      "photoDesc": "Affichée dans l'application et sur les comptes rendus partagés",
      "replace": "Remplacer",
      "businessDesc": "Thiia s'en sert pour calibrer le ton des messages",
      "socialLink": "Gérer dans Intégrations",
      "securityTitle": "Sécurité du compte",
      "emailLabel": "Adresse email",
      "edit": "Modifier",
      "changeCta": "Changer",
      "passwordChanged": "Modifié il y a {{count}} mois",
      "passwordChangedRecent": "Modifié ce mois-ci",
      "passwordChangedUnknown": "Date de modification inconnue",
      "sessions": "Sessions actives",
      "sessionsValue": "{{count}} appareil",
      "view": "Voir",
      "sessionsTitle": "Sessions actives",
      "sessionsHelp": "Seul l'appareil que vous utilisez actuellement peut être affiché.",
      "thisDevice": "Cet appareil",
      "lastSignIn": "Dernière connexion",
      "prefsTitle": "Préférences",
      "language": "Langue de l'interface",
      "defaultOrg": "Organisation par défaut",
      "defaultOrgDesc": "Appliquée aux nouveaux prospects et comptes rendus",
      "noOrg": "Aucune organisation",
      "tour": "Tour de bienvenue",
      "redoOnboarding": "Refaire l'onboarding",
      "restart": "Relancer",
      "emailDialogTitle": "Modifier l'adresse email",
      "passwordDialogTitle": "Changer de mot de passe",
      "saved": "Préférence enregistrée",
      "saveError": "Modification impossible"
    },
    "ai": {
      "rules": {
        "title": "Règles de génération",
        "hint": "Thiia applique ces règles à tout ce qu'elle rédige.",
        "filters": {
          "reports": "Comptes rendus",
          "emails": "Emails",
          "prospecting": "Prospection"
        },
        "suggested": "Proposée par Thiia",
        "suggestedDesc": "Structure les comptes rendus en résumé, points clés, décisions, actions et prochaines étapes.",
        "accept": "Activer",
        "decline": "Ignorer",
        "empty": "Aucune règle pour l'instant.",
        "newRule": "Nouvelle règle",
        "newRuleDesc": "Dites à Thiia comment écrire, chercher ou résumer.",
        "add": "Ajouter"
      },
      "emailAnalysis": {
        "title": "Analyse des emails",
        "hint": "Ces instructions guident Thiia lors de la détection de prospects dans vos emails.",
        "instructions": "Instructions d'analyse",
        "noInstructions": "Aucune instruction pour l'instant.",
        "placeholder": "Ex : considère comme prospect toute personne qui mentionne un budget supérieur à 5 000 €…",
        "auto": "Analyser automatiquement",
        "autoDesc": "Thiia analyse vos nouveaux emails sans que vous ayez à le demander."
      },
      "patterns": {
        "title": "Ce que l'IA a appris",
        "count": "{{count}} patterns",
        "deduced": "Déduit de vos échanges",
        "manual": "Ajouté à la main",
        "forget": "Oublier",
        "empty": "Thiia n'a encore rien appris de vos échanges."
      },
      "templates": {
        "title": "Modèles et apparence",
        "hint": "Relances proposées par statut, signature des emails et logo sur les documents."
      }
    },
    "watch": {
      "results": {
        "title": "Résultats",
        "hint": "Les résultats de la veille vivent sur leur propre page."
      },
      "config": {
        "title": "Configuration",
        "enabledDesc": "Thiia cherche des signaux sur vos prospects et vos comptes cibles.",
        "schedule": "Jour et heure",
        "scheduleDesc": "Le digest est déposé dans vos résultats à cette heure.",
        "emailNotification": "Notification par email",
        "lastRun": "Dernière exécution : {{date}}",
        "neverRun": "Jamais lancée depuis cet écran."
      },
      "scope": {
        "title": "Périmètre",
        "prospects": "Prospects suivis",
        "all": "Tous les prospects",
        "active": "Actifs uniquement",
        "manual": "Sélection manuelle",
        "signals": "Types de signaux",
        "signalsCount": "{{count}} sur {{total}}"
      },
      "signals": {
        "funding": "Levée de fonds",
        "hiring": "Recrutement",
        "news": "Actualité presse",
        "event": "Événement",
        "job_change": "Changement de poste",
        "publication": "Publication"
      }
    }
  },
  "billing": {
    "title": "Facturation",
    "subtitle": "Consultez vos factures et gérez vos moyens de paiement.",
    "refresh": "Rafraîchir",
    "history": "Historique",
    "stripePortal": "Portail Stripe",
    "noInvoices": "Aucune facture disponible.",
    "invoiceNumber": "N° Facture",
    "date": "Date",
    "amount": "Montant",
    "status": "Statut",
    "actions": "Actions",
    "view": "Voir",
    "pdf": "PDF",
    "statusPaid": "Payé",
    "statusOpen": "En attente",
    "statusDraft": "Brouillon",
    "statusVoid": "Annulée",
    "error": "Erreur",
    "dateLocale": "fr-FR",
    "subscriptionSection": "Abonnement",
    "planLabel": "Plan en cours",
    "planAmount": "Montant",
    "nextPayment": "Prochain prélèvement",
    "paymentMethod": "Moyen de paiement",
    "seatsUsed": "Sièges utilisés",
    "managePayment": "Gérer le paiement",
    "changePlan": "Changer de plan",
    "noSubscription": "Aucun abonnement actif.",
    "cancelAtPeriodEnd": "Résiliation à la fin de la période",
    "object": "Objet",
    "subscriptionInvoice": "Facture d'abonnement",
    "creditPurchase": "Achat de crédits"
  },
  "quotasPage": {
    "credits": "Crédits restants",
    "refresh": "Rafraîchir",
    "addToCart": "+{{count}} ({{price}} €)",
    "addToCartMinutes": "+{{count}} min ({{price}} €)",
    "cart": "Panier",
    "creditsLine": "×{{size}} = {{total}} crédits",
    "creditsLineMinutes": "×{{size}} min = {{total}} min",
    "total": "Total",
    "pay": "Payer {{amount}} €",
    "buyPacks": "Acheter des packs",
    "popular": "Populaire",
    "buy": "Acheter",
    "purchaseHistory": "Historique des achats",
    "noPurchases": "Aucun achat de crédits.",
    "pack": "Pack",
    "amount": "Montant",
    "date": "Date",
    "customLot": "Lot personnalisé",
    "purchaseConfirmed": "Achat confirmé !",
    "creditsAdded": "Vos crédits ont été ajoutés.",
    "error": "Erreur",
    "labels": {
      "note_report": "Rapports",
      "chat_question": "Questions au chat",
      "agentic_task": "Tâches automatisées",
      "audio_transcription": "Transcription",
      "content_post": "Publications",
      "content_newsletter": "Newsletters",
      "search": "Recherches",
      "analysis": "Analyses",
      "checklist": "Checklists",
      "document_indexing": "Documents",
      "veille": "Veille automatique",
      "images_generated": "Images générées"
    },
    "recharge": "Recharger",
    "cartEmpty": "Votre panier est vide."
  },
  "reportConfig": {
    "title": "Compte-rendu IA",
    "customizeHint": "Personnalisez le format via",
    "settingsLink": "Réglages → Règles → Comptes rendus",
    "audioWarningOne": "Le fichier audio « {{name}} » n'a pas encore de transcription.",
    "audioWarningMany": "{{count}} fichiers audio n'ont pas de transcription.",
    "aiModel": "Modèle IA",
    "language": "Langue du compte-rendu",
    "customInstructions": "Instructions personnalisées",
    "modified": "Modifié",
    "savedPresets": "Presets sauvegardés",
    "presetDeleted": "Preset supprimé",
    "presetSaved": "Preset sauvegardé",
    "instructionsPlaceholder": "Instructions pour la génération du compte-rendu…",
    "reset": "Réinitialiser",
    "presetNamePlaceholder": "Nom du preset…",
    "saveAsPreset": "Sauvegarder comme preset",
    "compareWith": "Comparer avec un autre modèle",
    "generating": "Génération…",
    "writing": "Rédaction en cours…",
    "chooseVersion": "Choisir cette version",
    "cancel": "Annuler",
    "compareN": "Comparer ({{n}} modèles)",
    "generate": "Générer",
    "back": "← Retour",
    "preview": "Aperçu",
    "edit": "Modifier",
    "landscape": "Paysage",
    "landscapeTitle": "Mode paysage (PDF)",
    "copy": "Copier",
    "copied": "Copié !",
    "pdf": "PDF",
    "pdfDownloaded": "PDF téléchargé",
    "pdfError": "Erreur export PDF",
    "word": "Word",
    "wordDownloaded": "Word téléchargé",
    "wordError": "Erreur export Word",
    "draft": "Brouillon",
    "finalize": "Finaliser",
    "draftAutoSaved": "Brouillon sauvegardé automatiquement",
    "draftSaved": "Brouillon sauvegardé",
    "draftSaveError": "Erreur de sauvegarde",
    "sessionExpired": "Session expirée",
    "errorPrefix": "Erreur",
    "generationError": "Erreur de génération",
    "initializing": "Initialisation…",
    "draftTitle": "Brouillon – {{date}}",
    "instructionsDefault": "Consignes :\n- Rédige un compte-rendu synthétique, structuré et actionnable\n- Structure avec des sections claires : Contexte, Points clés, Éléments importants, Actions à suivre\n- Si des transcriptions audio sont fournies, analyse-les en profondeur pour en extraire les informations pertinentes\n- Mets en avant les insights stratégiques pour la relation commerciale\n- Identifie les engagements, décisions et prochaines étapes mentionnés\n- Utilise un ton professionnel et chaleureux\n- Format Markdown\n- Si des fichiers non-audio sont joints, mentionne-les dans le contexte",
    "modelDescriptions": {
      "mistralMedium": "Mistral souverain — rapide, équilibré",
      "mistralLarge": "Mistral souverain — qualité maximale",
      "gemini3Flash": "Rapide et équilibré",
      "gemini31Pro": "Dernier modèle Google, raisonnement avancé",
      "gemini25Flash": "Bon rapport qualité/vitesse",
      "gemini25Pro": "Précis, multimodal",
      "gpt52": "Dernier OpenAI, raisonnement renforcé",
      "gpt5": "Excellent raisonnement",
      "gpt5Mini": "Bon raisonnement, rapide"
    },
    "advancedMode": "Mode avancé",
    "advancedModeHint": "Choix du modèle, instructions personnalisées et comparaison",
    "mistralBadge": "Généré avec Mistral — IA souveraine, sans entraînement sur vos données",
    "cost": {
      "estimatedCost": "Coût estimé",
      "credits": "crédits",
      "breakdown": "Tier {{tier}} (~{{tokens}} tokens) × facteur ×{{factor}}",
      "tooltipTiers": "Coût de base (selon taille transcription)",
      "tooltipFactors": "Facteur modèle",
      "learnMore": "En savoir plus →"
    },
    "refine": {
      "title": "Modifier cette version",
      "placeholder": "Ex : raccourcis la partie budget, ajoute une colonne Priorité…",
      "apply": "Appliquer",
      "applying": "Application de la modification…",
      "undo": "Version précédente",
      "redo": "Version suivante",
      "error": "Impossible d'appliquer la modification",
      "chips": {
        "shorten": "Raccourcir",
        "formal": "Plus formel",
        "table": "En tableau",
        "actions": "Clarifier les actions",
        "expand": "Développer",
        "bullets": "En puces",
        "summary": "Ajouter un résumé",
        "owners": "Ajouter responsables",
        "dates": "Ajouter échéances",
        "sections": "Structurer en sections"
      },
      "prompts": {
        "shorten": "Raccourcis le compte-rendu d'environ 30 % en gardant toutes les informations essentielles.",
        "formal": "Reformule le compte-rendu avec un ton plus formel et professionnel, sans changer le contenu.",
        "table": "Présente les actions à suivre sous forme de tableau (Action, Responsable, Échéance, Résultat attendu).",
        "actions": "Clarifie et complète la section des actions à suivre : responsable et échéance explicites pour chaque action.",
        "expand": "Développe le compte-rendu : ajoute du contexte, des détails concrets et les points de décision manquants, sans inventer d'informations.",
        "bullets": "Transforme les longs paragraphes en listes à puces courtes et lisibles, sans perdre d'information.",
        "summary": "Ajoute en tête du compte-rendu une section « Résumé » de 3 à 5 puces reprenant les points clés.",
        "owners": "Ajoute une colonne / mention « Responsable » pour chaque action et attribue-la à la bonne personne d'après le contenu.",
        "dates": "Ajoute des échéances explicites (dates ou délais) pour chaque action à suivre.",
        "sections": "Structure le compte-rendu avec des titres clairs (Contexte, Points clés, Décisions, Actions à suivre)."
      },
      "quotaError": "Quota IA épuisé : la modification n'a pas pu être appliquée. Votre version actuelle est conservée. Achetez des crédits puis relancez uniquement cette modification.",
      "retry": "Relancer la modification",
      "dismiss": "Ignorer"
    },
    "compareVersions": {
      "title": "Comparer les versions",
      "button": "Comparer",
      "current": "actuelle",
      "restore": "Restaurer",
      "legend": "Chaque colonne est comparée à la précédente : ajouts surlignés, suppressions barrées."
    },
    "backToProspect": "Retour à la fiche",
    "editor": {
      "bold": "Gras",
      "italic": "Italique",
      "h2": "Titre",
      "h3": "Sous-titre",
      "bullets": "Liste à puces",
      "numbered": "Liste numérotée",
      "quote": "Citation",
      "undo": "Annuler",
      "redo": "Rétablir"
    }
  },
  "legalPages": {
    "back": "Retour",
    "lastUpdated": "Dernière mise à jour : 1er avril 2026",
    "legal": {
      "title": "Mentions légales",
      "s1Title": "1. Éditeur du site",
      "s1Intro": "Le site <0>Thiia Prospect</0> est édité par :",
      "s1Items": {
        "name": "<0>Raison sociale :</0> KREAPP — SAS, société par actions simplifiée",
        "siren": "<0>SIREN :</0> 914 378 344",
        "siret": "<0>SIRET (siège) :</0> 914 378 344 00016",
        "capital": "<0>Capital social :</0> 1 000 €",
        "address": "<0>Siège social :</0> 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France",
        "ape": "<0>Code APE :</0> 6201Z — Programmation informatique",
        "registered": "<0>Date d'immatriculation :</0> 10/06/2022",
        "president": "<0>Président :</0> Samir SALIBI"
      },
      "s2Title": "2. Hébergement",
      "s2Body": "Le site est hébergé par <0>Supabase Inc.</0> et <1>Lovable GmbH</1>. Les données sont traitées conformément au RGPD et hébergées au sein de l'Union européenne.",
      "s3Title": "3. Propriété intellectuelle",
      "s3Body": "L'ensemble du contenu du site (textes, images, logos, logiciels, base de données) est la propriété exclusive de KREAPP ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation ou diffusion, en tout ou partie, sans autorisation préalable écrite est interdite.",
      "s4Title": "4. Responsabilité",
      "s4Body": "KREAPP s'efforce d'assurer l'exactitude des informations diffusées sur le site, mais ne saurait être tenue responsable des erreurs, omissions ou des résultats obtenus suite à l'utilisation de ces informations. L'utilisation du service Thiia Prospect est soumise aux conditions générales d'utilisation.",
      "s5Title": "5. Contact",
      "s5Body": "Pour toute question relative aux mentions légales, vous pouvez nous contacter à l'adresse du siège social mentionnée ci-dessus ou par email à : <0>hello@thiia.app</0>."
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "s1Title": "1. Responsable du traitement",
      "s1Body": "Le responsable du traitement des données est <0>KREAPP</0>, SAS au capital de 1 000 €, immatriculée sous le SIREN 914 378 344, dont le siège social est situé au 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France, représentée par Samir SALIBI, Président.",
      "s2Title": "2. Données collectées",
      "s2Intro": "Dans le cadre de l'utilisation de Thiia Prospect, nous collectons les données suivantes :",
      "s2Items": {
        "identity": "<0>Données d'identification :</0> nom, prénom, adresse email, mot de passe (chiffré)",
        "pro": "<0>Données professionnelles :</0> nom de l'entreprise, secteur d'activité, audience cible, réseaux sociaux",
        "prospects": "<0>Données de prospection :</0> informations sur vos prospects (nom, email, entreprise, notes, historique d'interactions)",
        "comms": "<0>Données de communication :</0> contenu des emails analysés (avec votre consentement), conversations avec l'assistant IA",
        "tech": "<0>Données techniques :</0> adresse IP, type de navigateur, pages visitées, horodatages de connexion"
      },
      "s3Title": "3. Finalités du traitement",
      "s3Items": {
        "account": "Gestion de votre compte et authentification",
        "service": "Fourniture des services de prospection assistée par IA",
        "enrich": "Analyse et enrichissement de vos contacts professionnels",
        "content": "Génération de contenus et recommandations personnalisées",
        "notifs": "Envoi de notifications et rappels liés à votre activité",
        "improve": "Amélioration du service et correction des dysfonctionnements"
      },
      "s4Title": "4. Base légale du traitement",
      "s4Items": {
        "contract": "<0>Exécution du contrat :</0> les traitements nécessaires à la fourniture du service (Art. 6.1.b RGPD)",
        "consent": "<0>Consentement :</0> pour l'analyse de vos emails et l'utilisation de cookies non essentiels (Art. 6.1.a RGPD)",
        "interest": "<0>Intérêt légitime :</0> amélioration du service, sécurité, prévention de la fraude (Art. 6.1.f RGPD)"
      },
      "s5Title": "5. Confidentialité des données IA",
      "s5Body": "<0>Vos données ne sont jamais utilisées pour entraîner les modèles d'intelligence artificielle.</0> Thiia Prospect utilise Mistral AI, un moteur d'IA souverain français. Les données transmises à l'IA pour analyse sont traitées de manière éphémère et ne sont ni stockées ni réutilisées par le fournisseur du modèle. La confidentialité totale de vos données est garantie.",
      "s6Title": "6. Durée de conservation",
      "s6Items": {
        "account": "<0>Données de compte :</0> conservées pendant la durée de votre abonnement, puis 3 ans après la suppression du compte",
        "prospects": "<0>Données de prospection :</0> conservées tant que votre compte est actif",
        "logs": "<0>Logs techniques :</0> 12 mois maximum",
        "ai": "<0>Conversations IA :</0> conservées tant que vous ne les supprimez pas"
      },
      "s7Title": "7. Partage des données",
      "s7Intro": "Vos données personnelles ne sont jamais vendues. Elles peuvent être partagées avec :",
      "s7Items": {
        "supabase": "<0>Supabase :</0> hébergement et base de données (UE)",
        "mistral": "<0>Mistral AI :</0> traitement IA (France)",
        "stripe": "<0>Stripe :</0> gestion des paiements (conforme RGPD)",
        "google": "<0>Google / Microsoft :</0> uniquement si vous connectez vos comptes email ou calendrier (avec votre consentement explicite)"
      },
      "s8Title": "8. Transferts hors UE",
      "s8Body": "Nous privilégions les hébergements au sein de l'Union européenne. Lorsqu'un transfert hors UE est nécessaire (ex : Stripe pour les paiements), il est encadré par des clauses contractuelles types approuvées par la Commission européenne ou par une décision d'adéquation.",
      "s9Title": "9. Vos droits",
      "s9Intro": "Conformément au RGPD, vous disposez des droits suivants :",
      "s9Items": {
        "access": "<0>Droit d'accès :</0> obtenir une copie de vos données personnelles",
        "rectify": "<0>Droit de rectification :</0> corriger des données inexactes ou incomplètes",
        "erase": "<0>Droit à l'effacement :</0> demander la suppression de vos données",
        "portability": "<0>Droit à la portabilité :</0> recevoir vos données dans un format structuré",
        "object": "<0>Droit d'opposition :</0> vous opposer au traitement de vos données",
        "limit": "<0>Droit à la limitation :</0> restreindre le traitement de vos données",
        "withdraw": "<0>Droit de retrait du consentement :</0> retirer votre consentement à tout moment"
      },
      "s9Contact": "Pour exercer vos droits, contactez-nous à : <0>hello@thiia.app</0>",
      "s9Cnil": "En cas de litige, vous pouvez introduire une réclamation auprès de la <0>CNIL</0> (Commission nationale de l'informatique et des libertés) — <1>www.cnil.fr</1>.",
      "s10Title": "10. Cookies",
      "s10Body": "Thiia Prospect utilise uniquement des cookies strictement nécessaires au fonctionnement du service (authentification, préférences de session). Aucun cookie publicitaire ou de traçage n'est utilisé.",
      "s11Title": "11. Sécurité",
      "s11Body": "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement en transit (TLS) et au repos, authentification sécurisée, politiques de sécurité au niveau des lignes (RLS) dans la base de données, et audits réguliers.",
      "s12Title": "12. Modification de la politique",
      "s12Body": "Cette politique de confidentialité peut être mise à jour à tout moment. En cas de modification substantielle, vous serez informé(e) par notification dans l'application ou par email."
    },
    "terms": {
      "title": "Conditions générales d'utilisation",
      "s1Title": "1. Objet",
      "s1Body": "Les présentes conditions générales d'utilisation (CGU) régissent l'accès et l'utilisation de la plateforme <0>Thiia Prospect</0>, éditée par KREAPP, SAS au capital de 1 000 €, SIREN 914 378 344, siège social : 8 Le Hameau Saint Hubert, 78860 Saint-Nom-la-Bretèche, France.",
      "s2Title": "2. Accès au service",
      "s2Body": "L'accès à Thiia Prospect nécessite la création d'un compte utilisateur. L'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants. Tout accès au compte est présumé effectué par le titulaire du compte.",
      "s3Title": "3. Description du service",
      "s3Intro": "Thiia Prospect est un agent de prospection intelligent qui propose :",
      "s3Items": {
        "chat": "Un assistant IA conversationnel pour la prospection commerciale",
        "crm": "La gestion et le suivi des prospects (CRM)",
        "search": "La recherche et l'enrichissement de contacts professionnels",
        "email": "L'analyse d'emails et la génération de contenus",
        "calendar": "La gestion d'événements et de calendrier",
        "social": "La publication sur les réseaux sociaux professionnels"
      },
      "s4Title": "4. Crédits et paiement à la consommation",
      "s4Body": "Thiia Prospect fonctionne sans abonnement. L'accès aux fonctionnalités est conditionné à l'achat de crédits utilisés à la consommation (recherches, analyses, envois d'emails, génération de contenus, etc.). Les paiements sont gérés par Stripe et sont effectués de manière ponctuelle, à l'achat de chaque pack de crédits. Les tarifs et le coût en crédits de chaque action sont communiqués avant l'achat. Les crédits achetés ne font pas l'objet de renouvellement automatique : aucune somme n'est prélevée sans action explicite de l'utilisateur. Les crédits non consommés restent disponibles tant que le compte est actif et ne sont pas remboursables.",
      "s5Title": "5. Obligations de l'utilisateur",
      "s5Intro": "L'utilisateur s'engage à :",
      "s5Items": {
        "lawful": "Utiliser le service conformément à sa destination et aux lois en vigueur",
        "spam": "Ne pas utiliser le service à des fins de spam ou de harcèlement",
        "gdpr": "Respecter la réglementation applicable en matière de protection des données (RGPD) pour les données de ses propres prospects",
        "security": "Ne pas tenter de contourner les mesures de sécurité du service",
        "resell": "Ne pas revendre ou redistribuer l'accès au service sans autorisation"
      },
      "s6Title": "6. Propriété intellectuelle",
      "s6Body": "L'ensemble des éléments du service (logiciel, design, algorithmes, marques) est la propriété exclusive de KREAPP. L'utilisateur conserve la propriété de ses données. En utilisant le service, l'utilisateur accorde à KREAPP une licence limitée pour traiter ses données aux seules fins de fourniture du service.",
      "s7Title": "7. Données personnelles",
      "s7Body": "Le traitement des données personnelles est décrit dans notre <0>Politique de confidentialité</0>. Les données ne sont jamais utilisées pour entraîner les modèles d'IA.",
      "s8Title": "8. Limitation de responsabilité",
      "s8Body": "KREAPP met en œuvre les moyens raisonnables pour assurer la disponibilité et la fiabilité du service. Toutefois, le service est fourni « en l'état ». KREAPP ne garantit pas que le service sera exempt d'interruptions ou d'erreurs. En aucun cas, KREAPP ne pourra être tenue responsable des dommages indirects résultant de l'utilisation du service.",
      "s9Title": "9. Résiliation",
      "s9Body": "L'utilisateur peut résilier son compte à tout moment depuis les paramètres de son compte. KREAPP se réserve le droit de suspendre ou résilier un compte en cas de violation des présentes CGU, après notification. En cas de résiliation, les données de l'utilisateur seront conservées pendant une durée de 30 jours, puis supprimées.",
      "s10Title": "10. Droit applicable et juridiction",
      "s10Body": "Les présentes CGU sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux compétents de Versailles seront seuls compétents.",
      "s11Title": "11. Contact",
      "s11Body": "Pour toute question relative aux CGU : <0>hello@thiia.app</0>"
    }
  },
  "docsPage": {
    "toc": "Sommaire",
    "sectionsCount": "{{count}} sections",
    "title": "Documentation",
    "subtitle": "Guide complet pour exploiter Thiia au maximum",
    "searchPlaceholder": "Rechercher dans la documentation…",
    "noResults": "Aucun résultat pour « {{query}} ». Essayez d'autres mots-clés.",
    "footerQuestion": "Une question reste sans réponse ?",
    "footerContact": "Demandez directement à <0>Thiia dans le chat</0>, ou contactez-nous à <1>hello@thiia.app</1>"
  },
  "auth": {
    "home": "Accueil",
    "pageHeading": "Connexion ou création de compte Thiia",
    "tagline": "Votre assistante IA de prospection et de communication",
    "emailConfirmed": "Email confirmé avec succès !",
    "emailConfirmedDesc": "Votre compte est activé. Connectez-vous pour commencer.",
    "invitationReceived": "Vous avez reçu une invitation",
    "invitationJoinLogin": "Connectez-vous pour rejoindre votre équipe",
    "invitationJoinSignup": "Créez votre compte pour rejoindre votre équipe",
    "forgotTitle": "Mot de passe oublié",
    "loginTitle": "Se connecter",
    "signupTitle": "Créer un compte",
    "forgotDesc": "Entrez votre email pour recevoir un lien de réinitialisation",
    "loginDesc": "Retrouvez votre espace Thiia",
    "signupInviteDesc": "Créez votre compte pour accepter l'invitation",
    "signupDesc": "Commencez à prospecter avec l'IA",
    "emailPlaceholder": "Email",
    "namePlaceholder": "Votre nom",
    "passwordPlaceholder": "Mot de passe",
    "confirmPasswordPlaceholder": "Confirmer le mot de passe",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "forgotLink": "Mot de passe oublié ?",
    "sending": "Envoi...",
    "sendLink": "Envoyer le lien",
    "loading": "Chargement...",
    "signIn": "Se connecter",
    "signUp": "S'inscrire",
    "cooldown": "Réessayez dans {{s}}s",
    "captcha": {
      "label": "Vérification anti-robot",
      "requiredTitle": "Vérification requise",
      "requiredDesc": "Veuillez compléter le challenge anti-robot avant de continuer.",
      "testKeyNotice": "Mode test hCaptcha actif. Renseignez VITE_HCAPTCHA_SITE_KEY (et le secret côté Supabase) pour activer la vraie protection."
    },
    "acceptTermsLabel": "J'accepte les <terms>Conditions générales d'utilisation</terms> et la <privacy>Politique de confidentialité</privacy> de Thiia.",
    "acceptTermsRequiredTitle": "Acceptation requise",
    "acceptTermsRequiredDesc": "Vous devez accepter les CGU et la Politique de confidentialité pour continuer.",
    "backToLogin": "← Retour à la connexion",
    "noAccount": "Pas encore de compte ? S'inscrire",
    "haveAccount": "Déjà un compte ? Se connecter",
    "emailSent": "Email envoyé !",
    "emailSentDesc": "Vérifiez votre boîte de réception pour réinitialiser votre mot de passe.",
    "error": "Erreur",
    "passwordsDiffer": "Mots de passe différents",
    "passwordsDifferDesc": "Veuillez saisir le même mot de passe deux fois.",
    "accountCreated": "Compte créé !",
    "accountCreatedDesc": "Vérifiez votre email pour confirmer votre inscription.",
    "invitationAccepted": "Invitation acceptée ! 🎉",
    "invitationAcceptedDesc": "Votre compte a été lié à votre administrateur.",
    "invitationError": "Erreur d'invitation",
    "invitationErrorDesc": "Impossible d'accepter l'invitation",
    "continueWithGoogle": "Continuer avec Google",
    "continueWithLinkedIn": "Continuer avec LinkedIn",
    "continueWithMicrosoft": "Continuer avec Microsoft",
    "magicLinkCta": "Recevoir un lien magique",
    "magicLinkNeedEmail": "Veuillez saisir votre e-mail.",
    "magicLinkSentDesc": "Consultez votre boîte de réception pour vous connecter.",
    "magicLinkSentTitle": "Lien magique envoyé",
    "orContinueWith": "Ou continuer avec",
    "password": {
      "digit": "Au moins un chiffre",
      "length": "Au moins 10 caractères",
      "lower": "Au moins une minuscule",
      "medium": "Moyen",
      "noSpace": "Aucun espace",
      "special": "Au moins un caractère spécial",
      "strong": "Fort",
      "upper": "Au moins une majuscule",
      "veryStrong": "Très fort",
      "weak": "Faible",
      "weakDesc": "Choisissez un mot de passe plus robuste.",
      "weakTitle": "Mot de passe trop faible"
    }
  },
  "resetPassword": {
    "invalidLink": "Lien de réinitialisation invalide ou expiré.",
    "backToLogin": "Retour à la connexion",
    "title": "Nouveau mot de passe",
    "cardTitle": "Réinitialisation",
    "cardDesc": "Choisissez votre nouveau mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "updating": "Mise à jour...",
    "submit": "Mettre à jour le mot de passe",
    "passwordsMismatch": "Les mots de passe ne correspondent pas.",
    "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères.",
    "updated": "Mot de passe mis à jour !",
    "updatedDesc": "Vous pouvez maintenant vous connecter.",
    "error": "Erreur",
    "emailPlaceholder": "votre@email.com",
    "expiredDesc": "Ce lien de réinitialisation a expiré.",
    "expiredTitle": "Lien expiré",
    "refreshLink": "Renvoyer un lien",
    "resend": "Renvoyer",
    "resending": "Envoi en cours…",
    "resentDesc": "Un nouveau lien vous a été envoyé.",
    "resentInline": "Lien renvoyé",
    "resentTitle": "Lien renvoyé"
  },
  "clients": {
    "convertedToast": {
      "desc": "Le prospect est désormais client.",
      "title": "Client converti"
    },
    "movedBackToast": {
      "desc": "Le client a été replacé dans les prospects.",
      "title": "Déplacé vers les prospects"
    }
  },
  "organizations": {
    "alreadyExists": "Cette organisation existe déjà",
    "create": "Créer l'organisation",
    "createDescription": "Ajoutez une nouvelle organisation à votre espace.",
    "createTitle": "Nouvelle organisation",
    "created": "Organisation créée",
    "name": "Nom",
    "namePlaceholder": "Nom de l'organisation",
    "personal": "Personnel",
    "title": "Organisations"
  },
  "searchHub": {
    "subtitle": "Recherchez entreprises, personnes et événements",
    "tabs": {
      "companies": "Entreprises",
      "events": "Événements",
      "people": "Personnes",
      "auto": "Résultats automatiques"
    },
    "title": "Prospection"
  },
  "announcements": {
    "title": "Nouveautés",
    "subtitle": "Restez au courant des dernières évolutions de la plateforme.",
    "empty": "Aucune nouveauté pour le moment.",
    "unread": "non lues",
    "pinned": "Épinglée",
    "readMore": "En savoir plus",
    "seeAll": "Tout voir",
    "bellTooltip": "Voir les nouveautés",
    "categories": {
      "feature": "Nouveauté",
      "improvement": "Amélioration",
      "fix": "Correctif",
      "milestone": "Étape",
      "announcement": "Annonce"
    },
    "audience": {
      "owner_network": "Mon réseau (tous mes coachs)",
      "users": "Utilisateurs spécifiques",
      "all": "Tous les utilisateurs"
    },
    "status": {
      "draft": "Brouillon",
      "scheduled": "Planifiée",
      "published": "Publiée",
      "archived": "Archivée"
    },
    "admin": {
      "title": "Nouveautés",
      "subtitle": "Communiquez les évolutions à vos coachs — affichage à la connexion et email optionnel.",
      "new": "Nouvelle annonce",
      "edit": "Modifier l'annonce",
      "empty": "Aucune annonce pour l'instant.",
      "ownersOnly": "Réservé aux administrateurs.",
      "publish": "Publier",
      "publishAndEmail": "Publier + envoyer email",
      "sendEmail": "Envoyer email",
      "preview": "Aperçu",
      "saveDraft": "Enregistrer en brouillon",
      "saved": "Annonce enregistrée",
      "published": "Annonce publiée",
      "deleted": "Annonce supprimée",
      "deleteTitle": "Supprimer cette annonce ?",
      "deleteDesc": "Elle disparaîtra pour tous les destinataires. Cette action est irréversible.",
      "titleRequired": "Titre requis",
      "emailSent": "Email envoyé",
      "emailSentAt": "Envoyé",
      "emailPending": "En attente",
      "emailAlreadySent": "Email déjà envoyé le",
      "col": {
        "title": "Titre",
        "category": "Catégorie",
        "status": "Statut",
        "updated": "MàJ",
        "email": "Email"
      }
    },
    "preview": {
      "title": "Aperçu de l'annonce",
      "tabInApp": "Dans l'app",
      "tabEmail": "Email",
      "audienceCount": "{{count}} destinataire(s)",
      "scheduled": "Planifiée",
      "subject": "Sujet",
      "markedRead": "Simuler comme lue",
      "warnTitle": "Titre manquant",
      "warnBody": "Contenu vide",
      "untitled": "(sans titre)"
    },
    "form": {
      "title": "Titre",
      "titlePh": "Ex : Nouveau module Insights",
      "summary": "Résumé (1 phrase)",
      "category": "Catégorie",
      "audience": "Audience",
      "userIds": "IDs utilisateurs (séparés par des virgules)",
      "imageUrl": "Image (URL, optionnelle)",
      "body": "Contenu",
      "bodyPh": "Décrivez la nouveauté…",
      "ctaLabel": "Libellé bouton (optionnel)",
      "ctaLabelPh": "Voir la nouveauté",
      "ctaUrl": "URL du bouton",
      "publishAt": "Publier le (optionnel)",
      "expiresAt": "Expire le (optionnel)",
      "pinned": "Épingler",
      "pinnedHelp": "Affichée en priorité dans le bandeau.",
      "sendEmail": "Envoyer par email à la publication",
      "sendEmailHelp": "Un email sera envoyé aux destinataires qui n'ont pas désactivé cette notification."
    }
  },
  "workspace": {
    "account": "Compte",
    "backShort": "Retour",
    "backToMine": "Retour à mon compte",
    "banner": "Vous consultez le compte de {{name}}",
    "bannerActions": "Actions",
    "bannerReadOnly": "Lecture seule",
    "collaboratorOn": "Collaborateur sur",
    "switchTitle": "Changer d'espace",
    "viewingOther": "Vous consultez un autre espace",
    "yourAccount": "Votre compte"
  },
  "checklistComponents": {
    "filterBar": {
      "search": "Rechercher une tâche…",
      "clearSearch": "Effacer la recherche",
      "type": "Type",
      "filterByType": "Filtrer par type",
      "allTypes": "Tous les types",
      "filterByDueDate": "Filtrer par échéance",
      "dueAll": "Toutes les échéances",
      "dueOverdue": "En retard",
      "dueToday": "Aujourd'hui",
      "dueWeek": "Cette semaine",
      "dueMonth": "Ce mois-ci",
      "dueNoDate": "Sans date",
      "dueShortAll": "Échéance",
      "dueShortWeek": "Semaine",
      "dueShortMonth": "Mois",
      "assignee": "Assigné",
      "filterByAssignee": "Filtrer par assigné",
      "allAssignees": "Tous les assignés",
      "me": "Moi",
      "thiia": "Thiia",
      "thiiaAi": "Thiia (IA)",
      "collaborators": "Collaborateurs",
      "filterByTag": "Filtrer par tag",
      "tags": "Tags",
      "tagCount": "{{count}} tags",
      "searchTag": "Rechercher un tag…",
      "noTags": "Aucun tag",
      "clearSelection": "Effacer la sélection",
      "manageTags": "Gérer les tags",
      "sort": "Trier",
      "sortManual": "Ordre manuel",
      "sortDueAsc": "Échéance croissante",
      "sortDueDesc": "Échéance décroissante",
      "sortManualShort": "Manuel",
      "sortDueAscShort": "Échéance ↑",
      "sortDueDescShort": "Échéance ↓",
      "showArchived": "Afficher les archivées",
      "hideArchived": "Masquer les archivées",
      "archivedShown": "Archivées affichées",
      "resetFilters": "Réinitialiser les filtres",
      "newSection": "Nouvelle section",
      "expandAll": "Tout déplier",
      "collapseAll": "Tout replier",
      "exportExcel": "Exporter en Excel",
      "newTask": "Nouvelle tâche",
      "moreActions": "Plus d'actions",
      "newFolder": "Nouveau dossier",
      "archiveCompleted": "Archiver les terminées",
      "filters": "Filtres",
      "searchOption": "Rechercher…",
      "noResult": "Aucun résultat",
      "selectedCount": "{{count}} sélectionnés",
      "status": "Statut",
      "statusActive": "Toutes les tâches",
      "statusArchived": "Archivées incluses"
    },
    "widget": {
      "defaultTitle": "Mes tâches",
      "showAll": "Voir tout ({{count}})",
      "new": "Nouvelle",
      "create": "Créer",
      "createOne": "Créer une checklist",
      "noChecklist": "Aucune checklist pour le moment.",
      "checklistNamePlaceholder": "Nom de la checklist…",
      "searchTaskPlaceholder": "Rechercher une tâche…",
      "clear": "Effacer",
      "me": "Moi",
      "collaborator": "Collaborateur",
      "selectTask": "Sélectionner la tâche",
      "reorder": "Réordonner",
      "expandSubtasks": "Déplier les sous-tâches",
      "collapseSubtasks": "Replier les sous-tâches",
      "toggleAllFor": "Basculer tout pour {{label}}",
      "addSubtask": "Ajouter une sous-tâche",
      "moveToOtherChecklist": "Déplacer vers une autre checklist",
      "moveTo": "Déplacer vers",
      "editTask": "Modifier la tâche",
      "deleteTask": "Supprimer la tâche",
      "deleteTaskWithSubtasks": "Supprimer la tâche et ses sous-tâches",
      "subtaskPlaceholder": "Nouvelle sous-tâche…",
      "addTaskPlaceholder": "Ajouter une tâche…",
      "badgeAll": "Terminé",
      "badgeNone": "À faire",
      "badgeMixed": "En cours",
      "openChecklist": "Ouvrir la checklist {{title}}",
      "openProspectSheet": "Ouvrir la fiche du prospect",
      "doubleClickToRename": "Double-cliquer pour renommer",
      "uncheckAll": "Tout décocher",
      "completeRest": "Terminer le reste",
      "checkAll": "Tout cocher",
      "restoreChecklist": "Restaurer la checklist",
      "archiveChecklist": "Archiver la checklist",
      "restore": "Restaurer",
      "archive": "Archiver",
      "deleteChecklistTitle": "Supprimer la checklist ?",
      "deleteChecklistDescPermanent": "Cette action est définitive et supprimera toutes les tâches.",
      "deleteChecklist": "Supprimer la checklist",
      "delete": "Supprimer",
      "noOrg": "Sans organisation",
      "organization": "Organisation",
      "none": "Aucune",
      "overdueCount": "{{count}} en retard",
      "setDueDate": "Définir une échéance",
      "editDueDate": "Modifier l'échéance",
      "removeDueDate": "Retirer l'échéance",
      "noTaskToExport": "Aucune tâche à exporter",
      "tasksExported": "{{count}} tâches exportées",
      "tasksUpdated": "{{count}} tâches mises à jour",
      "tasksReassigned": "{{count}} tâches réassignées",
      "tasksDeleted": "{{count}} tâches supprimées",
      "tasksArchived": "{{count}} tâches archivées",
      "tasksRestored": "{{count}} tâches restaurées",
      "sendEmail": "Envoyer un e-mail",
      "scheduleEmail": "Programmer un e-mail",
      "createEvent": "Créer un événement",
      "addNote": "Ajouter une note",
      "doWithThiia": "Faire avec Thiia",
      "doneByThiia": "Effectué par Thiia",
      "failed": "Échec",
      "quotaExhausted": "Quota épuisé",
      "buyCreditsPack": "Achetez un pack de crédits pour continuer.",
      "actionFailed": "Action échouée",
      "confirmSend": "Confirmer l'envoi ?",
      "thiiaWillSendEmail": "Thiia va envoyer l'e-mail correspondant à cette tâche.",
      "send": "Envoyer",
      "cancel": "Annuler",
      "noMatch": "Aucune tâche ne correspond",
      "goToChecklists": "Voir toutes les tâches"
    }
  },
  "miscComponents": {
    "addEventDialog": {
      "chooseType": "Quel type d'événement souhaitez-vous créer ?",
      "hostingTitle": "J'organise cet événement",
      "hostingDesc": "Vous êtes l'hôte : gérez invitations, RSVP, check-in et récap.",
      "attendingTitle": "Je participe à cet événement",
      "attendingDesc": "Vous êtes invité(e) : suivez la date, le lieu et vos notes.",
      "hostingHeader": "Créer un événement (organisateur)",
      "attendingHeader": "Ajouter un événement auquel vous participez",
      "continue": "Continuer",
      "meetingLinkCreated": "Lien de réunion créé",
      "meetingLinkError": "Impossible de créer le lien",
      "invitee": "Invité",
      "invitationsPartial": "Certaines invitations n'ont pas pu être envoyées",
      "rsvp": "Votre réponse",
      "rsvpGoing": "Je participe",
      "rsvpMaybe": "Peut-être",
      "rsvpDeclined": "Je ne participe pas",
      "organization": "Organisation",
      "chooseOrganization": "Choisir une organisation",
      "defaultSuffix": "par défaut",
      "when": "Quand",
      "duration": "Durée",
      "minutes": "Minutes",
      "hours": "Heures",
      "days": "Jours",
      "useDuration": "Utiliser une durée",
      "useEndTime": "Utiliser une heure de fin",
      "organizer": "Organisateur",
      "organizerName": "Nom de l'organisateur",
      "organizerPlaceholder": "Nom affiché aux invités",
      "eventLink": "Lien de l'événement",
      "recurrence": "Récurrence",
      "repeat": "Répétition",
      "noRecurrence": "Aucune",
      "daily": "Quotidienne",
      "weekly": "Hebdomadaire",
      "monthly": "Mensuelle",
      "yearly": "Annuelle",
      "until": "Jusqu'au",
      "noEnd": "Sans fin",
      "format": "Format",
      "online": "En ligne",
      "inPerson": "En présentiel",
      "videoconference": "Visioconférence",
      "suggested": "Suggéré :",
      "chooseService": "Choisir un service",
      "noLink": "Aucun lien",
      "googleAccount": "Compte Google",
      "chooseAccount": "Choisir un compte",
      "autoMeetingNote": "Le lien de visio sera créé automatiquement à la création de l'événement.",
      "connectProviders": "Connectez Google ou Microsoft dans les paramètres pour générer un lien automatiquement.",
      "locationAddress": "Adresse / Lieu",
      "addressPlaceholder": "Saisissez une adresse",
      "addressHint": "Les invités verront cette adresse dans l'invitation.",
      "guests": "Invités",
      "removeAll": "Tout retirer",
      "addProspects": "Ajouter des prospects",
      "selectedProspects": "{{count}} prospect(s) sélectionné(s)",
      "searchProspect": "Rechercher un prospect...",
      "noProspect": "Aucun prospect trouvé",
      "noName": "Sans nom",
      "remove": "Retirer",
      "filteredByOrg": "Liste filtrée par l'organisation choisie.",
      "creatingMeet": "Création du lien..."
    },
    "publishLinkedInDialog": {
      "tokenExpiredTitle": "Session LinkedIn expirée",
      "tokenExpiredDesc": "Reconnectez votre compte LinkedIn pour publier.",
      "syncedWithEditor": "Synchronisé avec l'éditeur",
      "displayMode": "Mode d'affichage",
      "editText": "Modifier le texte",
      "editionTab": "Édition",
      "previewTitle": "Aperçu LinkedIn",
      "previewTab": "Aperçu",
      "companyPageLabel": "Page entreprise",
      "personalProfileLabel": "Profil personnel",
      "justNow": "à l'instant",
      "linksNotClickable": "Les liens ne sont pas cliquables dans l'aperçu.",
      "linkedinActivationHint": "Activez la publication LinkedIn dans les paramètres.",
      "andMore": "et plus",
      "fixAll": "Tout corriger",
      "viewDetail": "Voir le détail",
      "seeLess": "Voir moins",
      "seeMore": "Voir plus",
      "ratio": "Ratio",
      "recommended": "recommandé",
      "previewBadge": "Aperçu",
      "croppedFor": "Rogné pour",
      "notPublishedYet": "Pas encore publié",
      "detectedLinks": "Liens détectés",
      "toFix": "À corriger",
      "urlsNotClickable": "Ces URLs ne sont pas cliquables sur LinkedIn.",
      "prefixAllTitle": "Préfixer toutes les URLs",
      "fix": "Corriger"
    },
    "richTextEditor": {
      "addLink": "Ajouter un lien",
      "bold": "Gras",
      "bulletList": "Liste à puces",
      "clearFormatting": "Effacer la mise en forme",
      "ctaButtonDefault": "En savoir plus",
      "ctaButtonText": "Texte du bouton",
      "ctaTitle": "Insérer un bouton d'action",
      "ctaUrl": "URL du bouton",
      "customColor": "Couleur personnalisée",
      "fontFamily": "Police",
      "heading1": "Titre 1",
      "heading2": "Titre 2",
      "heading3": "Titre 3",
      "insertCta": "Insérer un bouton",
      "insertImage": "Insérer une image",
      "italic": "Italique",
      "lineHeight": "Interligne",
      "link": "Lien",
      "linkUrl": "URL du lien",
      "max5mb": "Taille maximale : 5 Mo",
      "notAuthenticated": "Vous devez être connecté.",
      "orderedList": "Liste numérotée",
      "quote": "Citation",
      "redo": "Rétablir",
      "reset": "Réinitialiser",
      "selectImage": "Choisir une image",
      "separator": "Séparateur",
      "strike": "Barré",
      "textColor": "Couleur du texte",
      "tooLarge": "Fichier trop volumineux",
      "underline": "Souligné",
      "undo": "Annuler",
      "unsupportedFormat": "Format non pris en charge",
      "uploadError": "Erreur d'envoi"
    },
    "calendarPage": {
      "joinTeams": "Rejoindre Teams",
      "joinZoom": "Rejoindre Zoom",
      "joinMeet": "Rejoindre Meet",
      "joinWebex": "Rejoindre Webex",
      "joinJitsi": "Rejoindre Jitsi",
      "joinGoToMeeting": "Rejoindre GoToMeeting",
      "joinGoTo": "Rejoindre GoTo",
      "joinBlueJeans": "Rejoindre BlueJeans",
      "joinWhereby": "Rejoindre Whereby",
      "join8x8": "Rejoindre 8x8",
      "joinLifesize": "Rejoindre Lifesize",
      "joinDaily": "Rejoindre Daily",
      "joinAround": "Rejoindre Around",
      "joinLivestorm": "Rejoindre Livestorm",
      "joinClickMeeting": "Rejoindre ClickMeeting",
      "joinSkype": "Rejoindre Skype",
      "joinDiscord": "Rejoindre Discord",
      "joinSlack": "Rejoindre Slack",
      "joinMeeting": "Rejoindre la réunion",
      "linkCopied": "Lien copié !",
      "copyLinkFail": "Échec de la copie",
      "copyLink": "Copier le lien",
      "copyLinkAria": "Copier le lien de la réunion",
      "busySlotHidden": "Détails masqués (créneau occupé)",
      "tasks": "Tâches",
      "showDoneTasks": "Afficher les tâches terminées",
      "hideDoneTasksTitle": "Masquer les tâches terminées",
      "hideDoneTasks": "Masquer terminées",
      "doneTasks": "Terminées",
      "hideBusyTitle": "Masquer les créneaux occupés",
      "showBusyTitle": "Afficher les créneaux occupés",
      "busy": "Occupé",
      "noTasksToExport": "Aucune tâche à exporter",
      "tasksExported": "{{count}} tâches exportées ({{label}})",
      "exportTasksTitle": "Exporter les tâches vers Excel",
      "excel": "Excel",
      "visible": "visibles",
      "visibleTasks": "Tâches visibles uniquement",
      "thisWeekLabel": "cette semaine",
      "thisWeek": "Tâches de cette semaine",
      "thisMonthLabel": "ce mois-ci",
      "thisMonth": "Tâches de ce mois",
      "next30DaysLabel": "30 prochains jours",
      "next30Days": "Tâches des 30 prochains jours",
      "customRange": "Plage personnalisée...",
      "fromTo": "Du / Au",
      "startLabel": "Début",
      "endLabel": "Fin",
      "selectRange": "Sélectionnez une plage",
      "invalidRange": "La date de fin doit être après le début",
      "export": "Exporter",
      "viewError": "Erreur d'affichage",
      "reload": "Recharger",
      "openDetails": "Détails",
      "syncedFromGoogle": "Synchronisé depuis Google Calendar",
      "googleCalendar": "Google Calendar",
      "syncedFromOutlook": "Synchronisé depuis Outlook",
      "outlookCalendar": "Outlook",
      "editEvent": "Modifier l'événement",
      "edit": "Modifier",
      "deleteConfirmTitle": "Supprimer l'événement ?",
      "delete": "Supprimer",
      "deleteEvent": "Supprimer l'événement",
      "openActionsMenu": "Actions",
      "actions": "Actions",
      "details": "Détails",
      "showMoreDays": "Afficher {{count}} jour(s) de plus"
    }
  },
  "agentWatches": {
    "title": "Veilles Thiia",
    "subtitle": "Tâches récurrentes exécutées automatiquement par Thiia (ex. « Analyse mon LinkedIn tous les mardis et propose 3 posts »). Créez-en une ici ou demandez à Thiia dans le chat.",
    "pageSubtitle": "Tâches récurrentes que Thiia exécute automatiquement pour toi. Créez-en une en demandant dans le chat (ex : « Analyse mon LinkedIn tous les mardis à 6h et propose 3 posts »).",
    "newButton": "Nouvelle",
    "details": "Détails",
    "loading": "Chargement…",
    "empty": "Aucune veille active. Demandez à Thiia dans le chat.",
    "emptyLong": "Aucune veille pour le moment. Demandez à Thiia dans le chat de créer une tâche récurrente qu'elle exécutera pour vous.",
    "paused": "Pause",
    "pausedLong": "En pause",
    "nextRun": "prochain",
    "nextRunLabel": "Prochain",
    "localTime": "Heure locale",
    "changeTimezone": "Changer le fuseau horaire",
    "deleteTitle": "Supprimer",
    "deleteConfirm": "Supprimer la veille « {{title}} » ?",
    "deleteConfirmHard": "Supprimer définitivement la veille « {{title}} » ?",
    "deleted": "Veille supprimée",
    "paused_toast": "Veille mise en pause",
    "resumed_toast": "Veille réactivée",
    "invalidTz": "Fuseau horaire invalide",
    "tzUpdateFail": "Impossible de mettre à jour le fuseau",
    "tzUpdated": "Fuseau mis à jour : {{tz}}",
    "noRunYet": "Pas encore d'exécution.",
    "lastReport": "Dernier rapport",
    "viewLastReport": "Voir le dernier rapport",
    "reports": "Rapports",
    "reportsDesc": "3 derniers rapports générés par Thiia.",
    "testNow": "Tester",
    "testNowHint": "Exécuter une fois maintenant pour vérifier que la veille fonctionne (sans décaler la prochaine exécution).",
    "testRunning": "Test de « {{title}} » en cours…",
    "testSuccess": "✅ Test de « {{title}} » réussi — voir le rapport.",
    "testFailed": "❌ Test de « {{title}} » échoué : {{error}}",
    "testAlreadyRunning": "Une exécution est déjà en cours pour cette veille — patiente quelques secondes.",
    "badge": {
      "test": "Test"
    },
    "cron": {
      "everyDay": "Chaque jour à {{time}}",
      "everyDaily": "Chaque jour à {{time}} ({{tz}})",
      "everyDay_": "Tous les {{day}} à {{time}} ({{tz}})",
      "dayOfMonth": "Le {{dom}} de chaque mois à {{time}}",
      "dayOfMonthTz": "Le {{dom}} de chaque mois à {{time}} ({{tz}})",
      "everyDow": "Chaque {{day}} à {{time}}",
      "yearly": "Chaque année au mois {{month}}, {{time}}",
      "days": {
        "short": {
          "0": "dim.",
          "1": "lun.",
          "2": "mar.",
          "3": "mer.",
          "4": "jeu.",
          "5": "ven.",
          "6": "sam."
        },
        "long": {
          "0": "dimanche",
          "1": "lundi",
          "2": "mardi",
          "3": "mercredi",
          "4": "jeudi",
          "5": "vendredi",
          "6": "samedi"
        }
      }
    },
    "dialog": {
      "title": "Nouvelle veille Thiia",
      "desc": "Configurez une tâche récurrente que Thiia exécutera automatiquement pour vous.",
      "fieldTitle": "Titre",
      "titlePh": "Ex : Veille LinkedIn hebdomadaire",
      "goal": "Objectif",
      "optional": "(optionnel)",
      "goalPh": "Ce que Thiia doit surveiller ou produire…",
      "action": "Action",
      "frequency": "Fréquence",
      "cronPh": "0 6 * * 2",
      "cronRequired": "Expression cron requise",
      "cronInvalid": "Cron invalide",
      "timezone": "Fuseau horaire",
      "nextRun": "Prochaine exécution",
      "cancel": "Annuler",
      "continue": "Continuer",
      "confirmTitle": "Confirmer la création de la veille",
      "confirmDesc": "Vérifiez le récapitulatif ci-dessous avant validation.",
      "modify": "Modifier",
      "create": "Créer la veille",
      "creating": "Création…",
      "created": "Veille créée",
      "createFail": "Impossible de créer la veille",
      "recap": {
        "title": "Titre",
        "goal": "Objectif",
        "action": "Action",
        "frequency": "Fréquence",
        "timezone": "Fuseau",
        "nextRun": "Prochaine exécution"
      },
      "presets": {
        "daily8": "Chaque jour à 8h",
        "daily8Hint": "Idéal pour un briefing matinal",
        "weeklyTue6": "Chaque mardi à 6h",
        "weeklyTue6Hint": "Recommandé pour LinkedIn",
        "weeklyMon9": "Chaque lundi à 9h",
        "weeklyMon9Hint": "Kick-off de semaine",
        "monthly1": "Le 1er du mois à 9h",
        "monthly1Hint": "Bilan mensuel",
        "custom": "Cron personnalisé",
        "customHint": "Renseignez votre expression"
      },
      "actions": {
        "linkedinLabel": "Analyse LinkedIn + brouillons de posts",
        "linkedinDesc": "Thiia analyse votre activité LinkedIn puis prépare des idées et brouillons de posts."
      }
    },
    "history": {
      "title": "Historique des exécutions",
      "description": "Toutes les exécutions de cette veille : statut, durée, destinataire, envoi de l'email et erreurs.",
      "viewHistory": "Historique ({{count}})",
      "recipient": "Destinataire : {{email}}",
      "noRecipient": "Aucun destinataire résolu",
      "emailSentAt": "Email envoyé le {{time}}",
      "emailNotSent": "Aucun email envoyé",
      "emailSkippedTest": "Mode test — email non envoyé",
      "resultsCount": "{{count}} résultat(s)",
      "showItems": "Voir les {{count}} résultat(s)",
      "hideItems": "Masquer les résultats"
    },
    "edit": {
      "title": "Modifier la règle",
      "desc": "Ajustez l'objectif, la fréquence, le fuseau horaire et le destinataire de cette veille.",
      "recipient": "Email destinataire du rapport",
      "emailInvalid": "Adresse email invalide",
      "saved": "Règle mise à jour",
      "saveFail": "Impossible d'enregistrer la règle",
      "button": "Modifier",
      "instructions": "Instructions précises",
      "instructionsPlaceholder": "Ex. : ne retenir que les offres en Île-de-France, exclure les stages, privilégier les sources officielles…",
      "instructionsHint": "Ces consignes sont appliquées en priorité par Thiia lors de chaque exécution.",
      "recency": "Fraîcheur",
      "recencyOptions": {
        "day": "Dernier jour",
        "week": "7 derniers jours",
        "month": "30 derniers jours",
        "year": "12 derniers mois"
      },
      "maxItems": "Nombre de résultats max",
      "maxItemsHint": "Entre 1 et 20 résultats par exécution.",
      "sources": "Sources privilégiées",
      "sourcesPlaceholder": "Ex. : boamp, francetravail.fr, apec…",
      "sourcesAdd": "Ajouter une source",
      "sourcesHint": "Domaines ou plateformes à privilégier lors de la recherche. Laisser vide pour ne filtrer aucune source.",
      "sourcesAuthWalled": "Ces plateformes exigent une authentification et ne remonteront quasiment aucun résultat via la recherche web : {{list}}.",
      "sourcesResolved": "Domaines réellement filtrés à la dernière exécution : {{list}}",
      "sourcesUnmapped": "Libellés non reconnus, ignorés par le filtre : {{list}}",
      "keywords": "Mots-clés prioritaires",
      "keywordsPlaceholder": "Ex. : transformation, coaching, appel d'offres…",
      "keywordsAdd": "Ajouter un mot-clé",
      "keywordsHint": "Termes mis en avant dans la recherche. Laisser vide pour ne prioriser aucun terme."
    },
    "versions": {
      "button": "Versions",
      "title": "Historique des versions",
      "desc": "Chaque modification de la règle est archivée. Restaurez une version précédente en un clic.",
      "empty": "Aucune version archivée pour l'instant. Les versions apparaissent dès la première modification.",
      "restore": "Restaurer",
      "restored": "Version v{{n}} restaurée",
      "restoreFail": "Impossible de restaurer cette version",
      "confirmTitle": "Restaurer cette version ?",
      "confirmDesc": "La règle sera remplacée par la version v{{n}} (titre, objectif, instructions, fréquence, fuseau horaire). La version actuelle sera archivée."
    },
    "items": {
      "untitled": "(sans titre)",
      "whyRelevant": "Pourquoi c'est recommandé",
      "sourceExplanation": "Source",
      "confidence": {
        "high": "Fiabilité élevée",
        "medium": "Fiabilité moyenne",
        "low": "Fiabilité faible"
      },
      "urlStatus": {
        "verified": "Lien vérifié",
        "same_domain": "Page source",
        "unverified": "Lien non vérifié",
        "search_fallback": "Recherche web"
      }
    }
  },
  "chatComponents": {
    "sources": {
      "title": "Sources",
      "copy": "Copier",
      "copyAll": "Copier toutes les sources",
      "copied": "Sources copiées",
      "copiedShort": "Copié",
      "copyFailed": "Copie impossible",
      "showMore": "Voir toutes ({{count}})",
      "showLess": "Réduire"
    },
    "giveReformulateInstructions": "Veuillez indiquer des instructions de reformulation.",
    "templateSaveFailed": "Échec de l'enregistrement du modèle.",
    "templateSaved": "Modèle enregistré.",
    "templateUpdateFailed": "Échec de la mise à jour du modèle.",
    "signatureSaved": "Signature enregistrée.",
    "subjectBodyRequired": "L'objet et le corps du message sont requis.",
    "subjectBodyDateRequired": "L'objet, le corps et la date sont requis.",
    "scheduleDateFuture": "La date de planification doit être dans le futur.",
    "invalidEmail": "Adresse e-mail invalide.",
    "throttleTooltip": "Espacer les envois pour éviter d'être signalé comme spam.",
    "trackClicksTooltip": "Suivre les clics sur les liens de l'e-mail.",
    "actionBlockUnparsed": "Bloc d'action non analysable",
    "activityAnalysisDone": "Analyse d'activité terminée",
    "addToNote": "Ajouter à la note",
    "addedToNote": "Ajouté à la note",
    "analysisCopied": "Analyse copiée",
    "annotateComment": "Annoter / commenter",
    "archive": "Archiver",
    "badAnswer": "Mauvaise réponse",
    "companySearchFailed": "Échec de la recherche d'entreprise",
    "copied": "Copié",
    "copy": "Copier",
    "copyAllCitations": "Copier toutes les citations",
    "copyAllUrls": "Copier toutes les URL",
    "copyEmail": "Copier l'e-mail",
    "copyForMail": "Copier pour e-mail",
    "copyImage": "Copier l'image",
    "copyImpossible": "Copie impossible",
    "copyMessage": "Copier le message",
    "copyMessageLink": "Copier le lien du message",
    "copyPhone": "Copier le téléphone",
    "copyRichForMail": "Copier (mise en forme) pour e-mail",
    "createBranch": "Créer une branche",
    "dataCopied": "Données copiées",
    "delete": "Supprimer",
    "deleteBranchConfirmDesc": "Cette branche et tous ses messages seront supprimés.",
    "deleteBranchConfirmTitle": "Supprimer la branche ?",
    "deleteConvConfirmDesc": "Cette conversation et tous ses messages seront supprimés.",
    "deleteConvConfirmTitle": "Supprimer la conversation ?",
    "deleteMessage": "Supprimer le message",
    "deleteMessageConfirm": "Supprimer ce message ?",
    "download": "Télécharger",
    "editMessage": "Modifier le message",
    "emailCopied": "E-mail copié",
    "employees": "employés",
    "enrichErrorPrefix": "Erreur d'enrichissement",
    "enrichSuccess": "Enrichissement réussi",
    "errorPrefix": "Erreur",
    "eventAnalysisDone": "Analyse d'événement terminée",
    "exportAnalyzedExcel": "Exporter (Excel)",
    "exportWordQA": "Exporter Q/R en Word",
    "goodAnswer": "Bonne réponse",
    "import": "Importer",
    "leader": "dirigeant",
    "linkedin": "LinkedIn",
    "moveTo": "Déplacer vers",
    "newFolder": "Nouveau dossier",
    "noConversation": "Aucune conversation",
    "noResult": "Aucun résultat",
    "noSourceAvailable": "Aucune source disponible",
    "openInMailer": "Ouvrir dans le client mail",
    "openMailer": "Ouvrir le client mail",
    "openProspectSheet": "Ouvrir la fiche prospect",
    "outOfFolder": "Hors dossier",
    "phoneCopied": "Téléphone copié",
    "pinnedMessage": "Message épinglé",
    "preview": "Aperçu",
    "previewAndExport": "Aperçu et export",
    "publishOnLinkedIn": "Publier sur LinkedIn",
    "quoteInReply": "Citer dans la réponse",
    "regenerateAnswer": "Régénérer la réponse",
    "rename": "Renommer",
    "resendPrompt": "Renvoyer la question",
    "resetConv": "Réinitialiser la conversation",
    "retrySearch": "Réessayer la recherche",
    "richCopySuccess": "Copié avec mise en forme",
    "runInSubConversation": "Exécuter dans une sous-conversation",
    "runThisAction": "Exécuter cette action",
    "searchCancelled": "Recherche annulée",
    "searchErrorPrefix": "Erreur de recherche",
    "searchSaved": "Recherche enregistrée",
    "seeCode": "Voir le code",
    "selectAllToggle": "Tout sélectionner",
    "serviceOverloaded": "Service surchargé, réessayez.",
    "share": "Partager",
    "shareByEmail": "Partager par e-mail",
    "site": "site",
    "skipCacheRetry": "Réessayer sans cache",
    "sortEvents": "Trier les événements",
    "sortResults": "Trier les résultats",
    "subfolder": "Sous-dossier",
    "toggleSelectAllEvents": "Tout sélectionner / désélectionner",
    "unarchive": "Désarchiver",
    "viewActive": "Actifs",
    "viewArchived": "Archivés",
    "viewCards": "Cartes",
    "viewList": "Liste",
    "viewTable": "Tableau",
    "wordExported": "Document Word exporté",
    "yesterday": "hier",
    "searchErrorPrefix2": "Erreur de recherche",
    "searchDeleted": "Recherche supprimée",
    "scoringErrorPrefix": "Erreur de scoring",
    "resetConversation": "Réinitialiser la conversation",
    "voiceMode": "Mode voix",
    "generateImageQuality": "Qualité de génération d'image",
    "backToMainConv": "Retour à la conversation principale",
    "reinjectConclusion": "Réinjecter la conclusion",
    "cancelUpload": "Annuler le téléversement"
  },
  "ownerComponents": {
    "aiUsage": {
      "aiCalls": "Appels IA",
      "alerts": {
        "coachCallsExceeded": "Un coach a dépassé son quota d'appels.",
        "coachCallsWarning": "Un coach approche de son quota d'appels.",
        "coachCostExceeded": "Un coach a dépassé son quota de coût.",
        "coachCostWarning": "Un coach approche de son quota de coût.",
        "globalCallsExceeded": "Quota global d'appels dépassé.",
        "globalCallsWarning": "Quota global d'appels bientôt atteint.",
        "globalCostExceeded": "Quota global de coût dépassé.",
        "globalCostWarning": "Quota global de coût bientôt atteint."
      },
      "alertsBtn": "Alertes",
      "all": "Tous",
      "allUsers": "Tous les utilisateurs",
      "attention": "Attention",
      "breakdownByModel": "Répartition par modèle",
      "breakdownByType": "Répartition par type",
      "calls": "Appels",
      "callsCount": "Nombre d'appels",
      "callsPerDay": "Appels par jour",
      "configureThresholds": "Configurer les seuils",
      "cost": "Coût",
      "date": "Date",
      "error": "Erreur",
      "estimatedCost": "Coût estimé",
      "estimatedCostShort": "Coût est.",
      "exceeded": "Dépassé",
      "exportCsv": "Exporter CSV",
      "function": "Fonction",
      "functions": "Fonctions",
      "globalThresholds": "Seuils globaux",
      "inAppNotifications": "Notifications dans l'application",
      "inputTokens": "Tokens en entrée",
      "last30Days": "30 derniers jours",
      "last7Days": "7 derniers jours",
      "last90Days": "90 derniers jours",
      "model": "Modèle",
      "modelDetail": "Détail du modèle",
      "models": "Modèles",
      "monthlyCalls": "Appels mensuels",
      "monthlyCost": "Coût mensuel",
      "noData": "Aucune donnée",
      "noLogs": "Aucun log",
      "noUsagePeriod": "Aucune utilisation sur la période",
      "ok": "OK",
      "outputTokens": "Tokens en sortie",
      "perUserThresholds": "Seuils par utilisateur",
      "pricePerCall": "Prix par appel",
      "recentLogs": "Logs récents",
      "saveThresholds": "Enregistrer les seuils",
      "saving": "Enregistrement…",
      "status": "Statut",
      "thresholdExceeded": "Seuil dépassé",
      "thresholdsSaved": "Seuils enregistrés",
      "title": "Utilisation IA",
      "tokens": "Tokens",
      "tokensIn": "Tokens (entrée)",
      "tokensOut": "Tokens (sortie)",
      "user": "Utilisateur",
      "users": "Utilisateurs"
    },
    "incidentDialog": {
      "created": "Incident créé",
      "description": "Description",
      "editTitle": "Modifier l'incident",
      "error": "Une erreur est survenue",
      "newTitle": "Nouvel incident",
      "severity": "Sévérité",
      "severityCritical": "Critique",
      "severityHigh": "Élevée",
      "severityLow": "Faible",
      "severityMedium": "Moyenne",
      "status": "Statut",
      "statusInvestigating": "Investigation",
      "statusOpen": "Ouvert",
      "titleLabel": "Titre",
      "titleRequired": "Le titre est requis",
      "updated": "Incident mis à jour",
      "statusResolved": "Résolu",
      "statusClosed": "Clôturé",
      "category": "Catégorie",
      "catDataBreach": "Violation de données",
      "catUnauthorizedAccess": "Accès non autorisé",
      "catServiceOutage": "Panne de service",
      "catMalware": "Logiciel malveillant",
      "catConfigError": "Erreur de configuration",
      "catThirdParty": "Tiers",
      "catOther": "Autre",
      "affectedUsers": "Utilisateurs affectés",
      "detectedAt": "Détecté le",
      "resolvedAt": "Résolu le",
      "affectedDataTypes": "Types de données affectés",
      "affectedDataTypesPlaceholder": "Ex. e-mails, mots de passe…",
      "cnilRequired": "Notification CNIL requise",
      "notifiedAt": "Notifié le",
      "cnilRef": "Référence CNIL",
      "cnilRefPlaceholder": "Numéro de dossier CNIL",
      "usersNotifiedAt": "Utilisateurs notifiés le",
      "mitigationActions": "Actions de mitigation",
      "rootCause": "Cause racine",
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "imap": {
      "testSuccessTitle": "Connexion réussie",
      "testSuccessDesc": "Le compte est correctement configuré.",
      "missingFields": "Champs manquants",
      "missingFieldsDesc": "Complétez tous les champs requis.",
      "passwordRequired": "Mot de passe requis",
      "passwordRequiredDesc": "Saisissez le mot de passe du compte.",
      "invalidEmail": "E-mail invalide",
      "invalidEmailDesc": "Saisissez une adresse e-mail valide.",
      "accountUpdated": "Compte mis à jour",
      "accountAdded": "Compte ajouté",
      "error": "Erreur",
      "orgUpdated": "Organisation mise à jour",
      "sendFailed": "Échec de l'envoi",
      "testEmailSent": "E-mail de test envoyé",
      "title": "Comptes e-mail IMAP",
      "subtitle": "Configurez vos comptes IMAP/SMTP pour envoyer et recevoir des e-mails.",
      "add": "Ajouter",
      "noAccounts": "Aucun compte configuré",
      "default": "Par défaut",
      "linkedOrg": "Organisation liée",
      "noOrgShort": "Aucune",
      "noOrg": "Aucune organisation",
      "setDefault": "Définir par défaut",
      "sendTestEmail": "Envoyer un e-mail de test",
      "edit": "Modifier",
      "delete": "Supprimer",
      "editAccount": "Modifier le compte",
      "addAccount": "Ajouter un compte",
      "editAccountDesc": "Mettez à jour les informations du compte.",
      "addAccountDesc": "Ajoutez un compte IMAP/SMTP.",
      "provider": "Fournisseur",
      "officialGuide": "Guide officiel",
      "emailAddress": "Adresse e-mail",
      "emailPlaceholder": "nom@exemple.com",
      "displayName": "Nom affiché",
      "displayNamePlaceholder": "Ex. Support",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "keepCurrentPassword": "Laisser vide pour conserver le mot de passe actuel",
      "imapServer": "Serveur IMAP",
      "port": "Port",
      "sslImap": "SSL/TLS (IMAP)",
      "smtpServer": "Serveur SMTP",
      "sslSmtp": "SSL/TLS (SMTP)",
      "linkedOrgOptional": "Organisation liée (optionnel)",
      "orgFilterHelp": "Filtrer les e-mails par organisation.",
      "setAsDefault": "Définir par défaut",
      "test": "Tester",
      "update": "Mettre à jour",
      "save": "Enregistrer"
    },
    "voiceCommands": {
      "activated": "Activé",
      "activationFailed": "Échec de l'activation",
      "deactivationFailed": "Échec de la désactivation",
      "deactivated": "Désactivé",
      "copied": "Copié",
      "browserUnsupported": "Navigateur non pris en charge",
      "showTokenFirst": "Affichez d'abord votre code personnel",
      "micError": "Erreur micro",
      "noResponse": "Aucune réponse",
      "errorPrefix": "Erreur",
      "heading": "Commandes vocales",
      "activatedBadge": "Activé",
      "introText": "Pilotez Thiia à la voix depuis vos appareils.",
      "activateOneClick": "Activation en un clic",
      "activateDesc": "Générez un code personnel pour utiliser les commandes vocales.",
      "activateButton": "Activer",
      "personalCode": "Code personnel",
      "codeCopied": "Code copié",
      "copy": "Copier",
      "hideCode": "Masquer le code",
      "testNow": "Tester maintenant",
      "testDesc": "Prononcez une commande pour vérifier la reconnaissance.",
      "generateFirst": "Générez un code d'abord pour tester la commande vocale.",
      "speakToThiia": "Parler à Thiia",
      "stop": "Arrêter",
      "youSaid": "Vous avez dit :",
      "thiiaReplies": "Thiia répond :",
      "installOnPhone": "Installer sur votre téléphone",
      "chooseDevice": "Choisissez votre appareil pour voir les instructions de configuration.",
      "iphone": "iPhone",
      "android": "Android",
      "iphoneStep1Title": "Installer le raccourci",
      "iphoneStep1Desc": "Ouvrez l'application Raccourcis et créez un nouveau raccourci pour envoyer une requête POST.",
      "iphoneStep2Title": "Configurer l'URL",
      "iphoneStep2Desc": "Utilisez l'URL et le code d'autorisation fournis ci-dessous.",
      "iphoneStep3Title": "Ajouter à l'écran d'accueil",
      "iphoneStep3Desc": "Vous pouvez maintenant lancer la commande directement depuis votre écran ou via Siri.",
      "urlCopied": "URL copiée dans le presse-papier",
      "copyUrl": "Copier l'URL",
      "copyAuthCode": "Copier le code d'accès",
      "thenSay": "Ensuite, vous pouvez dire \"Dis Siri, [nom du raccourci]\" suivi de votre demande.",
      "androidStep1Title": "Installer Tasker ou une application de requêtes HTTP",
      "androidStep1Desc": "Utilisez une application capable de passer des appels HTTP depuis un widget ou l'assistant.",
      "androidStep2Title": "Scanner le code QR",
      "androidStep2Desc": "Ce code QR contient l'URL pré-configurée et votre jeton unique.",
      "androidStep3Title": "Configurer le déclencheur",
      "androidStep3Desc": "Associez cette requête à un widget ou à un geste vocal.",
      "qrAlt": "Code QR de configuration",
      "scanWithApp": "Scannez ce code avec votre téléphone pour configurer la commande automatiquement.",
      "qrAfterCode": "Générez un code personnel ci-dessus pour afficher le code QR de configuration.",
      "manageAccess": "Gérer les appareils autorisés",
      "createdOn": "Créé le {{date}}",
      "lastUsed": "Dernière utilisation le {{date}}",
      "deactivate": "Désactiver",
      "regenerateCode": "Régénérer un nouveau code",
      "lastCommands": "Dernières commandes",
      "errorLabel": "Erreur",
      "advancedConfig": "Configuration avancée (API)"
    },
    "docTemplate": {
      "themeNotLoaded": "Le thème global n'est pas encore chargé.",
      "globalThemeApplied": "Thème global appliqué.",
      "styleSaved": "Charte graphique enregistrée.",
      "nameRequired": "Le nom du modèle est requis.",
      "templateUpdated": "Modèle mis à jour avec succès.",
      "templateCreated": "Modèle créé avec succès.",
      "saveFirst": "Veuillez enregistrer le modèle avant d'ajouter des fichiers.",
      "fileTooLarge": "Le fichier est trop volumineux (max 10 Mo).",
      "fileUploaded": "Fichier mis en ligne.",
      "fileDeleted": "Fichier supprimé.",
      "uploadCoverFirst": "Veuillez d'abord mettre en ligne une page de garde au format PDF.",
      "coverNotFound": "Impossible de récupérer le fichier PDF.",
      "analyzeFailed": "L'analyse du document a échoué.",
      "noteWizardEdit": "Modification via l'assistant de champs dynamiques",
      "fieldsUpdated": "Champs dynamiques mis à jour.",
      "historyLoadFailed": "Impossible de charger l'historique.",
      "confirmRestoreTitle": "Restaurer cette version ?",
      "confirmRestoreDesc": "La configuration actuelle des champs sera remplacée par celle de cette version.",
      "restore": "Restaurer",
      "noteBeforeRestore": "État avant restauration d'une version précédente",
      "versionRestored": "Version restaurée avec succès.",
      "editTemplate": "Modifier le modèle",
      "newTemplate": "Nouveau modèle",
      "sheetDesc": "Configurez les fichiers PDF/Word et la charte graphique de vos documents.",
      "name": "Nom du modèle",
      "namePlaceholder": "ex: Modèle Standard",
      "descriptionOptional": "Description (optionnelle)",
      "descriptionPlaceholder": "Détails sur l'utilisation de ce modèle...",
      "defaultTemplate": "Modèle par défaut",
      "defaultTemplateDesc": "Utilisé automatiquement pour les nouveaux documents si aucun autre modèle n'est choisi.",
      "save": "Enregistrer",
      "createTemplate": "Créer le modèle",
      "pages": "Pages et fichiers",
      "fileLoaded": "Fichier chargé",
      "replace": "Remplacer",
      "upload": "Mettre en ligne",
      "coverDynamicFields": "Champs dynamiques",
      "fieldsConfigured": "{{count}} champs configurés",
      "markFieldsHint": "Cliquez sur 'Modifier' pour marquer les zones à remplir sur le PDF.",
      "modificationHistory": "Historique des modifications",
      "history": "Historique",
      "edit": "Modifier",
      "styleGuide": "Charte graphique",
      "import": "Importer",
      "fromAnotherTemplate": "Depuis un autre modèle",
      "noTemplateAvailable": "Aucun autre modèle disponible",
      "styleImportedFrom": "Style importé de {{name}}",
      "fromGlobalTheme": "Depuis le thème global",
      "importJsonFile": "Importer un fichier JSON",
      "export": "Exporter",
      "preview": "Aperçu",
      "noValidColor": "Aucune couleur valide trouvée dans le fichier.",
      "colorsImported": "{{count}} couleurs importées.",
      "invalidJson": "JSON invalide : {{message}}",
      "syncGlobalTheme": "Synchroniser avec le thème global",
      "syncGlobalThemeDesc": "Les couleurs Primaire et Accent suivront les réglages de votre application.",
      "globalTag": "(Global)",
      "headingFont": "Police des titres",
      "bodyFont": "Police du texte",
      "saveStyle": "Enregistrer la charte",
      "close": "Fermer",
      "wizardDesc": "Sélectionnez les zones de texte sur votre document pour les transformer en champs dynamiques.",
      "wizardError": "Une erreur est survenue dans l'assistant",
      "retry": "Réessayer",
      "dynamicFieldsHistory": "Historique des champs",
      "historyDesc": "Retrouvez les versions précédentes de la configuration des champs.",
      "noVersions": "Aucune version enregistrée.",
      "coverBackFieldsCount": "{{coverCount}} champs (garde) · {{backCount}} champs (fin)"
    }
  },
  "prospectComponents": {
    "whatsAppComposer": {
      "unknownError": "Erreur inconnue",
      "error": "Erreur",
      "confirmDeleteTemplate": "Supprimer ce modèle ?",
      "templateDeleted": "Modèle supprimé",
      "saveFailed": "Échec de l'enregistrement",
      "templateSaved": "Modèle enregistré",
      "errNoOrg": "Aucune organisation configurée",
      "errSelectOrg": "Sélectionnez une organisation",
      "errInvalidSenderNumber": "Numéro d'expéditeur invalide",
      "errWrongTemplateField": "Champ de modèle incorrect",
      "errTemplateNameFormat": "Nom de modèle Meta invalide (minuscules, chiffres et _)",
      "errEmptyMessage": "Le message est vide",
      "errMessageTooLong": "Message trop long",
      "warnNoTemplate24h": "Sans modèle, l'envoi n'est possible que dans les 24 h suivant la dernière réponse.",
      "errNoRecipient": "Aucun destinataire",
      "errNoValidNumber": "Aucun numéro valide",
      "warnInvalidPhones": "Certains numéros sont invalides",
      "warnOptedOut": "Certains destinataires ont refusé les messages",
      "errScheduleFuture": "La date de planification doit être dans le futur",
      "sentScheduledTitle": "Envoi planifié",
      "sentDoneTitle": "Envoi terminé",
      "descScheduled": "{{count}} message(s) planifié(s)",
      "skippedPart": "{{count}} ignoré(s)",
      "descSent": "{{count}} message(s) envoyé(s)",
      "failedPart": "{{count}} en échec",
      "sendFailedTitle": "Échec de l'envoi",
      "retryDoneTitle": "Relance terminée",
      "retryDoneDesc": "{{ok}} succès · {{ko}} échec",
      "koPart": "{{count}} échec(s)",
      "retryFailedTitle": "Échec de la relance",
      "messageResent": "Message renvoyé",
      "newFailure": "Nouvel échec",
      "failureTitle": "Échec",
      "titleBulk": "Envoi WhatsApp groupé",
      "titleSingle": "Envoi WhatsApp",
      "sheetDescription": "Composez et envoyez un message WhatsApp.",
      "noOrgAlertPart1": "Configurez d'abord une organisation WhatsApp dans ",
      "noOrgAlertSettings": "Paramètres",
      "noOrgAlertPart2": " pour commencer.",
      "sendFrom": "Envoyer depuis",
      "chooseOrg": "Choisir une organisation",
      "templatesCount": "{{count}} modèle(s)",
      "clear": "Effacer",
      "saveCurrentAsTemplate": "Enregistrer comme modèle",
      "save": "Enregistrer",
      "searchTemplate": "Rechercher un modèle…",
      "loading": "Chargement…",
      "noTemplatesYet": "Aucun modèle enregistré",
      "noTemplatesMatch": "Aucun modèle correspondant",
      "metaTemplate": "Modèle Meta",
      "removeFavorite": "Retirer des favoris",
      "markFavorite": "Ajouter aux favoris",
      "deleteTitle": "Supprimer",
      "metaTemplateNameLabel": "Nom du modèle Meta",
      "metaTemplateNamePlaceholder": "ex. bienvenue_client",
      "metaTemplateHelp": "Doit correspondre exactement à un modèle approuvé dans Meta Business.",
      "messageLabel": "Message",
      "messagePlaceholder": "Écrivez votre message…",
      "variablesLabel": "Variables",
      "previewPerRecipient": "Aperçu par destinataire",
      "missingVarsCount": "{{count}} variable(s) manquante(s)",
      "prospectFallback": "Prospect",
      "noValueEmpty": "(vide)",
      "emptyMessage": "(message vide)",
      "blockingErrors": "Erreurs bloquantes",
      "scheduleSend": "Planifier l'envoi",
      "dateTime": "Date et heure",
      "timezone": "Fuseau horaire",
      "browserTz": "Fuseau du navigateur",
      "yourTz": "Votre fuseau",
      "scheduleHelp": "L'envoi sera exécuté à l'heure prévue.",
      "scheduleFutureError": "La date doit être dans le futur",
      "sendResults": "Résultats d'envoi",
      "sentCount": "{{count}} envoyé(s)",
      "scheduledCount": "{{count}} planifié(s)",
      "failedCount": "{{count}} échoué(s)",
      "retryFailedCount": "Relancer les {{count}} échec(s)",
      "statusScheduled": "Planifié",
      "statusOptOut": "Opt-out",
      "statusSent": "Envoyé",
      "statusFailed": "Échec",
      "retry": "Réessayer",
      "close": "Fermer",
      "cancel": "Annuler",
      "scheduleFor": "Planifier pour",
      "sendTo": "Envoyer à",
      "confirmSchedule": "Confirmer la planification",
      "confirmScheduleBody": "Vous êtes sur le point de planifier l'envoi.",
      "confirmScheduleFooter": "Vous pourrez annuler avant la date d'envoi.",
      "optedOutExcluded": "Les destinataires opt-out seront exclus.",
      "saveTemplateTitle": "Enregistrer comme modèle",
      "saveTemplateDesc": "Ce modèle sera disponible pour vos prochains envois.",
      "nameRequired": "Nom requis",
      "nameExample": "ex. Relance J+7",
      "category": "Catégorie",
      "categoryExample": "ex. Prospection",
      "description": "Description",
      "descriptionPlaceholder": "Notes internes…",
      "savedContent": "Contenu enregistré"
    }
  },
  "legalDocs": {
    "effectiveDate": "1er avril 2026",
    "footerHeading": "Documents légaux",
    "kind": {
      "contract": "Document contractuel",
      "info": "Information légale"
    },
    "index": {
      "securityPolicy": "Politique de sécurité",
      "gdprObligations": "Vos obligations RGPD"
    },
    "layout": {
      "documents": "Les documents",
      "inThisDoc": "Dans ce document",
      "goToSection": "Aller à une section",
      "effectiveSince": "En vigueur depuis le {{date}}",
      "nextDoc": "Document suivant",
      "downloadPdf": "Télécharger en PDF",
      "pdf": "PDF",
      "versionHistory": "Historique des versions",
      "versionHistoryLine": "Version {{version}} — en vigueur depuis le {{date}}."
    },
    "plain": {
      "heading": "En clair, avant le texte juridique",
      "disclaimer": "Ce résumé n'a pas de valeur contractuelle.",
      "legal": {
        "l1": "Thiia est édité par KREAPP SAS, société française.",
        "l2": "Les données sont hébergées dans l'Union européenne.",
        "l3": "Une adresse de contact est indiquée pour toute question.",
        "l4": "Le contenu du site appartient à son éditeur."
      },
      "terms": {
        "l1": "Vous achetez des packs de crédits, une fois : pas d'abonnement.",
        "l2": "Les crédits n'expirent pas et rien ne se reconduit tout seul.",
        "l3": "Vous restez responsable des messages envoyés depuis Thiia.",
        "l4": "Vos données de prospects ne sont jamais revendues."
      },
      "privacy": {
        "l1": "Vos données servent à fournir le service, rien d'autre.",
        "l2": "L'IA utilisée ne s'entraîne pas sur vos données.",
        "l3": "Vous pouvez exporter ou supprimer vos données à tout moment.",
        "l4": "Les sous-traitants sont listés et hébergés en Europe."
      }
    },
    "terms": {
      "noResale": {
        "title": "Non-revente des données"
      },
      "credits": {
        "title": "Packs de crédits et durée de validité",
        "body": "L'accès aux fonctionnalités de Thiia s'achète sous forme de packs de crédits réglés en une fois. Il n'existe ni abonnement, ni coût par utilisateur, ni reconduction automatique.",
        "starter": "Pack Starter",
        "starterValue": "29 € une fois",
        "pro": "Pack Pro",
        "proValue": "59 € une fois",
        "enterprise": "Pack Enterprise",
        "enterpriseValue": "99 € une fois",
        "validity": "Durée de validité des crédits",
        "validityValue": "Sans expiration",
        "renewal": "Reconduction",
        "renewalValue": "Aucune"
      }
    },
    "docs": {
      "sections": {
        "tutoriels": {
          "title": "Tutoriels & Guide",
          "badge": "Populaire",
          "intro": "Maîtrisez Thiia en quelques minutes avec nos guides pas à pas pour les cas d'usage les plus fréquents."
        },
        "demarrage": {
          "title": "Démarrage rapide",
          "badge": "Essentiel",
          "intro": "Tout ce qu'il faut savoir pour bien débuter avec Thiia et configurer votre espace de travail."
        },
        "chat": {
          "title": "Chat avec Thiia",
          "intro": "L'assistant IA conversationnel au cœur de votre expérience Thiia."
        },
        "annotations": {
          "title": "Annotations & Surlignage",
          "badge": "Nouveau",
          "intro": "Collaborez efficacement en annotant les réponses de l'IA directement dans le chat."
        },
        "documents-prospect": {
          "title": "Documents prospect",
          "badge": "Beta",
          "intro": "Centralisez et interrogez vos documents (PDF, contrats, factures) grâce à l'IA."
        },
        "cloud-drives": {
          "title": "Imports Cloud (Drive...)",
          "badge": "Nouveau",
          "intro": "Connectez vos services de stockage favoris pour importer vos documents en un clic."
        },
        "recherche": {
          "title": "Recherche intelligente",
          "intro": "Trouvez des prospects, des entreprises et des événements pertinents avec l'IA."
        },
        "prospects": {
          "title": "Gestion des prospects",
          "intro": "Organisez votre pipeline commercial et suivez l'évolution de vos relations."
        },
        "emails": {
          "title": "Emails & Séquences",
          "intro": "Gérez vos communications directement depuis Thiia avec l'aide de l'IA."
        },
        "evenements": {
          "title": "Événements & Networking",
          "intro": "Organisez vos participations aux salons et gérez vos contacts sur place."
        },
        "taches": {
          "title": "Tâches & Checklists",
          "intro": "Ne perdez plus jamais le fil de vos actions prioritaires."
        },
        "contenu": {
          "title": "Création de contenu",
          "intro": "Générez des posts LinkedIn, newsletters et articles en quelques secondes."
        },
        "bienetre": {
          "title": "Bien-être & Énergie",
          "intro": "Parce que votre réussite dépend aussi de votre équilibre personnel."
        },
        "integrations": {
          "title": "Intégrations & API",
          "intro": "Connectez Thiia à vos outils existants pour un workflow fluide."
        },
        "parametres": {
          "title": "Paramètres & Compte",
          "intro": "Configurez votre profil, vos organisations et vos préférences."
        }
      }
    },
    "privacy": {
      "rightsExport": {
        "title": "Droits et portabilité des données",
        "intro": "Vous disposez d'un droit d'accès, de rectification ou d'exportation de vos données personnelles à tout moment.",
        "dpoLabel": "Délégué à la Protection des Données :",
        "cnilLabel": "Autorité de contrôle (CNIL) :"
      },
      "noResale": {
        "title": "Non-revente des données"
      },
      "subprocessors": {
        "title": "Sous-traitants"
      },
      "cookies": {
        "title": "Cookies et statistiques",
        "tableTitle": "Liste des cookies utilisés",
        "table": {
          "headers": {
            "name": "Nom",
            "purpose": "Finalité",
            "duration": "Durée de conservation",
            "provider": "Fournisseur"
          },
          "rows": {
            "ga": "Google Analytics - suivi statistique de la fréquentation du site.",
            "gid": "Google Analytics - identification des utilisateurs uniques.",
            "gat": "Google Analytics - utilisé pour limiter le taux de requêtes."
          },
          "duration13m": "13 mois",
          "duration24h": "24 heures",
          "duration1min": "1 minute"
        }
      },
      "legalBasis": {
        "title": "Bases légales du traitement",
        "intro": "Conformément au RGPD, nous traitons vos données sur les bases légales suivantes :"
      },
      "fullRights": {
        "title": "Vos droits au titre du RGPD",
        "intro": "Vous disposez de plusieurs droits concernant vos données personnelles :"
      },
      "securityGovernance": {
        "title": "Sécurité et Gouvernance IA",
        "intro": "Pour plus de détails sur nos pratiques de sécurité et notre gouvernance de l'IA, veuillez consulter les documents suivants :",
        "links": {
          "overview": "Vue d'ensemble de la sécurité",
          "policy": "Politique de Sécurité des Systèmes d'Information (PSSI)",
          "aiPolicy": "Politique d'éthique et de gouvernance de l'IA",
          "aiia": "Analyse d'Impact relative à l'IA (AIIA)",
          "incident": "Procédure de gestion des incidents de sécurité"
        }
      }
    }
  },
  "adminPages": {
    "common": {
      "back": "Retour",
      "error": "Erreur",
      "email": "E-mail",
      "reset": "Réinitialiser",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "name": "Nom",
      "actions": "Actions",
      "edit": "Modifier",
      "save": "Enregistrer",
      "refresh": "Actualiser",
      "loading": "Chargement en cours...",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "orgSettings": {
      "title": "Configuration par organisation",
      "description": "Gérez les règles, templates et sources spécifiques à chaque organisation.",
      "globalConfig": "Configuration globale (par défaut)",
      "editingFor": "Modification pour :"
    },
    "whatsappHistory": {
      "organization": "Organisation",
      "cancelFailed": "Échec de l'annulation",
      "sendCanceled": "Envoi annulé avec succès",
      "title": "Historique WhatsApp",
      "total": "Total messages",
      "delivered": "Livrés",
      "scheduled": "Programmés",
      "failed": "Échecs",
      "searchPlaceholder": "Rechercher par nom, numéro ou contenu...",
      "queued": "En attente",
      "sent": "Envoyés",
      "read": "Lus",
      "canceled": "Annulés",
      "allOrganizations": "Toutes les organisations",
      "noMessagesYet": "Aucun message WhatsApp envoyé pour le moment.",
      "noMessagesMatchFilters": "Aucun message ne correspond à vos filtres.",
      "prospect": "Prospect",
      "templateLabel": "Modèle : {{sid}}",
      "optOutAfterScheduling": "Désinscription après programmation",
      "cancelScheduledSend": "Annuler l'envoi programmé",
      "pageInfo": "Page {{page}} sur {{totalPages}} ({{count}} messages)",
      "messageDetails": "Détails du message",
      "recipient": "Destinataire",
      "viewProspect": "Voir le prospect",
      "sender": "Expéditeur",
      "message": "Message",
      "template": "Modèle (Template)",
      "cancelReason": "Raison de l'annulation",
      "twilioSid": "ID Twilio (SID)",
      "scheduledFor": "Programmé pour"
    },
    "ownerDashboard": {
      "paymentSuccessTitle": "Paiement réussi !",
      "paymentSuccessDesc": "Votre abonnement a été mis à jour.",
      "paymentCancelTitle": "Paiement annulé",
      "paymentCancelDesc": "Aucune modification n'a été apportée à votre compte.",
      "inviteCreatedTitle": "Invitation créée",
      "inviteCreatedEmailFailedDesc": "L'invitation a été créée mais l'e-mail n'a pas pu être envoyé.",
      "inviteSentTitle": "Invitation envoyée",
      "inviteSentDesc": "Une invitation a été envoyée à {{email}}.",
      "userCreatedTitle": "Utilisateur créé",
      "userCreatedDesc": "{{name}} a été créé avec succès.",
      "bulkDeleteSuccessTitle": "Suppression réussie",
      "bulkDeleteCoachesDesc": "{{count}} utilisateurs ont été supprimés.",
      "bulkDeleteInvitationsDesc": "{{count}} invitations ont été supprimées.",
      "resendSuccessTitle": "Invitation renvoyée",
      "resendSuccessDesc": "L'invitation pour {{email}} a été renvoyée.",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "statusInvited": "Invité",
      "title": "Gestion de l'équipe",
      "subtitle": "Gérez vos coachs, suivez leur activité et leurs abonnements.",
      "addUser": "Ajouter un utilisateur",
      "inviteTab": "Inviter",
      "directCreateTab": "Création directe",
      "userEmailLabel": "Adresse e-mail",
      "sending": "Envoi en cours...",
      "sendInvitation": "Envoyer l'invitation",
      "userNameLabel": "Nom complet",
      "tempPasswordLabel": "Mot de passe temporaire",
      "creating": "Création...",
      "createAccount": "Créer le compte",
      "infoCard": "Informations",
      "totalUsers": "Utilisateurs totaux",
      "activeUsers": "Actifs",
      "pendingInvitations": "Invitations en attente",
      "usersTitle": "Utilisateurs",
      "refreshSubscriptions": "Actualiser les abonnements",
      "searchPlaceholder": "Rechercher par nom ou e-mail...",
      "statusFilter": "Statut",
      "allStatuses": "Tous les statuts",
      "profileFilter": "Profil",
      "allProfiles": "Tous les profils",
      "subscriptionFilter": "Abonnement",
      "allSubscriptions": "Tous",
      "subscribed": "Abonné",
      "noSubscription": "Sans abonnement",
      "selectedCount": "{{count}} utilisateur sélectionné",
      "deleteUsersTitle": "Supprimer les utilisateurs",
      "deleteUsersDesc": "Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés ? Cette action est irréversible.",
      "noUsersYet": "Aucun utilisateur pour le moment.",
      "noUsersMatchFilters": "Aucun utilisateur ne correspond à vos filtres.",
      "selectAll": "Tout sélectionner",
      "subAbbrev": "Abo.",
      "createdOn": "Créé le",
      "lastSignIn": "Dernière connexion",
      "selectRow": "Sélectionner la ligne",
      "subscribedUntil": "Abonné jusqu'au {{date}}",
      "noActiveSubscription": "Aucun abonnement actif",
      "deactivate": "Désactiver",
      "activate": "Activer",
      "invitationsTitle": "Invitations en attente",
      "selectedCountF": "{{count}} invitation sélectionnée",
      "deleteInvitationsTitle": "Supprimer les invitations",
      "deleteInvitationsDesc": "Êtes-vous sûr de vouloir supprimer les invitations sélectionnées ?",
      "sentOn": "Envoyée le",
      "expiresOn": "Expire le",
      "resendInvitationTitle": "Renvoyer l'invitation",
      "deleteInvitationTitle": "Supprimer l'invitation",
      "deleteInvitationDesc": "Êtes-vous sûr de vouloir supprimer cette invitation ?",
      "accessColumn": "Accès"
    },
    "ownerSettings": {
      "settingsSaved": "Paramètres enregistrés avec succès",
      "selectImage": "Veuillez sélectionner une image",
      "logoUpdated": "Logo mis à jour",
      "logoRemoved": "Logo supprimé",
      "stripeSaved": "Configuration Stripe enregistrée",
      "title": "Paramètres de la plateforme",
      "subtitle": "Gérez vos informations personnelles, votre entreprise et votre configuration de paiement.",
      "myProfile": "Mon Profil",
      "displayName": "Nom d'affichage",
      "myCompany": "Mon Entreprise",
      "logo": "Logo de l'entreprise",
      "change": "Modifier",
      "upload": "Télécharger",
      "companyName": "Nom de l'entreprise",
      "siret": "N° SIRET",
      "address": "Adresse du siège",
      "phone": "Téléphone professionnel",
      "website": "Site internet",
      "subscription": "Votre abonnement",
      "subscriptionDesc": "Votre abonnement est géré directement via notre plateforme de facturation sécurisée.",
      "stripeConfig": "Configuration Stripe",
      "stripeIntro": "Pour accepter des paiements, vous devez configurer vos clés Stripe. Retrouvez-les sur votre",
      "stripeDashboardLink": "tableau de bord Stripe",
      "secretKeyLabel": "Clé Secrète (Secret Key)",
      "configured": "Configuré",
      "notConfigured": "Non configuré",
      "secretKeyExplanation1": "Pour des raisons de sécurité, la clé secrète doit être définie comme un",
      "edgeFunctionSecret": "secret d'Edge Function",
      "secretKeyExplanation2": "dans Supabase.",
      "secretKeyExplanation3": "Veuillez créer un secret nommé",
      "secretKeyExplanation4": "avec votre clé API secrète Stripe.",
      "publicKeyLabel": "Clé Publique (Publishable Key)",
      "optional": "(Optionnel)",
      "priceIdLabel": "ID du Prix par défaut (Price ID)",
      "priceIdDesc": "L'ID du prix Stripe (ex: price_...) utilisé pour les nouveaux abonnements.",
      "update": "Mettre à jour",
      "security": "Sécurité & Accès",
      "securityDesc": "Les accès administrateurs sont restreints. Contactez le support pour toute modification des droits.",
      "saveChanges": "Enregistrer les modifications"
    }
  },
  "prospectDetail": {
    "backToClients": "Retour aux clients",
    "backToProspects": "Retour aux prospects",
    "notFound": "Prospect introuvable",
    "form": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "company": "Entreprise",
      "jobTitle": "Poste",
      "linkedin": "LinkedIn",
      "emailPlaceholder": "email@exemple.com",
      "phonePlaceholder": "+33 6 00 00 00 00",
      "linkedinPlaceholder": "https://linkedin.com/in/...",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "edit": "Modifier"
    },
    "viewExchangesInProvider": "Voir les échanges dans {{provider}}",
    "reactivateWhatsApp": "Réactiver WhatsApp",
    "whatsappOptOut": "Opt-out WhatsApp",
    "twitterX": "Twitter / X",
    "addedByPrefix": "· par {{name}}",
    "client": "Client",
    "emailDirect": "Email direct",
    "call": "Appeler",
    "sendWhatsApp": "Envoyer WhatsApp",
    "linkedin": "LinkedIn",
    "confirmOptOutTitle": "Marquer ce prospect en opt-out WhatsApp ?",
    "confirmOptOutDescription": "{{name}} ne recevra plus de messages WhatsApp. Vous pourrez le réactiver à tout moment depuis ce menu.",
    "confirmOptOut": "Confirmer l'opt-out",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer ce prospect ?",
    "deleteDescription": "{{name}} sera définitivement supprimé, ainsi que ses emails et inscriptions liés. Cette action est irréversible.",
    "cancel": "Annuler",
    "proposeMeeting": "Proposer un RDV",
    "proposeMeetingShort": "RDV",
    "addEmailToPropose": "Ajoutez un email au prospect",
    "proposeMeetingTitle": "Proposer un rendez-vous",
    "chooseDuration": "Choisir une durée",
    "duration60": "1 heure",
    "duration90": "1 h 30",
    "durationMinutes": "{{count}} minutes",
    "emailAi": "Email IA",
    "sendWhatsAppTitle": "Envoyer un message WhatsApp",
    "tabs": {
      "fiche": "Fiche",
      "activity": "Activité",
      "tasks": "Tâches",
      "notes": "Notes",
      "documents": "Docs",
      "exchanges": "Échanges",
      "infos": "Infos",
      "overview": "Vue d'ensemble",
      "emails": "Emails",
      "analyses": "Analyses IA"
    },
    "tasksTitle": "Tâches du prospect",
    "contactInfo": "Informations de contact",
    "changeStatus": "Changer le statut",
    "statusShort": {
      "discussion": "Discussion"
    },
    "tagsLabel": "Tags",
    "addTag": "Ajouter un tag",
    "addTagPlaceholder": "Ajouter un tag…",
    "noTag": "Aucun tag",
    "linkedEvents": "Événements liés",
    "registered": "Inscrit",
    "bio": "Bio",
    "companyDescription": "Description entreprise",
    "foundedIn": "· Fondée en {{year}}",
    "onlineActivity": "Analyse d'activité en ligne",
    "interestThemes": "Thèmes d'intérêt",
    "publishedArticles": "Articles publiés",
    "personalSite": "Site personnel",
    "linkedinActivity": "Activité LinkedIn",
    "relevanceAi": "Pertinence IA",
    "sentEmails": "{{count}} emails envoyés",
    "sentEmails_one": "{{count}} email envoyé",
    "sentEmails_other": "{{count}} emails envoyés",
    "noSubject": "(Sans objet)",
    "noContent": "Aucun contenu",
    "importedNotes": "Notes importées",
    "scoreBadge": "Score {{score}}%",
    "moreActions": "Plus d'actions",
    "latestExchanges": "Derniers échanges",
    "noMailboxConnected": "Aucune messagerie connectée"
  },
  "chatQuestionnaire": {
    "title": "Quelques précisions",
    "progress": "Question {{current}} / {{total}}",
    "previous": "Précédent",
    "next": "Suivant",
    "skip": "Passer",
    "send": "Envoyer",
    "placeholder": "Ta réponse…",
    "otherPlaceholder": "Autre réponse (facultatif)…",
    "noAnswer": "(non renseigné)",
    "multiHint": "Plusieurs choix possibles",
    "recapHeader": "Voici mes réponses :"
  },
  "pricing": {
    "title": "Vous payez ce que l'agent produit, pas un siège par mois",
    "subtitle": "Un CRM classique facture chaque utilisateur chaque mois, y compris les mois où personne ne prospecte. Thiia s'achète par pack de onze types de crédits métier, consommés au rythme de vos clients.",
    "pillNoSubscription": "Aucun abonnement",
    "pillNoSeat": "Aucun coût par utilisateur",
    "pillNoExpiry": "Crédits sans expiration",
    "priceSuffix": "€ — une fois",
    "buy": "Acheter ce pack",
    "showAll": "Voir les onze compteurs",
    "hideAll": "Masquer les onze compteurs",
    "unitMin": "min",
    "groupProspecting": "Prospection",
    "groupRelation": "Relation client",
    "groupDigital": "Communication digitale",
    "quotaSearches": "Recherches",
    "quotaWatches": "Veille automatique",
    "quotaReports": "Rapports",
    "quotaAnalyses": "Analyses",
    "quotaChat": "Questions au chat",
    "quotaNewsletters": "Newsletters",
    "quotaChecklists": "Checklists",
    "quotaTranscription": "Transcription",
    "quotaPublications": "Publications",
    "quotaDocuments": "Documents",
    "quotaImages": "Images générées",
    "packStarterName": "Pack Starter",
    "packStarterTarget": "Pour tester l'agent sur une première campagne, sans engagement",
    "packProName": "Pack Pro",
    "packProTarget": "Le rythme d'un indépendant qui prospecte toutes les semaines",
    "packProBadge": "Populaire",
    "packEnterpriseName": "Pack Enterprise",
    "packEnterpriseTarget": "Cabinet ou équipe qui traite un portefeuille partagé en continu",
    "topupTitle": "Recharger à la carte, quand vous en avez besoin",
    "topupIntro": "Un compteur à sec ne vous oblige pas à racheter un pack entier : chaque crédit se recharge séparément, au compteur près. Consulter, trier, relire et organiser ne consomme rien.",
    "topupClosing": "Les crédits restent acquis : aucune remise à zéro en fin de mois.",
    "topupSearches": "40 recherches",
    "topupWatches": "60 veilles automatiques",
    "topupReports": "20 rapports",
    "topupAnalyses": "20 analyses",
    "topupChat": "100 questions au chat",
    "topupNewsletters": "10 newsletters",
    "topupChecklists": "40 checklists",
    "topupTranscription": "480 min de transcription",
    "topupPublications": "25 publications",
    "topupDocuments": "50 documents",
    "topupImages": "20 images générées",
    "trustFreeCredits": "Crédits offerts à l'inscription",
    "trustNoRecurring": "Aucun prélèvement récurrent",
    "trustNoExpiry": "Crédits sans expiration",
    "trustFrance": "Données hébergées en France",
    "teaserTitle": "Des packs de crédits, achetés une fois",
    "teaserSubtitle": "Onze compteurs métier, consommés à votre rythme. Aucun abonnement, aucun coût par utilisateur.",
    "teaserLink": "Voir le détail des packs",
    "teaserStarterHighlight": "30 recherches de prospects",
    "teaserProHighlight": "500 questions au chat",
    "teaserEnterpriseHighlight": "150 recherches de prospects"
  },
  "faq": {
    "title": "Questions fréquentes",
    "q1": "Pourquoi pas d'abonnement mensuel ?",
    "a1": "Parce qu'un abonnement vous facture aussi les mois où vous ne prospectez pas. Avec Thiia, vous achetez un pack de crédits une fois et vous le consommez au rythme de votre activité, sans prélèvement automatique ni engagement de durée.",
    "q2": "Que se passe-t-il quand un compteur est épuisé ?",
    "a2": "Seules les actions liées à ce compteur sont mises en pause : les dix autres continuent de fonctionner. Vous rechargez ce compteur seul, à la carte, sans racheter un pack entier.",
    "q3": "Les crédits expirent-ils ?",
    "a3": "Non. Vos crédits restent acquis aussi longtemps que votre compte est actif : aucune remise à zéro en fin de mois, aucune date limite d'utilisation.",
    "q4": "Quelles actions ne consomment aucun crédit ?",
    "a4": "Consulter, trier, relire et organiser sont gratuits et illimités : fiches prospects, kanban, calendrier, emails reçus, documents déjà générés. Seules les actions produites par l'agent consomment un crédit.",
    "q5": "Puis-je partager mes crédits avec mon équipe ?",
    "a5": "Oui. Les crédits sont rattachés à l'organisation : tous les collaborateurs invités puisent dans le même pot commun, sans coût supplémentaire par utilisateur, avec un historique par personne.",
    "q6": "Comment payer et récupérer ma facture ?",
    "a6": "Le paiement est sécurisé par Stripe (carte bancaire, Apple Pay, Google Pay). Les crédits sont ajoutés instantanément et une facture KREAPP SAS vous est envoyée par email."
  },
  "docs": {
    "title": "Documentation",
    "contact": "Nous contacter",
    "openApp": "Ouvrir THIIA",
    "openMenu": "Ouvrir le sommaire",
    "onThisPage": "Sur cette page",
    "previous": "Précédent",
    "next": "Suivant",
    "backToIndex": "Retour à la documentation",
    "search": {
      "placeholder": "Rechercher dans la documentation",
      "empty": "Aucun article ne correspond."
    },
    "helpful": {
      "question": "Cette page vous a-t-elle aidé ?",
      "yes": "Oui",
      "no": "Non"
    },
    "notFound": {
      "title": "Article introuvable",
      "body": "Cette page de documentation n'existe pas ou a été déplacée."
    },
    "index": {
      "title": "Documentation THIIA",
      "subtitle": "Tout ce que fait l'agent, expliqué article par article."
    },
    "groups": {
      "start": {
        "label": "Démarrer",
        "summary": "Premiers pas, conversation avec l'agent, réglages et intégrations."
      },
      "prospection": {
        "label": "Prospection",
        "summary": "Trouver des contacts, les qualifier et suivre vos annotations."
      },
      "relation": {
        "label": "Relation client",
        "summary": "Emails, événements, tâches, documents et suivi de votre énergie."
      },
      "communication": {
        "label": "Communication digitale",
        "summary": "Préparer et publier vos contenus."
      },
      "billing": {
        "label": "Crédits et facturation",
        "summary": "Consommation des crédits, conformité et sécurité."
      }
    },
    "cost": {
      "label": "Coût",
      "recherche": {
        "rule": "Chaque recherche lancée consomme un crédit de recherche.",
        "free": "Consulter et trier des résultats déjà obtenus reste gratuit."
      },
      "prospects": {
        "rule": "Chaque analyse d'un prospect par l'agent consomme un crédit d'analyse.",
        "free": "Créer, modifier et classer une fiche reste gratuit."
      },
      "emails": {
        "rule": "Chaque email rédigé par l'agent consomme un crédit de rédaction.",
        "free": "Lire, modifier et envoyer un email déjà rédigé reste gratuit."
      },
      "contenu": {
        "rule": "Chaque contenu généré par l'agent consomme un crédit de contenu.",
        "free": "Modifier, planifier et publier un contenu reste gratuit."
      },
      "credits": {
        "rule": "Les crédits s'achètent par packs, une seule fois, et n'expirent pas.",
        "free": "Consulter vos compteurs est gratuit."
      }
    },
    "example": {
      "label": "Exemple",
      "counter": "1 recherche utilisée",
      "recherche": {
        "question": "Trouve-moi des dirigeants de PME industrielles en Occitanie.",
        "answer": "J'ai trouvé 7 profils correspondants. Voulez-vous que je les ajoute à vos prospects ?"
      }
    },
    "warning": {
      "credits": "Un crédit consommé n'est pas restitué, même si le résultat ne vous convient pas : affinez votre demande avant de la relancer.",
      "rgpd": "Vous restez responsable des données que vous saisissez : vérifiez votre base légale avant toute prospection."
    }
  },
  "topbar": {
    "searchPlaceholder": "Rechercher un prospect, un email, un événement…",
    "accountMenu": "Menu du compte"
  },
  "globalSearch": {
    "title": "Recherche globale",
    "placeholder": "Rechercher un prospect, un email, un événement…",
    "hint": "Saisissez au moins deux caractères pour lancer la recherche.",
    "empty": "Aucun résultat pour « {{query}} »",
    "footer": "↑↓ naviguer · ↵ ouvrir · ⌘↵ nouvel onglet",
    "groups": {
      "prospects": "Prospects",
      "emails": "Emails",
      "events": "Événements",
      "tasks": "Tâches",
      "documents": "Documents"
    }
  },
  "ownerNav": {
    "subtitle": "Administration",
    "backToWorkspace": "Revenir à mon espace",
    "users": "Gestion des utilisateurs",
    "aiUsage": "Consommation IA",
    "metrics": "Métriques & erreurs",
    "seo": "SEO & Indexation",
    "branding": "Personnalisation",
    "pricing": "Tarifs & Crédits",
    "emailTemplates": "Templates d'emails",
    "security": "Sécurité & Incidents",
    "eval": "Évaluation du chat",
    "voiceAgent": "Agent vocal",
    "announcements": "Nouveautés",
    "settings": "Paramètres"
  },
  "receipts": {
    "pendingCount": "{{count}} justificatif en attente",
    "pendingCount_one": "{{count}} justificatif en attente",
    "pendingCount_other": "{{count}} justificatifs en attente",
    "allOrganizations": "Toutes les organisations",
    "tabs": {
      "queue": "À traiter",
      "rules": "Règles fournisseurs",
      "connections": "Connexions",
      "log": "Journal"
    },
    "queue": {
      "scan": "Lancer un passage",
      "period": "Période",
      "periodDays": "{{count}} derniers jours",
      "periodYear": "12 derniers mois",
      "periodTwoYears": "24 derniers mois",
      "periodCustom": "Période personnalisée",
      "periodFrom": "Du",
      "periodTo": "Au",
      "scanDone": "Passage terminé",
      "scanSummary": "{{pending}} transaction(s) sans justificatif, {{created}} ajoutée(s) à la file.",
      "empty": "Aucune transaction en attente de justificatif.",
      "upload": "Déposer un PDF",
      "attached": "Justificatif attaché à la transaction.",
      "searchPlaceholder": "Fournisseur, montant, référence…",
      "noResults": "Aucune transaction ne correspond à cette recherche.",
      "count": "{{count}} transaction(s)",
      "sort": {
        "dateDesc": "Date (plus récentes)",
        "dateAsc": "Date (plus anciennes)",
        "amountDesc": "Montant (décroissant)",
        "amountAsc": "Montant (croissant)",
        "labelAsc": "Libellé (A-Z)",
        "labelDesc": "Libellé (Z-A)"
      },
      "filter": {
        "all": "Tous",
        "ready": "Prêts",
        "choose": "À choisir",
        "none": "Sans pièce"
      },
      "group": {
        "ready": "Prêts à valider",
        "choose": "À choisir",
        "none": "Sans justificatif"
      },
      "summaryOne": "1 facture, montant exact",
      "summaryMany": "{{count}} candidats",
      "summaryNone": "rien trouvé",
      "shortcuts": "J K naviguer · ↵ valider · X rejeter · U déposer",
      "validateAll": "Tout valider",
      "side": {
        "debit": "Sorties",
        "credit": "Entrées"
      }
    },
    "reason": {
      "new_vendor": "Nouveau fournisseur",
      "no_invoice": "Aucune facture trouvée",
      "amount_mismatch": "Écart de montant",
      "multiple_candidates": "Plusieurs factures"
    },
    "connector": {
      "outlook": "Outlook",
      "ovh": "OVH",
      "manual": "Dépôt manuel",
      "amazon": "Amazon Business",
      "qonto": "Qonto"
    },
    "mode": {
      "auto": "Automatique",
      "manual": "Validé à la main"
    },
    "rules": {
      "pattern": "Motif du libellé",
      "vendor": "Fournisseur",
      "connector": "Connecteur",
      "add": "Ajouter",
      "empty": "Aucune règle fournisseur pour le moment."
    },
    "connections": {
      "connected": "Connecté",
      "disconnected": "Non connecté",
      "connect": "Connecter",
      "disconnect": "Déconnecter",
      "qontoLogin": "Identifiant Qonto",
      "qontoSecret": "Clé secrète",
      "securityNote": "Vos identifiants sont conservés côté serveur et ne sont jamais lisibles depuis le navigateur.",
      "manageInSettings": "Gérer dans Intégrations"
    },
    "log": {
      "empty": "Aucun attachement enregistré."
    },
    "search": {
      "searchAll": "Chercher les factures",
      "searchOne": "Chercher la facture",
      "stop": "Arrêter",
      "done": "Recherche terminée",
      "foundCount": "{{count}} facture(s) trouvée(s)",
      "noMailbox": "Aucune boîte mail connectée pour cette organisation.",
      "failed": "Aucune facture trouvée dans vos boîtes mail",
      "preview": "Aperçu",
      "validate": "Valider et attacher",
      "dismiss": "Écarter",
      "openLink": "Ouvrir le lien",
      "nothingFound": "Aucune facture trouvée dans les boîtes interrogées",
      "runDone": "Passage terminé",
      "runFound": "{{count}} facture(s) trouvée(s)",
      "reportSummary": "{{mailboxes}} boîte(s) interrogée(s) · {{emails}} email(s) · {{pdfs}} PDF",
      "searchEverywhere": "Chercher partout",
      "searchWide": "Recherche élargie",
      "amazonError": "Amazon Business : {{error}}",
      "reportWindow": "fenêtre −{{before}} j / +{{after}} j"
    },
    "band": {
      "qontoSynced": "Qonto · synchro {{ago}}",
      "qontoDisconnected": "Qonto déconnecté · Reconnecter",
      "syncMinutes": "il y a {{count}} min",
      "syncHours": "il y a {{count}} h",
      "syncDays": "il y a {{count}} j",
      "syncNever": "jamais synchronisé",
      "searchEmails": "Rechercher dans les emails"
    },
    "detail": {
      "debitedOn": "Débitée le {{date}} · {{account}}"
    },
    "match": {
      "best": "Meilleure correspondance",
      "receivedOn": "reçue par email le {{date}}",
      "kindInvoice": "facture",
      "kindReceipt": "reçu du même paiement",
      "criteriaAmount": "Montant identique",
      "criteriaVendor": "Fournisseur reconnu",
      "criteriaDate": "Date la plus proche",
      "sameDay": "le jour même",
      "daysBefore": "{{count}} jours avant",
      "daysAfter": "{{count}} jours après",
      "gap": "écart {{count}} j",
      "others": "Autres candidats",
      "choose": "Choisir",
      "hiddenDuplicate": "Doublon masqué : {{name}}, aussi transféré par email",
      "ignoredStatements": "{{count}} relevés ignorés",
      "attachFile": "Attacher le fichier",
      "attachFiles": "Attacher les {{count}} fichiers",
      "notThisOne": "Pas celui-ci",
      "autoRule": "Attacher automatiquement les prochaines factures {{vendor}}"
    },
    "bulkValidate": {
      "title": "Attacher {{count}} justificatifs ?",
      "confirm": "Attacher"
    },
    "empty": {
      "title": "Aucune facture trouvée dans vos emails",
      "searched": "Recherche effectuée sur −{{before}} j / +{{after}} j autour du débit, pour un montant de {{amount}}",
      "dropHere": "Glissez le PDF ici",
      "or": "ou",
      "choose": "Choisir un fichier",
      "vendorAccount": "Télécharger depuis le compte {{vendor}}",
      "orderRef": "Référence de commande : {{ref}}",
      "noOrderRef": "Aucune référence de commande dans le libellé bancaire",
      "footerQuestion": "Pas de facture attendue ?",
      "markNone": "Marquer sans justificatif",
      "snooze": "Reporter à demain"
    },
    "instructions": {
      "title": "Instructions du moteur",
      "hint": "Écrivez en langage naturel ce que le moteur doit chercher ou ignorer. Ces instructions s'ajoutent aux règles fournisseurs, qui restent prioritaires.",
      "placeholder": "Les factures Lovable arrivent de billing@lovable.dev, jamais de reçus Stripe. Ignore tout ce qui vient de mon comptable.",
      "save": "Enregistrer les instructions",
      "reinterpret": "Réinterpréter",
      "saved": "Instructions enregistrées",
      "saveError": "Enregistrement impossible",
      "interpretError": "Le texte est enregistré, mais son interprétation a échoué. Réessayez avec « Réinterpréter ».",
      "understood": "Ce que le moteur applique",
      "includeTerms": "À chercher :",
      "trustedSenders": "Expéditeurs de confiance :",
      "excludeTerms": "À écarter :",
      "excludeSenders": "Expéditeurs ignorés :",
      "window": "Fenêtre souhaitée : {{before}} j avant / {{after}} j après",
      "noCriteria": "Aucun critère pour l'instant.",
      "matches": "Correspond à vos instructions",
      "guide": "Guider la recherche",
      "guideTitle": "Aider la prochaine recherche",
      "guideHint": "Expliquez ce qui ne va pas ou comment reconnaître le bon document. La consigne est ajoutée à vos instructions puis la recherche est relancée.",
      "guidePlaceholder": "Ex. : ignorer les liens url2820.qonto.com, prendre uniquement le PDF joint",
      "guideSuggestions": "Suggestions",
      "sugPdf": "Prendre uniquement une facture PDF jointe, ignorer les liens de suivi",
      "sugExcludeDomain": "Ignorer les liens du domaine {{domain}}",
      "sugTrust": "Faire confiance à l'expéditeur {{sender}}",
      "sugIgnoreSender": "Ignorer l'expéditeur {{sender}}",
      "guideSubmit": "Enregistrer et relancer",
      "guideCancel": "Annuler",
      "dismissAndGuide": "Écarter et guider"
    }
  },
  "voice": {
    "wake": {
      "standby": "Dites « Hey Thiia »",
      "off": "Écoute coupée — cliquez pour réactiver",
      "unsupported": "Cliquez pour parler à Thiia",
      "blocked": "Micro bloqué — autorisez-le dans le navigateur",
      "otherTab": "Thiia écoute dans un autre onglet",
      "expand": "Agrandir la conversation",
      "minimize": "Réduire et continuer",
      "connecting": "Connexion…",
      "timeout": "La connexion vocale n'a pas abouti. Réessayez.",
      "speaking": "Thiia parle…",
      "listening": "Je vous écoute",
      "error": "Erreur",
      "ready": "Prête",
      "end": "Terminer la conversation",
      "settingsTitle": "Écoute « Hey Thiia »",
      "settingsHint": "Thiia écoute sur toutes les pages et démarre la conversation vocale quand vous dites « Hey Thiia ». La détection se fait sur votre appareil.",
      "settingsToggle": "Toujours à l'écoute quand l'application est ouverte"
    }
  },
  "chatPending": {
    "analyzing": "Thiia analyse votre demande",
    "gathering": "Recherche et synthèse des informations",
    "composing": "Formulation de la réponse",
    "detailed": "Rédaction d'une réponse détaillée",
    "elapsed": "{{s}} s"
  },
  "exportPreview": {
    "refine": {
      "title": "Nouvelles instructions pour une nouvelle version",
      "placeholder": "Ex. : raccourcis la partie budget, ajoute une section prochaines étapes…",
      "apply": "Générer une nouvelle version",
      "applying": "Génération…",
      "save": "Enregistrer dans la note",
      "saved": "Nouvelle version enregistrée",
      "undo": "Revenir à la version précédente",
      "error": "Impossible de générer la nouvelle version"
    }
  },
  "noSubCrm": {
    "badge": "Sans abonnement",
    "h1": "Le CRM sans abonnement pour indépendants",
    "h1Accent": "et petites structures",
    "subtitle": "Trouvez vos clients, préparez vos relances et suivez vos contacts. Vous achetez un pack de crédits une seule fois et vous l'utilisez à votre rythme.",
    "ctaPrimary": "Créer mon compte",
    "ctaSecondary": "Voir les tarifs",
    "whyTitle": "Pourquoi payer chaque mois un outil que vous utilisez peu ?",
    "why1Title": "Vous payez à l'usage",
    "why1Body": "Pas de facture mensuelle qui tombe même les mois calmes. Vos crédits servent quand vous en avez besoin.",
    "why2Title": "Un seul outil au lieu de cinq",
    "why2Body": "Contacts, emails, recherche de prospects, agenda et justificatifs réunis au même endroit.",
    "why3Title": "Prospecter sans être commercial",
    "why3Body": "Thiia propose des prospects et prépare des messages personnalisés, jamais des envois de masse.",
    "why4Title": "Vos données restent en Europe",
    "why4Body": "Hébergement européen et respect du RGPD dès le départ : consentement et désinscription inclus.",
    "compareTitle": "Abonnement classique ou packs de crédits",
    "compareFeature": "Critère",
    "compareSub": "CRM par abonnement",
    "compareThiia": "Thiia",
    "rows": [
      {
        "feature": "Paiement",
        "sub": "Chaque mois, par utilisateur",
        "thiia": "Pack acheté une fois : 29, 59 ou 99 €"
      },
      {
        "feature": "Mois sans activité",
        "sub": "Facturés quand même",
        "thiia": "Rien à payer"
      },
      {
        "feature": "Engagement",
        "sub": "Souvent annuel",
        "thiia": "Aucun"
      },
      {
        "feature": "Recherche de prospects",
        "sub": "Module en option",
        "thiia": "Incluse"
      },
      {
        "feature": "Prise en main",
        "sub": "Pensée pour des équipes",
        "thiia": "Pensée pour une personne seule"
      }
    ],
    "stepsTitle": "Démarrer en trois étapes",
    "step1Title": "Créez votre compte",
    "step1Body": "Une adresse email suffit. Vous découvrez l'espace tout de suite.",
    "step2Title": "Présentez votre activité",
    "step2Body": "Thiia vous pose quelques questions pour comprendre vos clients idéaux.",
    "step3Title": "Recevez vos premiers prospects",
    "step3Body": "Choisissez un pack quand vous voulez aller plus loin, sans engagement.",
    "testimonialsTitle": "Ils l'utilisent au quotidien",
    "faqTitle": "Questions fréquentes",
    "faq": [
      {
        "q": "Thiia est-il vraiment sans abonnement ?",
        "a": "Oui. Vous achetez un pack de crédits à 29, 59 ou 99 €, une seule fois. Il n'y a ni prélèvement mensuel ni engagement."
      },
      {
        "q": "Que se passe-t-il quand mes crédits sont épuisés ?",
        "a": "Vous gardez accès à vos contacts et à vos données. Vous rachetez un pack seulement si vous voulez continuer à utiliser les fonctions qui consomment des crédits."
      },
      {
        "q": "Thiia convient-il si je travaille seul ?",
        "a": "C'est précisément pour ça qu'il a été conçu : indépendants, coachs, consultants et dirigeants de petites structures."
      },
      {
        "q": "Faut-il savoir prospecter pour l'utiliser ?",
        "a": "Non. Thiia propose des prospects adaptés à votre activité et prépare des messages personnalisés que vous relisez avant envoi."
      },
      {
        "q": "Mes données sont-elles protégées ?",
        "a": "Elles sont hébergées en Europe. Un consentement est demandé avant d'ajouter un contact ou d'envoyer un email, et chaque email contient un lien de désinscription."
      },
      {
        "q": "Puis-je importer mes contacts actuels ?",
        "a": "Oui, par import de fichier ou en connectant votre boîte Gmail ou Outlook."
      }
    ],
    "finalTitle": "Prêt à trouver vos prochains clients ?",
    "finalBody": "Créez votre compte et choisissez un pack seulement quand vous en avez besoin.",
    "breadcrumb": "CRM sans abonnement",
    "footerLink": "CRM sans abonnement",
    "pricingLinkText": "Vous cherchez un CRM sans engagement mensuel ?",
    "pricingLinkCta": "Découvrir notre approche sans abonnement"
  },
  "tpeParis": {
    "breadcrumb": "CRM pour dirigeants de TPE à Paris",
    "footerLink": "CRM TPE Paris & Île-de-France",
    "badge": "Paris & Île-de-France",
    "h1": "Le CRM des entrepreneurs et dirigeants de TPE",
    "h1Accent": "à Paris et en Île-de-France",
    "subtitle": "Vous dirigez seul ou avec une petite équipe ? Thiia trouve des entreprises franciliennes à contacter, prépare vos relances et range vos justificatifs. Sans abonnement : un pack de crédits acheté une fois.",
    "ctaPrimary": "Créer mon compte",
    "ctaSecondary": "Voir les tarifs",
    "whyTitle": "Pensé pour le quotidien d'un dirigeant francilien",
    "why1Title": "Des prospects près de chez vous",
    "why1Body": "Recherchez des entreprises par ville ou département (Paris, Hauts-de-Seine, Seine-Saint-Denis, Val-de-Marne…), vérifiées dans les registres officiels français.",
    "why2Title": "Vos rendez-vous et événements",
    "why2Body": "Salons, meetups, Station F : ajoutez les événements où vous allez et préparez vos rencontres dans un même agenda.",
    "why3Title": "Justificatifs Qonto rattachés",
    "why3Body": "Thiia retrouve vos factures fournisseurs dans vos emails et vous propose de les rattacher à vos transactions Qonto, après votre validation.",
    "why4Title": "Une IA française, des données en Europe",
    "why4Body": "IA souveraine française, hébergement européen et RGPD respecté : consentement et désinscription inclus.",
    "profilesTitle": "Pour qui ?",
    "profiles": [
      {
        "title": "Dirigeants de TPE",
        "body": "Agences, cabinets, sociétés de services de 1 à 10 personnes qui gèrent eux-mêmes leur développement commercial."
      },
      {
        "title": "Indépendants et freelances",
        "body": "Consultants, développeurs, designers, formateurs installés à Paris ou en petite couronne."
      },
      {
        "title": "Coachs et accompagnants",
        "body": "Coachs, thérapeutes et conseillers qui veulent trouver des clients sans démarchage agressif."
      }
    ],
    "stepsTitle": "Démarrer en trois étapes",
    "step1Title": "Créez votre compte",
    "step1Body": "Une adresse email suffit.",
    "step2Title": "Décrivez vos clients idéaux",
    "step2Body": "Secteur, taille, zone : Paris, petite couronne ou toute l'Île-de-France.",
    "step3Title": "Recevez vos premiers prospects",
    "step3Body": "Choisissez un pack de 29, 59 ou 99 € quand vous voulez aller plus loin.",
    "faqTitle": "Questions fréquentes",
    "faq": [
      {
        "q": "Puis-je cibler uniquement des entreprises d'Île-de-France ?",
        "a": "Oui. Vous indiquez la zone voulue (une ville, un département ou toute la région) et Thiia limite ses propositions à ces entreprises."
      },
      {
        "q": "Thiia est-il sans abonnement ?",
        "a": "Oui. Vous achetez un pack de crédits à 29, 59 ou 99 €, une seule fois, sans prélèvement mensuel ni engagement."
      },
      {
        "q": "Fonctionne-t-il avec Qonto ?",
        "a": "Oui. Thiia lit vos transactions Qonto et vous propose les factures correspondantes trouvées dans vos emails. Rien n'est rattaché sans votre validation."
      },
      {
        "q": "Mes données sont-elles protégées ?",
        "a": "Vos données sont hébergées en Europe, l'IA utilisée est française et ne s'entraîne pas sur vos données."
      }
    ],
    "finalTitle": "Développez votre entreprise francilienne sans abonnement",
    "finalBody": "Créez votre compte et découvrez vos premiers prospects en quelques minutes."
  }
}
